/* tslint:disable */
/* eslint-disable */
/**
 * Takaro app-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * Contact: support@takaro.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, } from './common.js';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base.js';
export const ActivityInputDTOTimeTypeEnum = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly',
};
export const ActivityInputDTODataTypeEnum = {
    Users: 'users',
    Players: 'players',
};
export const BanSearchInputDTOExtendEnum = {
    Player: 'player',
    GameServer: 'gameServer',
};
export const BanSearchInputDTOSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc',
};
export const CommandSearchInputDTOExtendEnum = {
    Module: 'module',
    GameServer: 'gameServer',
    Permissions: 'permissions',
};
export const CommandSearchInputDTOSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc',
};
export const CronJobSearchInputDTOExtendEnum = {
    Module: 'module',
    GameServer: 'gameServer',
};
export const CronJobSearchInputDTOSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc',
};
export const DomainCreateInputDTOStateEnum = {
    Active: 'ACTIVE',
    Disabled: 'DISABLED',
    Maintenance: 'MAINTENANCE',
    Deleted: 'DELETED',
};
export const DomainOutputDTOStateEnum = {
    Active: 'ACTIVE',
    Disabled: 'DISABLED',
    Maintenance: 'MAINTENANCE',
    Deleted: 'DELETED',
};
export const DomainSearchInputAllowedFiltersStateEnum = {
    Active: 'ACTIVE',
    Disabled: 'DISABLED',
    Maintenance: 'MAINTENANCE',
    Deleted: 'DELETED',
};
export const DomainSearchInputDTOSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc',
};
export const DomainUpdateInputDTOStateEnum = {
    Active: 'ACTIVE',
    Disabled: 'DISABLED',
    Maintenance: 'MAINTENANCE',
    Deleted: 'DELETED',
};
export const EntityCreateDTOTypeEnum = {
    Hostile: 'hostile',
    Friendly: 'friendly',
    Neutral: 'neutral',
};
export const EntityOutputDTOTypeEnum = {
    Hostile: 'hostile',
    Friendly: 'friendly',
    Neutral: 'neutral',
};
export const EntitySearchInputAllowedFiltersTypeEnum = {
    Hostile: 'hostile',
    Friendly: 'friendly',
    Neutral: 'neutral',
};
export const EntitySearchInputDTOSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc',
};
export const EntityUpdateDTOTypeEnum = {
    Hostile: 'hostile',
    Friendly: 'friendly',
    Neutral: 'neutral',
};
export const EventChatMessageChannelEnum = {
    Global: 'global',
    Team: 'team',
    Friends: 'friends',
    Whisper: 'whisper',
};
export const EventCreateDTOEventNameEnum = {
    RoleAssigned: 'role-assigned',
    RoleRemoved: 'role-removed',
    RoleCreated: 'role-created',
    RoleUpdated: 'role-updated',
    RoleDeleted: 'role-deleted',
    CommandExecuted: 'command-executed',
    CommandExecutionDenied: 'command-execution-denied',
    HookExecuted: 'hook-executed',
    CronjobExecuted: 'cronjob-executed',
    CurrencyAdded: 'currency-added',
    CurrencyDeducted: 'currency-deducted',
    CurrencyResetAll: 'currency-reset-all',
    SettingsSet: 'settings-set',
    PlayerNewIpDetected: 'player-new-ip-detected',
    PlayerNewNameDetected: 'player-new-name-detected',
    ServerStatusChanged: 'server-status-changed',
    ModuleCreated: 'module-created',
    ModuleUpdated: 'module-updated',
    ModuleDeleted: 'module-deleted',
    ModuleInstalled: 'module-installed',
    ModuleUninstalled: 'module-uninstalled',
    PlayerCreated: 'player-created',
    ShopListingCreated: 'shop-listing-created',
    ShopListingUpdated: 'shop-listing-updated',
    ShopListingDeleted: 'shop-listing-deleted',
    ShopOrderCreated: 'shop-order-created',
    ShopOrderStatusChanged: 'shop-order-status-changed',
    ShopOrderDeliveryFailed: 'shop-order-delivery-failed',
    PlayerLinked: 'player-linked',
    GameserverCreated: 'gameserver-created',
    GameserverUpdated: 'gameserver-updated',
    GameserverDeleted: 'gameserver-deleted',
    PlayerBanned: 'player-banned',
    PlayerUnbanned: 'player-unbanned',
    PlayerDeleted: 'player-deleted',
    PlayerConnected: 'player-connected',
    PlayerDisconnected: 'player-disconnected',
    ChatMessage: 'chat-message',
    PlayerDeath: 'player-death',
    EntityKilled: 'entity-killed',
};
export const EventOutputDTOEventNameEnum = {
    RoleAssigned: 'role-assigned',
    RoleRemoved: 'role-removed',
    RoleCreated: 'role-created',
    RoleUpdated: 'role-updated',
    RoleDeleted: 'role-deleted',
    CommandExecuted: 'command-executed',
    CommandExecutionDenied: 'command-execution-denied',
    HookExecuted: 'hook-executed',
    CronjobExecuted: 'cronjob-executed',
    CurrencyAdded: 'currency-added',
    CurrencyDeducted: 'currency-deducted',
    CurrencyResetAll: 'currency-reset-all',
    SettingsSet: 'settings-set',
    PlayerNewIpDetected: 'player-new-ip-detected',
    PlayerNewNameDetected: 'player-new-name-detected',
    ServerStatusChanged: 'server-status-changed',
    ModuleCreated: 'module-created',
    ModuleUpdated: 'module-updated',
    ModuleDeleted: 'module-deleted',
    ModuleInstalled: 'module-installed',
    ModuleUninstalled: 'module-uninstalled',
    PlayerCreated: 'player-created',
    ShopListingCreated: 'shop-listing-created',
    ShopListingUpdated: 'shop-listing-updated',
    ShopListingDeleted: 'shop-listing-deleted',
    ShopOrderCreated: 'shop-order-created',
    ShopOrderStatusChanged: 'shop-order-status-changed',
    ShopOrderDeliveryFailed: 'shop-order-delivery-failed',
    PlayerLinked: 'player-linked',
    GameserverCreated: 'gameserver-created',
    GameserverUpdated: 'gameserver-updated',
    GameserverDeleted: 'gameserver-deleted',
    PlayerBanned: 'player-banned',
    PlayerUnbanned: 'player-unbanned',
    PlayerDeleted: 'player-deleted',
    PlayerConnected: 'player-connected',
    PlayerDisconnected: 'player-disconnected',
    ChatMessage: 'chat-message',
    PlayerDeath: 'player-death',
    EntityKilled: 'entity-killed',
};
export const EventSearchInputAllowedFiltersEventNameEnum = {
    RoleAssigned: 'role-assigned',
    RoleRemoved: 'role-removed',
    RoleCreated: 'role-created',
    RoleUpdated: 'role-updated',
    RoleDeleted: 'role-deleted',
    CommandExecuted: 'command-executed',
    CommandExecutionDenied: 'command-execution-denied',
    HookExecuted: 'hook-executed',
    CronjobExecuted: 'cronjob-executed',
    CurrencyAdded: 'currency-added',
    CurrencyDeducted: 'currency-deducted',
    CurrencyResetAll: 'currency-reset-all',
    SettingsSet: 'settings-set',
    PlayerNewIpDetected: 'player-new-ip-detected',
    PlayerNewNameDetected: 'player-new-name-detected',
    ServerStatusChanged: 'server-status-changed',
    ModuleCreated: 'module-created',
    ModuleUpdated: 'module-updated',
    ModuleDeleted: 'module-deleted',
    ModuleInstalled: 'module-installed',
    ModuleUninstalled: 'module-uninstalled',
    PlayerCreated: 'player-created',
    ShopListingCreated: 'shop-listing-created',
    ShopListingUpdated: 'shop-listing-updated',
    ShopListingDeleted: 'shop-listing-deleted',
    ShopOrderCreated: 'shop-order-created',
    ShopOrderStatusChanged: 'shop-order-status-changed',
    ShopOrderDeliveryFailed: 'shop-order-delivery-failed',
    PlayerLinked: 'player-linked',
    GameserverCreated: 'gameserver-created',
    GameserverUpdated: 'gameserver-updated',
    GameserverDeleted: 'gameserver-deleted',
    PlayerBanned: 'player-banned',
    PlayerUnbanned: 'player-unbanned',
    PlayerDeleted: 'player-deleted',
    PlayerConnected: 'player-connected',
    PlayerDisconnected: 'player-disconnected',
    ChatMessage: 'chat-message',
    PlayerDeath: 'player-death',
    EntityKilled: 'entity-killed',
};
export const EventSearchInputDTOExtendEnum = {
    Module: 'module',
    GameServer: 'gameServer',
    Player: 'player',
    User: 'user',
};
export const EventSearchInputDTOSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc',
};
export const EventsCountInputDTOEventNameEnum = {
    RoleAssigned: 'role-assigned',
    RoleRemoved: 'role-removed',
    RoleCreated: 'role-created',
    RoleUpdated: 'role-updated',
    RoleDeleted: 'role-deleted',
    CommandExecuted: 'command-executed',
    CommandExecutionDenied: 'command-execution-denied',
    HookExecuted: 'hook-executed',
    CronjobExecuted: 'cronjob-executed',
    CurrencyAdded: 'currency-added',
    CurrencyDeducted: 'currency-deducted',
    CurrencyResetAll: 'currency-reset-all',
    SettingsSet: 'settings-set',
    PlayerNewIpDetected: 'player-new-ip-detected',
    PlayerNewNameDetected: 'player-new-name-detected',
    ServerStatusChanged: 'server-status-changed',
    ModuleCreated: 'module-created',
    ModuleUpdated: 'module-updated',
    ModuleDeleted: 'module-deleted',
    ModuleInstalled: 'module-installed',
    ModuleUninstalled: 'module-uninstalled',
    PlayerCreated: 'player-created',
    ShopListingCreated: 'shop-listing-created',
    ShopListingUpdated: 'shop-listing-updated',
    ShopListingDeleted: 'shop-listing-deleted',
    ShopOrderCreated: 'shop-order-created',
    ShopOrderStatusChanged: 'shop-order-status-changed',
    ShopOrderDeliveryFailed: 'shop-order-delivery-failed',
    PlayerLinked: 'player-linked',
    GameserverCreated: 'gameserver-created',
    GameserverUpdated: 'gameserver-updated',
    GameserverDeleted: 'gameserver-deleted',
    PlayerBanned: 'player-banned',
    PlayerUnbanned: 'player-unbanned',
    PlayerDeleted: 'player-deleted',
    PlayerConnected: 'player-connected',
    PlayerDisconnected: 'player-disconnected',
    ChatMessage: 'chat-message',
    PlayerDeath: 'player-death',
    EntityKilled: 'entity-killed',
};
export const EventsCountInputDTOSumByEnum = {
    Player: 'player',
    Module: 'module',
    User: 'user',
    Gameserver: 'gameserver',
};
export const EventsCountInputDTOBucketStepEnum = {
    _5m: '5m',
    _30m: '30m',
    _1h: '1h',
    _6h: '6h',
    _12h: '12h',
    _24h: '24h',
};
export const FunctionSearchInputDTOExtendEnum = {
    Version: 'version',
    CronJob: 'cronJob',
    Hook: 'hook',
    Command: 'command',
};
export const FunctionSearchInputDTOSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc',
};
export const GameServerCreateDTOTypeEnum = {
    Sevendaystodie: 'SEVENDAYSTODIE',
    Rust: 'RUST',
    Generic: 'GENERIC',
    Mock: 'MOCK',
};
export const GameServerOutputDTOTypeEnum = {
    Sevendaystodie: 'SEVENDAYSTODIE',
    Rust: 'RUST',
    Generic: 'GENERIC',
    Mock: 'MOCK',
};
export const GameServerSearchInputAllowedFiltersTypeEnum = {
    Sevendaystodie: 'SEVENDAYSTODIE',
    Rust: 'RUST',
    Generic: 'GENERIC',
    Mock: 'MOCK',
};
export const GameServerSearchInputDTOExtendEnum = {
    Players: 'players',
    Items: 'items',
};
export const GameServerSearchInputDTOSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc',
};
export const GameServerTestReachabilityInputDTOTypeEnum = {
    Sevendaystodie: 'SEVENDAYSTODIE',
    Rust: 'RUST',
    Generic: 'GENERIC',
    Mock: 'MOCK',
};
export const GameServerTypesOutputDTOTypeEnum = {
    Sevendaystodie: 'SEVENDAYSTODIE',
    Rust: 'RUST',
    Generic: 'GENERIC',
    Mock: 'MOCK',
};
export const GameServerUpdateDTOTypeEnum = {
    Sevendaystodie: 'SEVENDAYSTODIE',
    Rust: 'RUST',
    Generic: 'GENERIC',
    Mock: 'MOCK',
};
export const GetJobInputDTOTypeEnum = {
    CsmmImport: 'csmmImport',
    SeedModules: 'seedModules',
    CleanEvents: 'cleanEvents',
    CleanExpiringVariables: 'cleanExpiringVariables',
    EnsureCronjobsScheduled: 'ensureCronjobsScheduled',
    DeleteGameServers: 'deleteGameServers',
    SyncItems: 'syncItems',
    SyncEntities: 'syncEntities',
    SyncBans: 'syncBans',
    SyncSteam: 'syncSteam',
    SyncDiscordRoles: 'syncDiscordRoles',
};
export const GetSettingsInputKeysEnum = {
    CommandPrefix: 'commandPrefix',
    ServerChatName: 'serverChatName',
    EconomyEnabled: 'economyEnabled',
    CurrencyName: 'currencyName',
    DeveloperMode: 'developerMode',
    MessagePrefix: 'messagePrefix',
    DomainName: 'domainName',
    DiscordRoleSyncEnabled: 'discordRoleSyncEnabled',
    DiscordRoleSyncPreferDiscord: 'discordRoleSyncPreferDiscord',
    UnknownCommandFeedbackEnabled: 'unknownCommandFeedbackEnabled',
    UnknownCommandFeedbackMessage: 'unknownCommandFeedbackMessage',
};
export const GuildSearchInputDTOSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc',
};
export const HookCreateDTOEventTypeEnum = {
    Log: 'log',
    PlayerConnected: 'player-connected',
    PlayerDisconnected: 'player-disconnected',
    ChatMessage: 'chat-message',
    PlayerDeath: 'player-death',
    EntityKilled: 'entity-killed',
    DiscordMessage: 'discord-message',
    RoleAssigned: 'role-assigned',
    RoleRemoved: 'role-removed',
    RoleCreated: 'role-created',
    RoleUpdated: 'role-updated',
    RoleDeleted: 'role-deleted',
    CommandExecuted: 'command-executed',
    CommandExecutionDenied: 'command-execution-denied',
    HookExecuted: 'hook-executed',
    CronjobExecuted: 'cronjob-executed',
    CurrencyAdded: 'currency-added',
    CurrencyDeducted: 'currency-deducted',
    CurrencyResetAll: 'currency-reset-all',
    SettingsSet: 'settings-set',
    PlayerNewIpDetected: 'player-new-ip-detected',
    PlayerNewNameDetected: 'player-new-name-detected',
    ServerStatusChanged: 'server-status-changed',
    ModuleCreated: 'module-created',
    ModuleUpdated: 'module-updated',
    ModuleDeleted: 'module-deleted',
    ModuleInstalled: 'module-installed',
    ModuleUninstalled: 'module-uninstalled',
    PlayerCreated: 'player-created',
    ShopListingCreated: 'shop-listing-created',
    ShopListingUpdated: 'shop-listing-updated',
    ShopListingDeleted: 'shop-listing-deleted',
    ShopOrderCreated: 'shop-order-created',
    ShopOrderStatusChanged: 'shop-order-status-changed',
    ShopOrderDeliveryFailed: 'shop-order-delivery-failed',
    PlayerLinked: 'player-linked',
    GameserverCreated: 'gameserver-created',
    GameserverUpdated: 'gameserver-updated',
    GameserverDeleted: 'gameserver-deleted',
    PlayerBanned: 'player-banned',
    PlayerUnbanned: 'player-unbanned',
    PlayerDeleted: 'player-deleted',
};
export const HookOutputDTOEventTypeEnum = {
    Log: 'log',
    PlayerConnected: 'player-connected',
    PlayerDisconnected: 'player-disconnected',
    ChatMessage: 'chat-message',
    PlayerDeath: 'player-death',
    EntityKilled: 'entity-killed',
    DiscordMessage: 'discord-message',
    RoleAssigned: 'role-assigned',
    RoleRemoved: 'role-removed',
    RoleCreated: 'role-created',
    RoleUpdated: 'role-updated',
    RoleDeleted: 'role-deleted',
    CommandExecuted: 'command-executed',
    CommandExecutionDenied: 'command-execution-denied',
    HookExecuted: 'hook-executed',
    CronjobExecuted: 'cronjob-executed',
    CurrencyAdded: 'currency-added',
    CurrencyDeducted: 'currency-deducted',
    CurrencyResetAll: 'currency-reset-all',
    SettingsSet: 'settings-set',
    PlayerNewIpDetected: 'player-new-ip-detected',
    PlayerNewNameDetected: 'player-new-name-detected',
    ServerStatusChanged: 'server-status-changed',
    ModuleCreated: 'module-created',
    ModuleUpdated: 'module-updated',
    ModuleDeleted: 'module-deleted',
    ModuleInstalled: 'module-installed',
    ModuleUninstalled: 'module-uninstalled',
    PlayerCreated: 'player-created',
    ShopListingCreated: 'shop-listing-created',
    ShopListingUpdated: 'shop-listing-updated',
    ShopListingDeleted: 'shop-listing-deleted',
    ShopOrderCreated: 'shop-order-created',
    ShopOrderStatusChanged: 'shop-order-status-changed',
    ShopOrderDeliveryFailed: 'shop-order-delivery-failed',
    PlayerLinked: 'player-linked',
    GameserverCreated: 'gameserver-created',
    GameserverUpdated: 'gameserver-updated',
    GameserverDeleted: 'gameserver-deleted',
    PlayerBanned: 'player-banned',
    PlayerUnbanned: 'player-unbanned',
    PlayerDeleted: 'player-deleted',
};
export const HookSearchInputAllowedFiltersEventTypeEnum = {
    Log: 'log',
    PlayerConnected: 'player-connected',
    PlayerDisconnected: 'player-disconnected',
    ChatMessage: 'chat-message',
    PlayerDeath: 'player-death',
    EntityKilled: 'entity-killed',
    DiscordMessage: 'discord-message',
    RoleAssigned: 'role-assigned',
    RoleRemoved: 'role-removed',
    RoleCreated: 'role-created',
    RoleUpdated: 'role-updated',
    RoleDeleted: 'role-deleted',
    CommandExecuted: 'command-executed',
    CommandExecutionDenied: 'command-execution-denied',
    HookExecuted: 'hook-executed',
    CronjobExecuted: 'cronjob-executed',
    CurrencyAdded: 'currency-added',
    CurrencyDeducted: 'currency-deducted',
    CurrencyResetAll: 'currency-reset-all',
    SettingsSet: 'settings-set',
    PlayerNewIpDetected: 'player-new-ip-detected',
    PlayerNewNameDetected: 'player-new-name-detected',
    ServerStatusChanged: 'server-status-changed',
    ModuleCreated: 'module-created',
    ModuleUpdated: 'module-updated',
    ModuleDeleted: 'module-deleted',
    ModuleInstalled: 'module-installed',
    ModuleUninstalled: 'module-uninstalled',
    PlayerCreated: 'player-created',
    ShopListingCreated: 'shop-listing-created',
    ShopListingUpdated: 'shop-listing-updated',
    ShopListingDeleted: 'shop-listing-deleted',
    ShopOrderCreated: 'shop-order-created',
    ShopOrderStatusChanged: 'shop-order-status-changed',
    ShopOrderDeliveryFailed: 'shop-order-delivery-failed',
    PlayerLinked: 'player-linked',
    GameserverCreated: 'gameserver-created',
    GameserverUpdated: 'gameserver-updated',
    GameserverDeleted: 'gameserver-deleted',
    PlayerBanned: 'player-banned',
    PlayerUnbanned: 'player-unbanned',
    PlayerDeleted: 'player-deleted',
};
export const HookSearchInputDTOExtendEnum = {
    Module: 'module',
    GameServer: 'gameServer',
};
export const HookSearchInputDTOSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc',
};
export const HookTriggerDTOEventTypeEnum = {
    Log: 'log',
    PlayerConnected: 'player-connected',
    PlayerDisconnected: 'player-disconnected',
    ChatMessage: 'chat-message',
    PlayerDeath: 'player-death',
    EntityKilled: 'entity-killed',
    DiscordMessage: 'discord-message',
    RoleAssigned: 'role-assigned',
    RoleRemoved: 'role-removed',
    RoleCreated: 'role-created',
    RoleUpdated: 'role-updated',
    RoleDeleted: 'role-deleted',
    CommandExecuted: 'command-executed',
    CommandExecutionDenied: 'command-execution-denied',
    HookExecuted: 'hook-executed',
    CronjobExecuted: 'cronjob-executed',
    CurrencyAdded: 'currency-added',
    CurrencyDeducted: 'currency-deducted',
    CurrencyResetAll: 'currency-reset-all',
    SettingsSet: 'settings-set',
    PlayerNewIpDetected: 'player-new-ip-detected',
    PlayerNewNameDetected: 'player-new-name-detected',
    ServerStatusChanged: 'server-status-changed',
    ModuleCreated: 'module-created',
    ModuleUpdated: 'module-updated',
    ModuleDeleted: 'module-deleted',
    ModuleInstalled: 'module-installed',
    ModuleUninstalled: 'module-uninstalled',
    PlayerCreated: 'player-created',
    ShopListingCreated: 'shop-listing-created',
    ShopListingUpdated: 'shop-listing-updated',
    ShopListingDeleted: 'shop-listing-deleted',
    ShopOrderCreated: 'shop-order-created',
    ShopOrderStatusChanged: 'shop-order-status-changed',
    ShopOrderDeliveryFailed: 'shop-order-delivery-failed',
    PlayerLinked: 'player-linked',
    GameserverCreated: 'gameserver-created',
    GameserverUpdated: 'gameserver-updated',
    GameserverDeleted: 'gameserver-deleted',
    PlayerBanned: 'player-banned',
    PlayerUnbanned: 'player-unbanned',
    PlayerDeleted: 'player-deleted',
};
export const HookUpdateDTOEventTypeEnum = {
    Log: 'log',
    PlayerConnected: 'player-connected',
    PlayerDisconnected: 'player-disconnected',
    ChatMessage: 'chat-message',
    PlayerDeath: 'player-death',
    EntityKilled: 'entity-killed',
    DiscordMessage: 'discord-message',
    RoleAssigned: 'role-assigned',
    RoleRemoved: 'role-removed',
    RoleCreated: 'role-created',
    RoleUpdated: 'role-updated',
    RoleDeleted: 'role-deleted',
    CommandExecuted: 'command-executed',
    CommandExecutionDenied: 'command-execution-denied',
    HookExecuted: 'hook-executed',
    CronjobExecuted: 'cronjob-executed',
    CurrencyAdded: 'currency-added',
    CurrencyDeducted: 'currency-deducted',
    CurrencyResetAll: 'currency-reset-all',
    SettingsSet: 'settings-set',
    PlayerNewIpDetected: 'player-new-ip-detected',
    PlayerNewNameDetected: 'player-new-name-detected',
    ServerStatusChanged: 'server-status-changed',
    ModuleCreated: 'module-created',
    ModuleUpdated: 'module-updated',
    ModuleDeleted: 'module-deleted',
    ModuleInstalled: 'module-installed',
    ModuleUninstalled: 'module-uninstalled',
    PlayerCreated: 'player-created',
    ShopListingCreated: 'shop-listing-created',
    ShopListingUpdated: 'shop-listing-updated',
    ShopListingDeleted: 'shop-listing-deleted',
    ShopOrderCreated: 'shop-order-created',
    ShopOrderStatusChanged: 'shop-order-status-changed',
    ShopOrderDeliveryFailed: 'shop-order-delivery-failed',
    PlayerLinked: 'player-linked',
    GameserverCreated: 'gameserver-created',
    GameserverUpdated: 'gameserver-updated',
    GameserverDeleted: 'gameserver-deleted',
    PlayerBanned: 'player-banned',
    PlayerUnbanned: 'player-unbanned',
    PlayerDeleted: 'player-deleted',
};
export const IEntityDTOTypeEnum = {
    Hostile: 'hostile',
    Friendly: 'friendly',
    Neutral: 'neutral',
};
export const IHookEventTypeEnum = {
    Log: 'log',
    PlayerConnected: 'player-connected',
    PlayerDisconnected: 'player-disconnected',
    ChatMessage: 'chat-message',
    PlayerDeath: 'player-death',
    EntityKilled: 'entity-killed',
    DiscordMessage: 'discord-message',
    RoleAssigned: 'role-assigned',
    RoleRemoved: 'role-removed',
    RoleCreated: 'role-created',
    RoleUpdated: 'role-updated',
    RoleDeleted: 'role-deleted',
    CommandExecuted: 'command-executed',
    CommandExecutionDenied: 'command-execution-denied',
    HookExecuted: 'hook-executed',
    CronjobExecuted: 'cronjob-executed',
    CurrencyAdded: 'currency-added',
    CurrencyDeducted: 'currency-deducted',
    CurrencyResetAll: 'currency-reset-all',
    SettingsSet: 'settings-set',
    PlayerNewIpDetected: 'player-new-ip-detected',
    PlayerNewNameDetected: 'player-new-name-detected',
    ServerStatusChanged: 'server-status-changed',
    ModuleCreated: 'module-created',
    ModuleUpdated: 'module-updated',
    ModuleDeleted: 'module-deleted',
    ModuleInstalled: 'module-installed',
    ModuleUninstalled: 'module-uninstalled',
    PlayerCreated: 'player-created',
    ShopListingCreated: 'shop-listing-created',
    ShopListingUpdated: 'shop-listing-updated',
    ShopListingDeleted: 'shop-listing-deleted',
    ShopOrderCreated: 'shop-order-created',
    ShopOrderStatusChanged: 'shop-order-status-changed',
    ShopOrderDeliveryFailed: 'shop-order-delivery-failed',
    PlayerLinked: 'player-linked',
    GameserverCreated: 'gameserver-created',
    GameserverUpdated: 'gameserver-updated',
    GameserverDeleted: 'gameserver-deleted',
    PlayerBanned: 'player-banned',
    PlayerUnbanned: 'player-unbanned',
    PlayerDeleted: 'player-deleted',
};
export const ITakaroQuerySortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc',
};
export const ItemSearchInputDTOExtendEnum = {
    Gameserver: 'gameserver',
};
export const ItemSearchInputDTOSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc',
};
export const JobStatusOutputDTOStatusEnum = {
    Pending: 'pending',
    Completed: 'completed',
    Failed: 'failed',
    Active: 'active',
    Delayed: 'delayed',
    Prioritized: 'prioritized',
    Waiting: 'waiting',
    WaitingChildren: 'waiting-children',
};
export const ModuleInstallationSearchInputDTOSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc',
};
export const ModuleSearchInputDTOSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc',
};
export const ModuleVersionSearchInputDTOSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc',
};
export const OrderStatusCountDTOStatusEnum = {
    Completed: 'COMPLETED',
    Paid: 'PAID',
    Canceled: 'CANCELED',
};
/**
 *
 * @export
 * @enum {string}
 */
export const PERMISSIONS = {
    Root: 'ROOT',
    ManageUsers: 'MANAGE_USERS',
    ReadUsers: 'READ_USERS',
    ManageRoles: 'MANAGE_ROLES',
    ReadRoles: 'READ_ROLES',
    ManageGameservers: 'MANAGE_GAMESERVERS',
    ReadModules: 'READ_MODULES',
    ManageModules: 'MANAGE_MODULES',
    ReadPlayers: 'READ_PLAYERS',
    ManagePlayers: 'MANAGE_PLAYERS',
    ManageSettings: 'MANAGE_SETTINGS',
    ReadSettings: 'READ_SETTINGS',
    ReadVariables: 'READ_VARIABLES',
    ManageVariables: 'MANAGE_VARIABLES',
    ReadEvents: 'READ_EVENTS',
    ManageEvents: 'MANAGE_EVENTS',
    ReadItems: 'READ_ITEMS',
    ManageItems: 'MANAGE_ITEMS',
    ReadEntities: 'READ_ENTITIES',
    ManageEntities: 'MANAGE_ENTITIES',
    ManageShopListings: 'MANAGE_SHOP_LISTINGS',
    ManageShopOrders: 'MANAGE_SHOP_ORDERS',
    ViewDiscordInfo: 'VIEW_DISCORD_INFO',
    SendDiscordMessage: 'SEND_DISCORD_MESSAGE',
};
export const ParamKeyKeyEnum = {
    CommandPrefix: 'commandPrefix',
    ServerChatName: 'serverChatName',
    EconomyEnabled: 'economyEnabled',
    CurrencyName: 'currencyName',
    DeveloperMode: 'developerMode',
    MessagePrefix: 'messagePrefix',
    DomainName: 'domainName',
    DiscordRoleSyncEnabled: 'discordRoleSyncEnabled',
    DiscordRoleSyncPreferDiscord: 'discordRoleSyncPreferDiscord',
    UnknownCommandFeedbackEnabled: 'unknownCommandFeedbackEnabled',
    UnknownCommandFeedbackMessage: 'unknownCommandFeedbackMessage',
};
export const PlayerOnGameServerSearchInputDTOExtendEnum = {
    GameServer: 'gameServer',
    Player: 'player',
};
export const PlayerOnGameServerSearchInputDTOSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc',
};
export const PlayerSearchInputDTOExtendEnum = {
    PlayerOnGameServers: 'playerOnGameServers',
    Roles: 'roles',
    GameServers: 'gameServers',
    RoleAssignments: 'roleAssignments',
};
export const PlayerSearchInputDTOSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc',
};
export const RecentOrderDTOStatusEnum = {
    Completed: 'COMPLETED',
    Paid: 'PAID',
    Canceled: 'CANCELED',
};
export const RoleSearchInputDTOExtendEnum = {
    Permissions: 'permissions',
};
export const RoleSearchInputDTOSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc',
};
export const SettingsOutputDTOKeyEnum = {
    CommandPrefix: 'commandPrefix',
    ServerChatName: 'serverChatName',
    EconomyEnabled: 'economyEnabled',
    CurrencyName: 'currencyName',
    DeveloperMode: 'developerMode',
    MessagePrefix: 'messagePrefix',
    DomainName: 'domainName',
    DiscordRoleSyncEnabled: 'discordRoleSyncEnabled',
    DiscordRoleSyncPreferDiscord: 'discordRoleSyncPreferDiscord',
    UnknownCommandFeedbackEnabled: 'unknownCommandFeedbackEnabled',
    UnknownCommandFeedbackMessage: 'unknownCommandFeedbackMessage',
};
export const SettingsOutputDTOTypeEnum = {
    Override: 'override',
    Inherit: 'inherit',
    Global: 'global',
    Default: 'default',
};
export const ShopAnalyticsQueryDTOPeriodEnum = {
    Last24Hours: 'last24Hours',
    Last7Days: 'last7Days',
    Last30Days: 'last30Days',
    Last90Days: 'last90Days',
};
export const ShopCategorySearchInputDTOSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc',
};
export const ShopListingSearchInputDTOExtendEnum = {
    GameServer: 'gameServer',
    Items: 'items',
    Categories: 'categories',
};
export const ShopListingSearchInputDTOSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc',
};
export const ShopOrderOutputDTOStatusEnum = {
    Completed: 'COMPLETED',
    Paid: 'PAID',
    Canceled: 'CANCELED',
};
export const ShopOrderSearchInputDTOExtendEnum = {
    Listing: 'listing',
    ListingItems: 'listing.items',
    ListingItemsItem: 'listing.items.item',
};
export const ShopOrderSearchInputDTOSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc',
};
export const ShopOrderUpdateDTOStatusEnum = {
    Completed: 'COMPLETED',
    Paid: 'PAID',
    Canceled: 'CANCELED',
};
export const UserSearchInputDTOExtendEnum = {
    Roles: 'roles',
};
export const UserSearchInputDTOSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc',
};
export const VariableSearchInputDTOExtendEnum = {
    Module: 'module',
    Player: 'player',
    GameServer: 'gameServer',
};
export const VariableSearchInputDTOSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc',
};
/**
 * AnalyticsApi - axios parameter creator
 * @export
 */
export const AnalyticsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve comprehensive analytics for shop performance across selected game servers   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `AnalyticsControllerGetShopAnalytics`
         * @summary Get shop analytics
         * @param {Array<string>} [gameServerIds]
         * @param {AnalyticsControllerGetShopAnalyticsPeriodEnum} [period]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetShopAnalytics: async (gameServerIds, period, options = {}) => {
            const localVarPath = `/analytics/shop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            if (gameServerIds) {
                localVarQueryParameter['gameServerIds'] = gameServerIds;
            }
            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AnalyticsApi - functional programming interface
 * @export
 */
export const AnalyticsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AnalyticsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve comprehensive analytics for shop performance across selected game servers   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `AnalyticsControllerGetShopAnalytics`
         * @summary Get shop analytics
         * @param {Array<string>} [gameServerIds]
         * @param {AnalyticsControllerGetShopAnalyticsPeriodEnum} [period]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyticsControllerGetShopAnalytics(gameServerIds, period, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsControllerGetShopAnalytics(gameServerIds, period, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsApi.analyticsControllerGetShopAnalytics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AnalyticsApi - factory interface
 * @export
 */
export const AnalyticsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AnalyticsApiFp(configuration);
    return {
        /**
         * Retrieve comprehensive analytics for shop performance across selected game servers   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `AnalyticsControllerGetShopAnalytics`
         * @summary Get shop analytics
         * @param {Array<string>} [gameServerIds]
         * @param {AnalyticsControllerGetShopAnalyticsPeriodEnum} [period]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetShopAnalytics(gameServerIds, period, options) {
            return localVarFp
                .analyticsControllerGetShopAnalytics(gameServerIds, period, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * AnalyticsApi - object-oriented interface
 * @export
 * @class AnalyticsApi
 * @extends {BaseAPI}
 */
export class AnalyticsApi extends BaseAPI {
    /**
     * Retrieve comprehensive analytics for shop performance across selected game servers   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `AnalyticsControllerGetShopAnalytics`
     * @summary Get shop analytics
     * @param {Array<string>} [gameServerIds]
     * @param {AnalyticsControllerGetShopAnalyticsPeriodEnum} [period]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    analyticsControllerGetShopAnalytics(gameServerIds, period, options) {
        return AnalyticsApiFp(this.configuration)
            .analyticsControllerGetShopAnalytics(gameServerIds, period, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const AnalyticsControllerGetShopAnalyticsPeriodEnum = {
    Last24Hours: 'last24Hours',
    Last7Days: 'last7Days',
    Last30Days: 'last30Days',
    Last90Days: 'last90Days',
};
/**
 * CommandApi - axios parameter creator
 * @export
 */
export const CommandApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerCreate`
         * @summary Create
         * @param {CommandCreateDTO} [commandCreateDTO] CommandCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandControllerCreate: async (commandCreateDTO, options = {}) => {
            const localVarPath = `/command`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(commandCreateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerCreateArgument`
         * @summary Create argument
         * @param {CommandArgumentCreateDTO} [commandArgumentCreateDTO] CommandArgumentCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandControllerCreateArgument: async (commandArgumentCreateDTO, options = {}) => {
            const localVarPath = `/command/argument`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(commandArgumentCreateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `CommandControllerGetExecutions`
         * @summary Get executions
         * @param {string} id
         * @param {any} [success]
         * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandControllerGetExecutions: async (id, success, eventSearchInputDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('commandControllerGetExecutions', 'id', id);
            const localVarPath = `/command/{id}/executions`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            if (success !== undefined) {
                for (const [key, value] of Object.entries(success)) {
                    localVarQueryParameter[key] = value;
                }
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(eventSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `CommandControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandControllerGetOne: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('commandControllerGetOne', 'id', id);
            const localVarPath = `/command/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandControllerRemove: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('commandControllerRemove', 'id', id);
            const localVarPath = `/command/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerRemoveArgument`
         * @summary Remove argument
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandControllerRemoveArgument: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('commandControllerRemoveArgument', 'id', id);
            const localVarPath = `/command/argument/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search commands   Required permissions: `READ_MODULES`<br> OperationId: `CommandControllerSearch`
         * @summary Search
         * @param {CommandSearchInputDTO} [commandSearchInputDTO] CommandSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandControllerSearch: async (commandSearchInputDTO, options = {}) => {
            const localVarPath = `/command/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(commandSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerTrigger`
         * @summary Trigger
         * @param {string} id
         * @param {CommandTriggerDTO} [commandTriggerDTO] CommandTriggerDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandControllerTrigger: async (id, commandTriggerDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('commandControllerTrigger', 'id', id);
            const localVarPath = `/command/{id}/trigger`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(commandTriggerDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {CommandUpdateDTO} [commandUpdateDTO] CommandUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandControllerUpdate: async (id, commandUpdateDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('commandControllerUpdate', 'id', id);
            const localVarPath = `/command/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(commandUpdateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerUpdateArgument`
         * @summary Update argument
         * @param {string} id
         * @param {CommandArgumentUpdateDTO} [commandArgumentUpdateDTO] CommandArgumentUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandControllerUpdateArgument: async (id, commandArgumentUpdateDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('commandControllerUpdateArgument', 'id', id);
            const localVarPath = `/command/argument/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(commandArgumentUpdateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CommandApi - functional programming interface
 * @export
 */
export const CommandApiFp = function (configuration) {
    const localVarAxiosParamCreator = CommandApiAxiosParamCreator(configuration);
    return {
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerCreate`
         * @summary Create
         * @param {CommandCreateDTO} [commandCreateDTO] CommandCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commandControllerCreate(commandCreateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commandControllerCreate(commandCreateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommandApi.commandControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerCreateArgument`
         * @summary Create argument
         * @param {CommandArgumentCreateDTO} [commandArgumentCreateDTO] CommandArgumentCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commandControllerCreateArgument(commandArgumentCreateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commandControllerCreateArgument(commandArgumentCreateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommandApi.commandControllerCreateArgument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `CommandControllerGetExecutions`
         * @summary Get executions
         * @param {string} id
         * @param {any} [success]
         * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commandControllerGetExecutions(id, success, eventSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commandControllerGetExecutions(id, success, eventSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommandApi.commandControllerGetExecutions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `CommandControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commandControllerGetOne(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commandControllerGetOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommandApi.commandControllerGetOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commandControllerRemove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commandControllerRemove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommandApi.commandControllerRemove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerRemoveArgument`
         * @summary Remove argument
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commandControllerRemoveArgument(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commandControllerRemoveArgument(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommandApi.commandControllerRemoveArgument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search commands   Required permissions: `READ_MODULES`<br> OperationId: `CommandControllerSearch`
         * @summary Search
         * @param {CommandSearchInputDTO} [commandSearchInputDTO] CommandSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commandControllerSearch(commandSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commandControllerSearch(commandSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommandApi.commandControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerTrigger`
         * @summary Trigger
         * @param {string} id
         * @param {CommandTriggerDTO} [commandTriggerDTO] CommandTriggerDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commandControllerTrigger(id, commandTriggerDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commandControllerTrigger(id, commandTriggerDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommandApi.commandControllerTrigger']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {CommandUpdateDTO} [commandUpdateDTO] CommandUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commandControllerUpdate(id, commandUpdateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commandControllerUpdate(id, commandUpdateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommandApi.commandControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerUpdateArgument`
         * @summary Update argument
         * @param {string} id
         * @param {CommandArgumentUpdateDTO} [commandArgumentUpdateDTO] CommandArgumentUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commandControllerUpdateArgument(id, commandArgumentUpdateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commandControllerUpdateArgument(id, commandArgumentUpdateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommandApi.commandControllerUpdateArgument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CommandApi - factory interface
 * @export
 */
export const CommandApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CommandApiFp(configuration);
    return {
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerCreate`
         * @summary Create
         * @param {CommandCreateDTO} [commandCreateDTO] CommandCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandControllerCreate(commandCreateDTO, options) {
            return localVarFp.commandControllerCreate(commandCreateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerCreateArgument`
         * @summary Create argument
         * @param {CommandArgumentCreateDTO} [commandArgumentCreateDTO] CommandArgumentCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandControllerCreateArgument(commandArgumentCreateDTO, options) {
            return localVarFp
                .commandControllerCreateArgument(commandArgumentCreateDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `CommandControllerGetExecutions`
         * @summary Get executions
         * @param {string} id
         * @param {any} [success]
         * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandControllerGetExecutions(id, success, eventSearchInputDTO, options) {
            return localVarFp
                .commandControllerGetExecutions(id, success, eventSearchInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `CommandControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandControllerGetOne(id, options) {
            return localVarFp.commandControllerGetOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandControllerRemove(id, options) {
            return localVarFp.commandControllerRemove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerRemoveArgument`
         * @summary Remove argument
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandControllerRemoveArgument(id, options) {
            return localVarFp.commandControllerRemoveArgument(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Search commands   Required permissions: `READ_MODULES`<br> OperationId: `CommandControllerSearch`
         * @summary Search
         * @param {CommandSearchInputDTO} [commandSearchInputDTO] CommandSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandControllerSearch(commandSearchInputDTO, options) {
            return localVarFp
                .commandControllerSearch(commandSearchInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerTrigger`
         * @summary Trigger
         * @param {string} id
         * @param {CommandTriggerDTO} [commandTriggerDTO] CommandTriggerDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandControllerTrigger(id, commandTriggerDTO, options) {
            return localVarFp
                .commandControllerTrigger(id, commandTriggerDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {CommandUpdateDTO} [commandUpdateDTO] CommandUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandControllerUpdate(id, commandUpdateDTO, options) {
            return localVarFp
                .commandControllerUpdate(id, commandUpdateDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerUpdateArgument`
         * @summary Update argument
         * @param {string} id
         * @param {CommandArgumentUpdateDTO} [commandArgumentUpdateDTO] CommandArgumentUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandControllerUpdateArgument(id, commandArgumentUpdateDTO, options) {
            return localVarFp
                .commandControllerUpdateArgument(id, commandArgumentUpdateDTO, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * CommandApi - object-oriented interface
 * @export
 * @class CommandApi
 * @extends {BaseAPI}
 */
export class CommandApi extends BaseAPI {
    /**
     *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerCreate`
     * @summary Create
     * @param {CommandCreateDTO} [commandCreateDTO] CommandCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommandApi
     */
    commandControllerCreate(commandCreateDTO, options) {
        return CommandApiFp(this.configuration)
            .commandControllerCreate(commandCreateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerCreateArgument`
     * @summary Create argument
     * @param {CommandArgumentCreateDTO} [commandArgumentCreateDTO] CommandArgumentCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommandApi
     */
    commandControllerCreateArgument(commandArgumentCreateDTO, options) {
        return CommandApiFp(this.configuration)
            .commandControllerCreateArgument(commandArgumentCreateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_MODULES`<br> OperationId: `CommandControllerGetExecutions`
     * @summary Get executions
     * @param {string} id
     * @param {any} [success]
     * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommandApi
     */
    commandControllerGetExecutions(id, success, eventSearchInputDTO, options) {
        return CommandApiFp(this.configuration)
            .commandControllerGetExecutions(id, success, eventSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_MODULES`<br> OperationId: `CommandControllerGetOne`
     * @summary Get one
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommandApi
     */
    commandControllerGetOne(id, options) {
        return CommandApiFp(this.configuration)
            .commandControllerGetOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerRemove`
     * @summary Remove
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommandApi
     */
    commandControllerRemove(id, options) {
        return CommandApiFp(this.configuration)
            .commandControllerRemove(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerRemoveArgument`
     * @summary Remove argument
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommandApi
     */
    commandControllerRemoveArgument(id, options) {
        return CommandApiFp(this.configuration)
            .commandControllerRemoveArgument(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search commands   Required permissions: `READ_MODULES`<br> OperationId: `CommandControllerSearch`
     * @summary Search
     * @param {CommandSearchInputDTO} [commandSearchInputDTO] CommandSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommandApi
     */
    commandControllerSearch(commandSearchInputDTO, options) {
        return CommandApiFp(this.configuration)
            .commandControllerSearch(commandSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerTrigger`
     * @summary Trigger
     * @param {string} id
     * @param {CommandTriggerDTO} [commandTriggerDTO] CommandTriggerDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommandApi
     */
    commandControllerTrigger(id, commandTriggerDTO, options) {
        return CommandApiFp(this.configuration)
            .commandControllerTrigger(id, commandTriggerDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerUpdate`
     * @summary Update
     * @param {string} id
     * @param {CommandUpdateDTO} [commandUpdateDTO] CommandUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommandApi
     */
    commandControllerUpdate(id, commandUpdateDTO, options) {
        return CommandApiFp(this.configuration)
            .commandControllerUpdate(id, commandUpdateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CommandControllerUpdateArgument`
     * @summary Update argument
     * @param {string} id
     * @param {CommandArgumentUpdateDTO} [commandArgumentUpdateDTO] CommandArgumentUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommandApi
     */
    commandControllerUpdateArgument(id, commandArgumentUpdateDTO, options) {
        return CommandApiFp(this.configuration)
            .commandControllerUpdateArgument(id, commandArgumentUpdateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CronJobApi - axios parameter creator
 * @export
 */
export const CronJobApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CronJobControllerCreate`
         * @summary Create
         * @param {CronJobCreateDTO} [cronJobCreateDTO] CronJobCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cronJobControllerCreate: async (cronJobCreateDTO, options = {}) => {
            const localVarPath = `/cronjob`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(cronJobCreateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `CronJobControllerGetExecutions`
         * @summary Get executions
         * @param {string} id
         * @param {any} [success]
         * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cronJobControllerGetExecutions: async (id, success, eventSearchInputDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cronJobControllerGetExecutions', 'id', id);
            const localVarPath = `/cronjob/{id}/executions`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            if (success !== undefined) {
                for (const [key, value] of Object.entries(success)) {
                    localVarQueryParameter[key] = value;
                }
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(eventSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `CronJobControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cronJobControllerGetOne: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cronJobControllerGetOne', 'id', id);
            const localVarPath = `/cronjob/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CronJobControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cronJobControllerRemove: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cronJobControllerRemove', 'id', id);
            const localVarPath = `/cronjob/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search cronjobs   Required permissions: `READ_MODULES`<br> OperationId: `CronJobControllerSearch`
         * @summary Search
         * @param {CronJobSearchInputDTO} [cronJobSearchInputDTO] CronJobSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cronJobControllerSearch: async (cronJobSearchInputDTO, options = {}) => {
            const localVarPath = `/cronjob/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(cronJobSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CronJobControllerTrigger`
         * @summary Trigger
         * @param {CronJobTriggerDTO} [cronJobTriggerDTO] CronJobTriggerDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cronJobControllerTrigger: async (cronJobTriggerDTO, options = {}) => {
            const localVarPath = `/cronjob/trigger`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(cronJobTriggerDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CronJobControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {CronJobUpdateDTO} [cronJobUpdateDTO] CronJobUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cronJobControllerUpdate: async (id, cronJobUpdateDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cronJobControllerUpdate', 'id', id);
            const localVarPath = `/cronjob/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(cronJobUpdateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CronJobApi - functional programming interface
 * @export
 */
export const CronJobApiFp = function (configuration) {
    const localVarAxiosParamCreator = CronJobApiAxiosParamCreator(configuration);
    return {
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CronJobControllerCreate`
         * @summary Create
         * @param {CronJobCreateDTO} [cronJobCreateDTO] CronJobCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cronJobControllerCreate(cronJobCreateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cronJobControllerCreate(cronJobCreateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronJobApi.cronJobControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `CronJobControllerGetExecutions`
         * @summary Get executions
         * @param {string} id
         * @param {any} [success]
         * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cronJobControllerGetExecutions(id, success, eventSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cronJobControllerGetExecutions(id, success, eventSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronJobApi.cronJobControllerGetExecutions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `CronJobControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cronJobControllerGetOne(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cronJobControllerGetOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronJobApi.cronJobControllerGetOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CronJobControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cronJobControllerRemove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cronJobControllerRemove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronJobApi.cronJobControllerRemove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search cronjobs   Required permissions: `READ_MODULES`<br> OperationId: `CronJobControllerSearch`
         * @summary Search
         * @param {CronJobSearchInputDTO} [cronJobSearchInputDTO] CronJobSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cronJobControllerSearch(cronJobSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cronJobControllerSearch(cronJobSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronJobApi.cronJobControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CronJobControllerTrigger`
         * @summary Trigger
         * @param {CronJobTriggerDTO} [cronJobTriggerDTO] CronJobTriggerDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cronJobControllerTrigger(cronJobTriggerDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cronJobControllerTrigger(cronJobTriggerDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronJobApi.cronJobControllerTrigger']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CronJobControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {CronJobUpdateDTO} [cronJobUpdateDTO] CronJobUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cronJobControllerUpdate(id, cronJobUpdateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cronJobControllerUpdate(id, cronJobUpdateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronJobApi.cronJobControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CronJobApi - factory interface
 * @export
 */
export const CronJobApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CronJobApiFp(configuration);
    return {
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CronJobControllerCreate`
         * @summary Create
         * @param {CronJobCreateDTO} [cronJobCreateDTO] CronJobCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cronJobControllerCreate(cronJobCreateDTO, options) {
            return localVarFp.cronJobControllerCreate(cronJobCreateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `CronJobControllerGetExecutions`
         * @summary Get executions
         * @param {string} id
         * @param {any} [success]
         * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cronJobControllerGetExecutions(id, success, eventSearchInputDTO, options) {
            return localVarFp
                .cronJobControllerGetExecutions(id, success, eventSearchInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `CronJobControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cronJobControllerGetOne(id, options) {
            return localVarFp.cronJobControllerGetOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CronJobControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cronJobControllerRemove(id, options) {
            return localVarFp.cronJobControllerRemove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Search cronjobs   Required permissions: `READ_MODULES`<br> OperationId: `CronJobControllerSearch`
         * @summary Search
         * @param {CronJobSearchInputDTO} [cronJobSearchInputDTO] CronJobSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cronJobControllerSearch(cronJobSearchInputDTO, options) {
            return localVarFp
                .cronJobControllerSearch(cronJobSearchInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CronJobControllerTrigger`
         * @summary Trigger
         * @param {CronJobTriggerDTO} [cronJobTriggerDTO] CronJobTriggerDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cronJobControllerTrigger(cronJobTriggerDTO, options) {
            return localVarFp
                .cronJobControllerTrigger(cronJobTriggerDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CronJobControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {CronJobUpdateDTO} [cronJobUpdateDTO] CronJobUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cronJobControllerUpdate(id, cronJobUpdateDTO, options) {
            return localVarFp
                .cronJobControllerUpdate(id, cronJobUpdateDTO, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * CronJobApi - object-oriented interface
 * @export
 * @class CronJobApi
 * @extends {BaseAPI}
 */
export class CronJobApi extends BaseAPI {
    /**
     *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CronJobControllerCreate`
     * @summary Create
     * @param {CronJobCreateDTO} [cronJobCreateDTO] CronJobCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronJobApi
     */
    cronJobControllerCreate(cronJobCreateDTO, options) {
        return CronJobApiFp(this.configuration)
            .cronJobControllerCreate(cronJobCreateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_MODULES`<br> OperationId: `CronJobControllerGetExecutions`
     * @summary Get executions
     * @param {string} id
     * @param {any} [success]
     * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronJobApi
     */
    cronJobControllerGetExecutions(id, success, eventSearchInputDTO, options) {
        return CronJobApiFp(this.configuration)
            .cronJobControllerGetExecutions(id, success, eventSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_MODULES`<br> OperationId: `CronJobControllerGetOne`
     * @summary Get one
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronJobApi
     */
    cronJobControllerGetOne(id, options) {
        return CronJobApiFp(this.configuration)
            .cronJobControllerGetOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CronJobControllerRemove`
     * @summary Remove
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronJobApi
     */
    cronJobControllerRemove(id, options) {
        return CronJobApiFp(this.configuration)
            .cronJobControllerRemove(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search cronjobs   Required permissions: `READ_MODULES`<br> OperationId: `CronJobControllerSearch`
     * @summary Search
     * @param {CronJobSearchInputDTO} [cronJobSearchInputDTO] CronJobSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronJobApi
     */
    cronJobControllerSearch(cronJobSearchInputDTO, options) {
        return CronJobApiFp(this.configuration)
            .cronJobControllerSearch(cronJobSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CronJobControllerTrigger`
     * @summary Trigger
     * @param {CronJobTriggerDTO} [cronJobTriggerDTO] CronJobTriggerDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronJobApi
     */
    cronJobControllerTrigger(cronJobTriggerDTO, options) {
        return CronJobApiFp(this.configuration)
            .cronJobControllerTrigger(cronJobTriggerDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_MODULES`<br> OperationId: `CronJobControllerUpdate`
     * @summary Update
     * @param {string} id
     * @param {CronJobUpdateDTO} [cronJobUpdateDTO] CronJobUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronJobApi
     */
    cronJobControllerUpdate(id, cronJobUpdateDTO, options) {
        return CronJobApiFp(this.configuration)
            .cronJobControllerUpdate(id, cronJobUpdateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DiscordApi - axios parameter creator
 * @export
 */
export const DiscordApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Delete a Discord message. The bot must have sent the original message or have appropriate permissions. Returns an empty response on success.   Required permissions: `SEND_DISCORD_MESSAGE`<br> OperationId: `DiscordControllerDeleteMessage`
         * @summary Delete Discord message
         * @param {string} channelId
         * @param {string} messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discordControllerDeleteMessage: async (channelId, messageId, options = {}) => {
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('discordControllerDeleteMessage', 'channelId', channelId);
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('discordControllerDeleteMessage', 'messageId', messageId);
            const localVarPath = `/discord/channels/{channelId}/messages/{messageId}`
                .replace(`{${'channelId'}}`, encodeURIComponent(String(channelId)))
                .replace(`{${'messageId'}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all channels (text, voice, etc.) in a specific Discord guild. Useful for selecting channels for notifications or commands.   Required permissions: `VIEW_DISCORD_INFO`<br> OperationId: `DiscordControllerGetChannels`
         * @summary Get guild channels
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discordControllerGetChannels: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('discordControllerGetChannels', 'id', id);
            const localVarPath = `/discord/guilds/{id}/channels`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the invite link to add the Takaro bot to a Discord server, along with the developer Discord server link.<br> OperationId: `DiscordControllerGetInvite`
         * @summary Get bot invite links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discordControllerGetInvite: async (options = {}) => {
            const localVarPath = `/discord/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all roles available in a specific Discord guild. Useful for role-based integrations and permissions mapping.   Required permissions: `VIEW_DISCORD_INFO`<br> OperationId: `DiscordControllerGetRoles`
         * @summary Get guild roles
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discordControllerGetRoles: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('discordControllerGetRoles', 'id', id);
            const localVarPath = `/discord/guilds/{id}/roles`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for Discord guilds (servers) that the bot has access to. Supports filtering by name, Discord ID, and whether Takaro is enabled.   Required permissions: `VIEW_DISCORD_INFO`<br> OperationId: `DiscordControllerSearch`
         * @summary Search Discord guilds
         * @param {GuildSearchInputDTO} [guildSearchInputDTO] GuildSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discordControllerSearch: async (guildSearchInputDTO, options = {}) => {
            const localVarPath = `/discord/guilds/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(guildSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send a text message or rich embed to a specific Discord channel. Requires the bot to have appropriate permissions in the channel.   Required permissions: `SEND_DISCORD_MESSAGE`<br> OperationId: `DiscordControllerSendMessage`
         * @summary Send message to Discord channel
         * @param {string} id
         * @param {SendMessageInputDTO} [sendMessageInputDTO] SendMessageInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discordControllerSendMessage: async (id, sendMessageInputDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('discordControllerSendMessage', 'id', id);
            const localVarPath = `/discord/channels/{id}/message`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(sendMessageInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Takaro-specific settings for a Discord guild, such as enabling or disabling Takaro features.   Required permissions: `MANAGE_SETTINGS`<br> OperationId: `DiscordControllerUpdateGuild`
         * @summary Update guild settings
         * @param {string} id
         * @param {GuildApiUpdateDTO} [guildApiUpdateDTO] GuildApiUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discordControllerUpdateGuild: async (id, guildApiUpdateDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('discordControllerUpdateGuild', 'id', id);
            const localVarPath = `/discord/guilds/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(guildApiUpdateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Discord message with new content or embed. Requires the bot to have sent the original message.   Required permissions: `SEND_DISCORD_MESSAGE`<br> OperationId: `DiscordControllerUpdateMessage`
         * @summary Update Discord message
         * @param {string} channelId
         * @param {string} messageId
         * @param {SendMessageInputDTO} [sendMessageInputDTO] SendMessageInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discordControllerUpdateMessage: async (channelId, messageId, sendMessageInputDTO, options = {}) => {
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('discordControllerUpdateMessage', 'channelId', channelId);
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('discordControllerUpdateMessage', 'messageId', messageId);
            const localVarPath = `/discord/channels/{channelId}/messages/{messageId}`
                .replace(`{${'channelId'}}`, encodeURIComponent(String(channelId)))
                .replace(`{${'messageId'}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(sendMessageInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DiscordApi - functional programming interface
 * @export
 */
export const DiscordApiFp = function (configuration) {
    const localVarAxiosParamCreator = DiscordApiAxiosParamCreator(configuration);
    return {
        /**
         * Delete a Discord message. The bot must have sent the original message or have appropriate permissions. Returns an empty response on success.   Required permissions: `SEND_DISCORD_MESSAGE`<br> OperationId: `DiscordControllerDeleteMessage`
         * @summary Delete Discord message
         * @param {string} channelId
         * @param {string} messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discordControllerDeleteMessage(channelId, messageId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discordControllerDeleteMessage(channelId, messageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscordApi.discordControllerDeleteMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all channels (text, voice, etc.) in a specific Discord guild. Useful for selecting channels for notifications or commands.   Required permissions: `VIEW_DISCORD_INFO`<br> OperationId: `DiscordControllerGetChannels`
         * @summary Get guild channels
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discordControllerGetChannels(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discordControllerGetChannels(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscordApi.discordControllerGetChannels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the invite link to add the Takaro bot to a Discord server, along with the developer Discord server link.<br> OperationId: `DiscordControllerGetInvite`
         * @summary Get bot invite links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discordControllerGetInvite(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discordControllerGetInvite(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscordApi.discordControllerGetInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all roles available in a specific Discord guild. Useful for role-based integrations and permissions mapping.   Required permissions: `VIEW_DISCORD_INFO`<br> OperationId: `DiscordControllerGetRoles`
         * @summary Get guild roles
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discordControllerGetRoles(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discordControllerGetRoles(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscordApi.discordControllerGetRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for Discord guilds (servers) that the bot has access to. Supports filtering by name, Discord ID, and whether Takaro is enabled.   Required permissions: `VIEW_DISCORD_INFO`<br> OperationId: `DiscordControllerSearch`
         * @summary Search Discord guilds
         * @param {GuildSearchInputDTO} [guildSearchInputDTO] GuildSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discordControllerSearch(guildSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discordControllerSearch(guildSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscordApi.discordControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send a text message or rich embed to a specific Discord channel. Requires the bot to have appropriate permissions in the channel.   Required permissions: `SEND_DISCORD_MESSAGE`<br> OperationId: `DiscordControllerSendMessage`
         * @summary Send message to Discord channel
         * @param {string} id
         * @param {SendMessageInputDTO} [sendMessageInputDTO] SendMessageInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discordControllerSendMessage(id, sendMessageInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discordControllerSendMessage(id, sendMessageInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscordApi.discordControllerSendMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update Takaro-specific settings for a Discord guild, such as enabling or disabling Takaro features.   Required permissions: `MANAGE_SETTINGS`<br> OperationId: `DiscordControllerUpdateGuild`
         * @summary Update guild settings
         * @param {string} id
         * @param {GuildApiUpdateDTO} [guildApiUpdateDTO] GuildApiUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discordControllerUpdateGuild(id, guildApiUpdateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discordControllerUpdateGuild(id, guildApiUpdateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscordApi.discordControllerUpdateGuild']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Discord message with new content or embed. Requires the bot to have sent the original message.   Required permissions: `SEND_DISCORD_MESSAGE`<br> OperationId: `DiscordControllerUpdateMessage`
         * @summary Update Discord message
         * @param {string} channelId
         * @param {string} messageId
         * @param {SendMessageInputDTO} [sendMessageInputDTO] SendMessageInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discordControllerUpdateMessage(channelId, messageId, sendMessageInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discordControllerUpdateMessage(channelId, messageId, sendMessageInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscordApi.discordControllerUpdateMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * DiscordApi - factory interface
 * @export
 */
export const DiscordApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DiscordApiFp(configuration);
    return {
        /**
         * Delete a Discord message. The bot must have sent the original message or have appropriate permissions. Returns an empty response on success.   Required permissions: `SEND_DISCORD_MESSAGE`<br> OperationId: `DiscordControllerDeleteMessage`
         * @summary Delete Discord message
         * @param {string} channelId
         * @param {string} messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discordControllerDeleteMessage(channelId, messageId, options) {
            return localVarFp
                .discordControllerDeleteMessage(channelId, messageId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all channels (text, voice, etc.) in a specific Discord guild. Useful for selecting channels for notifications or commands.   Required permissions: `VIEW_DISCORD_INFO`<br> OperationId: `DiscordControllerGetChannels`
         * @summary Get guild channels
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discordControllerGetChannels(id, options) {
            return localVarFp.discordControllerGetChannels(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the invite link to add the Takaro bot to a Discord server, along with the developer Discord server link.<br> OperationId: `DiscordControllerGetInvite`
         * @summary Get bot invite links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discordControllerGetInvite(options) {
            return localVarFp.discordControllerGetInvite(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all roles available in a specific Discord guild. Useful for role-based integrations and permissions mapping.   Required permissions: `VIEW_DISCORD_INFO`<br> OperationId: `DiscordControllerGetRoles`
         * @summary Get guild roles
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discordControllerGetRoles(id, options) {
            return localVarFp.discordControllerGetRoles(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for Discord guilds (servers) that the bot has access to. Supports filtering by name, Discord ID, and whether Takaro is enabled.   Required permissions: `VIEW_DISCORD_INFO`<br> OperationId: `DiscordControllerSearch`
         * @summary Search Discord guilds
         * @param {GuildSearchInputDTO} [guildSearchInputDTO] GuildSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discordControllerSearch(guildSearchInputDTO, options) {
            return localVarFp
                .discordControllerSearch(guildSearchInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Send a text message or rich embed to a specific Discord channel. Requires the bot to have appropriate permissions in the channel.   Required permissions: `SEND_DISCORD_MESSAGE`<br> OperationId: `DiscordControllerSendMessage`
         * @summary Send message to Discord channel
         * @param {string} id
         * @param {SendMessageInputDTO} [sendMessageInputDTO] SendMessageInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discordControllerSendMessage(id, sendMessageInputDTO, options) {
            return localVarFp
                .discordControllerSendMessage(id, sendMessageInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update Takaro-specific settings for a Discord guild, such as enabling or disabling Takaro features.   Required permissions: `MANAGE_SETTINGS`<br> OperationId: `DiscordControllerUpdateGuild`
         * @summary Update guild settings
         * @param {string} id
         * @param {GuildApiUpdateDTO} [guildApiUpdateDTO] GuildApiUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discordControllerUpdateGuild(id, guildApiUpdateDTO, options) {
            return localVarFp
                .discordControllerUpdateGuild(id, guildApiUpdateDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Discord message with new content or embed. Requires the bot to have sent the original message.   Required permissions: `SEND_DISCORD_MESSAGE`<br> OperationId: `DiscordControllerUpdateMessage`
         * @summary Update Discord message
         * @param {string} channelId
         * @param {string} messageId
         * @param {SendMessageInputDTO} [sendMessageInputDTO] SendMessageInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discordControllerUpdateMessage(channelId, messageId, sendMessageInputDTO, options) {
            return localVarFp
                .discordControllerUpdateMessage(channelId, messageId, sendMessageInputDTO, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * DiscordApi - object-oriented interface
 * @export
 * @class DiscordApi
 * @extends {BaseAPI}
 */
export class DiscordApi extends BaseAPI {
    /**
     * Delete a Discord message. The bot must have sent the original message or have appropriate permissions. Returns an empty response on success.   Required permissions: `SEND_DISCORD_MESSAGE`<br> OperationId: `DiscordControllerDeleteMessage`
     * @summary Delete Discord message
     * @param {string} channelId
     * @param {string} messageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApi
     */
    discordControllerDeleteMessage(channelId, messageId, options) {
        return DiscordApiFp(this.configuration)
            .discordControllerDeleteMessage(channelId, messageId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve all channels (text, voice, etc.) in a specific Discord guild. Useful for selecting channels for notifications or commands.   Required permissions: `VIEW_DISCORD_INFO`<br> OperationId: `DiscordControllerGetChannels`
     * @summary Get guild channels
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApi
     */
    discordControllerGetChannels(id, options) {
        return DiscordApiFp(this.configuration)
            .discordControllerGetChannels(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the invite link to add the Takaro bot to a Discord server, along with the developer Discord server link.<br> OperationId: `DiscordControllerGetInvite`
     * @summary Get bot invite links
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApi
     */
    discordControllerGetInvite(options) {
        return DiscordApiFp(this.configuration)
            .discordControllerGetInvite(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve all roles available in a specific Discord guild. Useful for role-based integrations and permissions mapping.   Required permissions: `VIEW_DISCORD_INFO`<br> OperationId: `DiscordControllerGetRoles`
     * @summary Get guild roles
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApi
     */
    discordControllerGetRoles(id, options) {
        return DiscordApiFp(this.configuration)
            .discordControllerGetRoles(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search for Discord guilds (servers) that the bot has access to. Supports filtering by name, Discord ID, and whether Takaro is enabled.   Required permissions: `VIEW_DISCORD_INFO`<br> OperationId: `DiscordControllerSearch`
     * @summary Search Discord guilds
     * @param {GuildSearchInputDTO} [guildSearchInputDTO] GuildSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApi
     */
    discordControllerSearch(guildSearchInputDTO, options) {
        return DiscordApiFp(this.configuration)
            .discordControllerSearch(guildSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Send a text message or rich embed to a specific Discord channel. Requires the bot to have appropriate permissions in the channel.   Required permissions: `SEND_DISCORD_MESSAGE`<br> OperationId: `DiscordControllerSendMessage`
     * @summary Send message to Discord channel
     * @param {string} id
     * @param {SendMessageInputDTO} [sendMessageInputDTO] SendMessageInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApi
     */
    discordControllerSendMessage(id, sendMessageInputDTO, options) {
        return DiscordApiFp(this.configuration)
            .discordControllerSendMessage(id, sendMessageInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update Takaro-specific settings for a Discord guild, such as enabling or disabling Takaro features.   Required permissions: `MANAGE_SETTINGS`<br> OperationId: `DiscordControllerUpdateGuild`
     * @summary Update guild settings
     * @param {string} id
     * @param {GuildApiUpdateDTO} [guildApiUpdateDTO] GuildApiUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApi
     */
    discordControllerUpdateGuild(id, guildApiUpdateDTO, options) {
        return DiscordApiFp(this.configuration)
            .discordControllerUpdateGuild(id, guildApiUpdateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update an existing Discord message with new content or embed. Requires the bot to have sent the original message.   Required permissions: `SEND_DISCORD_MESSAGE`<br> OperationId: `DiscordControllerUpdateMessage`
     * @summary Update Discord message
     * @param {string} channelId
     * @param {string} messageId
     * @param {SendMessageInputDTO} [sendMessageInputDTO] SendMessageInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApi
     */
    discordControllerUpdateMessage(channelId, messageId, sendMessageInputDTO, options) {
        return DiscordApiFp(this.configuration)
            .discordControllerUpdateMessage(channelId, messageId, sendMessageInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DomainApi - axios parameter creator
 * @export
 */
export const DomainApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * <br> OperationId: `DomainControllerCreate`
         * @summary Create
         * @param {DomainCreateInputDTO} [domainCreateInputDTO] DomainCreateInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domainControllerCreate: async (domainCreateInputDTO, options = {}) => {
            const localVarPath = `/domain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication adminAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'x-takaro-admin-token', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(domainCreateInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <br> OperationId: `DomainControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domainControllerGetOne: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('domainControllerGetOne', 'id', id);
            const localVarPath = `/domain/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication adminAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'x-takaro-admin-token', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <br> OperationId: `DomainControllerGetToken`
         * @summary Get token
         * @param {TokenInputDTO} [tokenInputDTO] TokenInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domainControllerGetToken: async (tokenInputDTO, options = {}) => {
            const localVarPath = `/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication adminAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'x-takaro-admin-token', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(tokenInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <br> OperationId: `DomainControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domainControllerRemove: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('domainControllerRemove', 'id', id);
            const localVarPath = `/domain/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication adminAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'x-takaro-admin-token', configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <br> OperationId: `DomainControllerResolveRegistrationToken`
         * @summary Resolve registration token
         * @param {ResolveRegistrationTokenInputDTO} [resolveRegistrationTokenInputDTO] ResolveRegistrationTokenInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domainControllerResolveRegistrationToken: async (resolveRegistrationTokenInputDTO, options = {}) => {
            const localVarPath = `/resolve-registration-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication adminAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'x-takaro-admin-token', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(resolveRegistrationTokenInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <br> OperationId: `DomainControllerSearch`
         * @summary Search
         * @param {DomainSearchInputDTO} [domainSearchInputDTO] DomainSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domainControllerSearch: async (domainSearchInputDTO, options = {}) => {
            const localVarPath = `/domain/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication adminAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'x-takaro-admin-token', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(domainSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <br> OperationId: `DomainControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {DomainUpdateInputDTO} [domainUpdateInputDTO] DomainUpdateInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domainControllerUpdate: async (id, domainUpdateInputDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('domainControllerUpdate', 'id', id);
            const localVarPath = `/domain/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication adminAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'x-takaro-admin-token', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(domainUpdateInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DomainApi - functional programming interface
 * @export
 */
export const DomainApiFp = function (configuration) {
    const localVarAxiosParamCreator = DomainApiAxiosParamCreator(configuration);
    return {
        /**
         * <br> OperationId: `DomainControllerCreate`
         * @summary Create
         * @param {DomainCreateInputDTO} [domainCreateInputDTO] DomainCreateInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domainControllerCreate(domainCreateInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domainControllerCreate(domainCreateInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DomainApi.domainControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <br> OperationId: `DomainControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domainControllerGetOne(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domainControllerGetOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DomainApi.domainControllerGetOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <br> OperationId: `DomainControllerGetToken`
         * @summary Get token
         * @param {TokenInputDTO} [tokenInputDTO] TokenInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domainControllerGetToken(tokenInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domainControllerGetToken(tokenInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DomainApi.domainControllerGetToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <br> OperationId: `DomainControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domainControllerRemove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domainControllerRemove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DomainApi.domainControllerRemove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <br> OperationId: `DomainControllerResolveRegistrationToken`
         * @summary Resolve registration token
         * @param {ResolveRegistrationTokenInputDTO} [resolveRegistrationTokenInputDTO] ResolveRegistrationTokenInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domainControllerResolveRegistrationToken(resolveRegistrationTokenInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domainControllerResolveRegistrationToken(resolveRegistrationTokenInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DomainApi.domainControllerResolveRegistrationToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <br> OperationId: `DomainControllerSearch`
         * @summary Search
         * @param {DomainSearchInputDTO} [domainSearchInputDTO] DomainSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domainControllerSearch(domainSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domainControllerSearch(domainSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DomainApi.domainControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <br> OperationId: `DomainControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {DomainUpdateInputDTO} [domainUpdateInputDTO] DomainUpdateInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domainControllerUpdate(id, domainUpdateInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domainControllerUpdate(id, domainUpdateInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DomainApi.domainControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * DomainApi - factory interface
 * @export
 */
export const DomainApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DomainApiFp(configuration);
    return {
        /**
         * <br> OperationId: `DomainControllerCreate`
         * @summary Create
         * @param {DomainCreateInputDTO} [domainCreateInputDTO] DomainCreateInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domainControllerCreate(domainCreateInputDTO, options) {
            return localVarFp
                .domainControllerCreate(domainCreateInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * <br> OperationId: `DomainControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domainControllerGetOne(id, options) {
            return localVarFp.domainControllerGetOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * <br> OperationId: `DomainControllerGetToken`
         * @summary Get token
         * @param {TokenInputDTO} [tokenInputDTO] TokenInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domainControllerGetToken(tokenInputDTO, options) {
            return localVarFp.domainControllerGetToken(tokenInputDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * <br> OperationId: `DomainControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domainControllerRemove(id, options) {
            return localVarFp.domainControllerRemove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * <br> OperationId: `DomainControllerResolveRegistrationToken`
         * @summary Resolve registration token
         * @param {ResolveRegistrationTokenInputDTO} [resolveRegistrationTokenInputDTO] ResolveRegistrationTokenInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domainControllerResolveRegistrationToken(resolveRegistrationTokenInputDTO, options) {
            return localVarFp
                .domainControllerResolveRegistrationToken(resolveRegistrationTokenInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * <br> OperationId: `DomainControllerSearch`
         * @summary Search
         * @param {DomainSearchInputDTO} [domainSearchInputDTO] DomainSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domainControllerSearch(domainSearchInputDTO, options) {
            return localVarFp
                .domainControllerSearch(domainSearchInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * <br> OperationId: `DomainControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {DomainUpdateInputDTO} [domainUpdateInputDTO] DomainUpdateInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domainControllerUpdate(id, domainUpdateInputDTO, options) {
            return localVarFp
                .domainControllerUpdate(id, domainUpdateInputDTO, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * DomainApi - object-oriented interface
 * @export
 * @class DomainApi
 * @extends {BaseAPI}
 */
export class DomainApi extends BaseAPI {
    /**
     * <br> OperationId: `DomainControllerCreate`
     * @summary Create
     * @param {DomainCreateInputDTO} [domainCreateInputDTO] DomainCreateInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DomainApi
     */
    domainControllerCreate(domainCreateInputDTO, options) {
        return DomainApiFp(this.configuration)
            .domainControllerCreate(domainCreateInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * <br> OperationId: `DomainControllerGetOne`
     * @summary Get one
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DomainApi
     */
    domainControllerGetOne(id, options) {
        return DomainApiFp(this.configuration)
            .domainControllerGetOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * <br> OperationId: `DomainControllerGetToken`
     * @summary Get token
     * @param {TokenInputDTO} [tokenInputDTO] TokenInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DomainApi
     */
    domainControllerGetToken(tokenInputDTO, options) {
        return DomainApiFp(this.configuration)
            .domainControllerGetToken(tokenInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * <br> OperationId: `DomainControllerRemove`
     * @summary Remove
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DomainApi
     */
    domainControllerRemove(id, options) {
        return DomainApiFp(this.configuration)
            .domainControllerRemove(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * <br> OperationId: `DomainControllerResolveRegistrationToken`
     * @summary Resolve registration token
     * @param {ResolveRegistrationTokenInputDTO} [resolveRegistrationTokenInputDTO] ResolveRegistrationTokenInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DomainApi
     */
    domainControllerResolveRegistrationToken(resolveRegistrationTokenInputDTO, options) {
        return DomainApiFp(this.configuration)
            .domainControllerResolveRegistrationToken(resolveRegistrationTokenInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * <br> OperationId: `DomainControllerSearch`
     * @summary Search
     * @param {DomainSearchInputDTO} [domainSearchInputDTO] DomainSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DomainApi
     */
    domainControllerSearch(domainSearchInputDTO, options) {
        return DomainApiFp(this.configuration)
            .domainControllerSearch(domainSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * <br> OperationId: `DomainControllerUpdate`
     * @summary Update
     * @param {string} id
     * @param {DomainUpdateInputDTO} [domainUpdateInputDTO] DomainUpdateInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DomainApi
     */
    domainControllerUpdate(id, domainUpdateInputDTO, options) {
        return DomainApiFp(this.configuration)
            .domainControllerUpdate(id, domainUpdateInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EntityApi - axios parameter creator
 * @export
 */
export const EntityApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *    Required permissions: `READ_ENTITIES`<br> OperationId: `EntityControllerFindOne`
         * @summary Find one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entityControllerFindOne: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('entityControllerFindOne', 'id', id);
            const localVarPath = `/entities/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_ENTITIES`<br> OperationId: `EntityControllerSearch`
         * @summary Search
         * @param {EntitySearchInputDTO} [entitySearchInputDTO] EntitySearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entityControllerSearch: async (entitySearchInputDTO, options = {}) => {
            const localVarPath = `/entities/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(entitySearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EntityApi - functional programming interface
 * @export
 */
export const EntityApiFp = function (configuration) {
    const localVarAxiosParamCreator = EntityApiAxiosParamCreator(configuration);
    return {
        /**
         *    Required permissions: `READ_ENTITIES`<br> OperationId: `EntityControllerFindOne`
         * @summary Find one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async entityControllerFindOne(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.entityControllerFindOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.entityControllerFindOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_ENTITIES`<br> OperationId: `EntityControllerSearch`
         * @summary Search
         * @param {EntitySearchInputDTO} [entitySearchInputDTO] EntitySearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async entityControllerSearch(entitySearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.entityControllerSearch(entitySearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.entityControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EntityApi - factory interface
 * @export
 */
export const EntityApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EntityApiFp(configuration);
    return {
        /**
         *    Required permissions: `READ_ENTITIES`<br> OperationId: `EntityControllerFindOne`
         * @summary Find one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entityControllerFindOne(id, options) {
            return localVarFp.entityControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_ENTITIES`<br> OperationId: `EntityControllerSearch`
         * @summary Search
         * @param {EntitySearchInputDTO} [entitySearchInputDTO] EntitySearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entityControllerSearch(entitySearchInputDTO, options) {
            return localVarFp
                .entityControllerSearch(entitySearchInputDTO, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * EntityApi - object-oriented interface
 * @export
 * @class EntityApi
 * @extends {BaseAPI}
 */
export class EntityApi extends BaseAPI {
    /**
     *    Required permissions: `READ_ENTITIES`<br> OperationId: `EntityControllerFindOne`
     * @summary Find one
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    entityControllerFindOne(id, options) {
        return EntityApiFp(this.configuration)
            .entityControllerFindOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_ENTITIES`<br> OperationId: `EntityControllerSearch`
     * @summary Search
     * @param {EntitySearchInputDTO} [entitySearchInputDTO] EntitySearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    entityControllerSearch(entitySearchInputDTO, options) {
        return EntityApiFp(this.configuration)
            .entityControllerSearch(entitySearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EventApi - axios parameter creator
 * @export
 */
export const EventApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *    Required permissions: `MANAGE_EVENTS`<br> OperationId: `EventControllerCreate`
         * @summary Create
         * @param {EventCreateDTO} [eventCreateDTO] EventCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventControllerCreate: async (eventCreateDTO, options = {}) => {
            const localVarPath = `/event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(eventCreateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export events matching the search criteria to CSV format. Accepts the same parameters as the search endpoint. Maximum time range is 90 days.   Required permissions: `READ_EVENTS`<br> OperationId: `EventControllerExport`
         * @summary Export events to CSV
         * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventControllerExport: async (eventSearchInputDTO, options = {}) => {
            const localVarPath = `/event/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(eventSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches events where cronjob, hook and command failed. Supports all the common query parameters   Required permissions: `READ_MODULES`, `READ_EVENTS`<br> OperationId: `EventControllerGetFailedFunctions`
         * @summary Get failed functions
         * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventControllerGetFailedFunctions: async (eventSearchInputDTO, options = {}) => {
            const localVarPath = `/event/filter/failed-functions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(eventSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_EVENTS`<br> OperationId: `EventControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventControllerGetOne: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('eventControllerGetOne', 'id', id);
            const localVarPath = `/event/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search events   Required permissions: `READ_EVENTS`<br> OperationId: `EventControllerSearch`
         * @summary Search
         * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventControllerSearch: async (eventSearchInputDTO, options = {}) => {
            const localVarPath = `/event/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(eventSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EventApi - functional programming interface
 * @export
 */
export const EventApiFp = function (configuration) {
    const localVarAxiosParamCreator = EventApiAxiosParamCreator(configuration);
    return {
        /**
         *    Required permissions: `MANAGE_EVENTS`<br> OperationId: `EventControllerCreate`
         * @summary Create
         * @param {EventCreateDTO} [eventCreateDTO] EventCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventControllerCreate(eventCreateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventControllerCreate(eventCreateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventApi.eventControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export events matching the search criteria to CSV format. Accepts the same parameters as the search endpoint. Maximum time range is 90 days.   Required permissions: `READ_EVENTS`<br> OperationId: `EventControllerExport`
         * @summary Export events to CSV
         * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventControllerExport(eventSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventControllerExport(eventSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventApi.eventControllerExport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches events where cronjob, hook and command failed. Supports all the common query parameters   Required permissions: `READ_MODULES`, `READ_EVENTS`<br> OperationId: `EventControllerGetFailedFunctions`
         * @summary Get failed functions
         * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventControllerGetFailedFunctions(eventSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventControllerGetFailedFunctions(eventSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventApi.eventControllerGetFailedFunctions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_EVENTS`<br> OperationId: `EventControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventControllerGetOne(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventControllerGetOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventApi.eventControllerGetOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search events   Required permissions: `READ_EVENTS`<br> OperationId: `EventControllerSearch`
         * @summary Search
         * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventControllerSearch(eventSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventControllerSearch(eventSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventApi.eventControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EventApi - factory interface
 * @export
 */
export const EventApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EventApiFp(configuration);
    return {
        /**
         *    Required permissions: `MANAGE_EVENTS`<br> OperationId: `EventControllerCreate`
         * @summary Create
         * @param {EventCreateDTO} [eventCreateDTO] EventCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventControllerCreate(eventCreateDTO, options) {
            return localVarFp.eventControllerCreate(eventCreateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Export events matching the search criteria to CSV format. Accepts the same parameters as the search endpoint. Maximum time range is 90 days.   Required permissions: `READ_EVENTS`<br> OperationId: `EventControllerExport`
         * @summary Export events to CSV
         * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventControllerExport(eventSearchInputDTO, options) {
            return localVarFp.eventControllerExport(eventSearchInputDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches events where cronjob, hook and command failed. Supports all the common query parameters   Required permissions: `READ_MODULES`, `READ_EVENTS`<br> OperationId: `EventControllerGetFailedFunctions`
         * @summary Get failed functions
         * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventControllerGetFailedFunctions(eventSearchInputDTO, options) {
            return localVarFp
                .eventControllerGetFailedFunctions(eventSearchInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_EVENTS`<br> OperationId: `EventControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventControllerGetOne(id, options) {
            return localVarFp.eventControllerGetOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Search events   Required permissions: `READ_EVENTS`<br> OperationId: `EventControllerSearch`
         * @summary Search
         * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventControllerSearch(eventSearchInputDTO, options) {
            return localVarFp.eventControllerSearch(eventSearchInputDTO, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EventApi - object-oriented interface
 * @export
 * @class EventApi
 * @extends {BaseAPI}
 */
export class EventApi extends BaseAPI {
    /**
     *    Required permissions: `MANAGE_EVENTS`<br> OperationId: `EventControllerCreate`
     * @summary Create
     * @param {EventCreateDTO} [eventCreateDTO] EventCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    eventControllerCreate(eventCreateDTO, options) {
        return EventApiFp(this.configuration)
            .eventControllerCreate(eventCreateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Export events matching the search criteria to CSV format. Accepts the same parameters as the search endpoint. Maximum time range is 90 days.   Required permissions: `READ_EVENTS`<br> OperationId: `EventControllerExport`
     * @summary Export events to CSV
     * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    eventControllerExport(eventSearchInputDTO, options) {
        return EventApiFp(this.configuration)
            .eventControllerExport(eventSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Fetches events where cronjob, hook and command failed. Supports all the common query parameters   Required permissions: `READ_MODULES`, `READ_EVENTS`<br> OperationId: `EventControllerGetFailedFunctions`
     * @summary Get failed functions
     * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    eventControllerGetFailedFunctions(eventSearchInputDTO, options) {
        return EventApiFp(this.configuration)
            .eventControllerGetFailedFunctions(eventSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_EVENTS`<br> OperationId: `EventControllerGetOne`
     * @summary Get one
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    eventControllerGetOne(id, options) {
        return EventApiFp(this.configuration)
            .eventControllerGetOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search events   Required permissions: `READ_EVENTS`<br> OperationId: `EventControllerSearch`
     * @summary Search
     * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    eventControllerSearch(eventSearchInputDTO, options) {
        return EventApiFp(this.configuration)
            .eventControllerSearch(eventSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ExternalAuthApi - axios parameter creator
 * @export
 */
export const ExternalAuthApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * <br> OperationId: `ExternalAuthControllerAuthDiscord`
         * @summary Auth discord
         * @param {string} redirect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalAuthControllerAuthDiscord: async (redirect, options = {}) => {
            // verify required parameter 'redirect' is not null or undefined
            assertParamExists('externalAuthControllerAuthDiscord', 'redirect', redirect);
            const localVarPath = `/auth/discord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (redirect !== undefined) {
                localVarQueryParameter['redirect'] = redirect;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <br> OperationId: `ExternalAuthControllerAuthDiscordReturn`
         * @summary Auth discord return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalAuthControllerAuthDiscordReturn: async (options = {}) => {
            const localVarPath = `/auth/discord/return`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ExternalAuthApi - functional programming interface
 * @export
 */
export const ExternalAuthApiFp = function (configuration) {
    const localVarAxiosParamCreator = ExternalAuthApiAxiosParamCreator(configuration);
    return {
        /**
         * <br> OperationId: `ExternalAuthControllerAuthDiscord`
         * @summary Auth discord
         * @param {string} redirect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalAuthControllerAuthDiscord(redirect, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalAuthControllerAuthDiscord(redirect, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalAuthApi.externalAuthControllerAuthDiscord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <br> OperationId: `ExternalAuthControllerAuthDiscordReturn`
         * @summary Auth discord return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalAuthControllerAuthDiscordReturn(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalAuthControllerAuthDiscordReturn(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalAuthApi.externalAuthControllerAuthDiscordReturn']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ExternalAuthApi - factory interface
 * @export
 */
export const ExternalAuthApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ExternalAuthApiFp(configuration);
    return {
        /**
         * <br> OperationId: `ExternalAuthControllerAuthDiscord`
         * @summary Auth discord
         * @param {string} redirect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalAuthControllerAuthDiscord(redirect, options) {
            return localVarFp
                .externalAuthControllerAuthDiscord(redirect, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * <br> OperationId: `ExternalAuthControllerAuthDiscordReturn`
         * @summary Auth discord return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalAuthControllerAuthDiscordReturn(options) {
            return localVarFp.externalAuthControllerAuthDiscordReturn(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ExternalAuthApi - object-oriented interface
 * @export
 * @class ExternalAuthApi
 * @extends {BaseAPI}
 */
export class ExternalAuthApi extends BaseAPI {
    /**
     * <br> OperationId: `ExternalAuthControllerAuthDiscord`
     * @summary Auth discord
     * @param {string} redirect
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalAuthApi
     */
    externalAuthControllerAuthDiscord(redirect, options) {
        return ExternalAuthApiFp(this.configuration)
            .externalAuthControllerAuthDiscord(redirect, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * <br> OperationId: `ExternalAuthControllerAuthDiscordReturn`
     * @summary Auth discord return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalAuthApi
     */
    externalAuthControllerAuthDiscordReturn(options) {
        return ExternalAuthApiFp(this.configuration)
            .externalAuthControllerAuthDiscordReturn(options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FunctionApi - axios parameter creator
 * @export
 */
export const FunctionApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `FunctionControllerCreate`
         * @summary Create
         * @param {FunctionCreateDTO} [functionCreateDTO] FunctionCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        functionControllerCreate: async (functionCreateDTO, options = {}) => {
            const localVarPath = `/function`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(functionCreateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `FunctionControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        functionControllerGetOne: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('functionControllerGetOne', 'id', id);
            const localVarPath = `/function/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `FunctionControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        functionControllerRemove: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('functionControllerRemove', 'id', id);
            const localVarPath = `/function/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search functions   Required permissions: `READ_MODULES`<br> OperationId: `FunctionControllerSearch`
         * @summary Search
         * @param {FunctionSearchInputDTO} [functionSearchInputDTO] FunctionSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        functionControllerSearch: async (functionSearchInputDTO, options = {}) => {
            const localVarPath = `/function/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(functionSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `FunctionControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {FunctionUpdateDTO} [functionUpdateDTO] FunctionUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        functionControllerUpdate: async (id, functionUpdateDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('functionControllerUpdate', 'id', id);
            const localVarPath = `/function/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(functionUpdateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FunctionApi - functional programming interface
 * @export
 */
export const FunctionApiFp = function (configuration) {
    const localVarAxiosParamCreator = FunctionApiAxiosParamCreator(configuration);
    return {
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `FunctionControllerCreate`
         * @summary Create
         * @param {FunctionCreateDTO} [functionCreateDTO] FunctionCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async functionControllerCreate(functionCreateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.functionControllerCreate(functionCreateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FunctionApi.functionControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `FunctionControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async functionControllerGetOne(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.functionControllerGetOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FunctionApi.functionControllerGetOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `FunctionControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async functionControllerRemove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.functionControllerRemove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FunctionApi.functionControllerRemove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search functions   Required permissions: `READ_MODULES`<br> OperationId: `FunctionControllerSearch`
         * @summary Search
         * @param {FunctionSearchInputDTO} [functionSearchInputDTO] FunctionSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async functionControllerSearch(functionSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.functionControllerSearch(functionSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FunctionApi.functionControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `FunctionControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {FunctionUpdateDTO} [functionUpdateDTO] FunctionUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async functionControllerUpdate(id, functionUpdateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.functionControllerUpdate(id, functionUpdateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FunctionApi.functionControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * FunctionApi - factory interface
 * @export
 */
export const FunctionApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FunctionApiFp(configuration);
    return {
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `FunctionControllerCreate`
         * @summary Create
         * @param {FunctionCreateDTO} [functionCreateDTO] FunctionCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        functionControllerCreate(functionCreateDTO, options) {
            return localVarFp
                .functionControllerCreate(functionCreateDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `FunctionControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        functionControllerGetOne(id, options) {
            return localVarFp.functionControllerGetOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `FunctionControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        functionControllerRemove(id, options) {
            return localVarFp.functionControllerRemove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Search functions   Required permissions: `READ_MODULES`<br> OperationId: `FunctionControllerSearch`
         * @summary Search
         * @param {FunctionSearchInputDTO} [functionSearchInputDTO] FunctionSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        functionControllerSearch(functionSearchInputDTO, options) {
            return localVarFp
                .functionControllerSearch(functionSearchInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `FunctionControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {FunctionUpdateDTO} [functionUpdateDTO] FunctionUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        functionControllerUpdate(id, functionUpdateDTO, options) {
            return localVarFp
                .functionControllerUpdate(id, functionUpdateDTO, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * FunctionApi - object-oriented interface
 * @export
 * @class FunctionApi
 * @extends {BaseAPI}
 */
export class FunctionApi extends BaseAPI {
    /**
     *    Required permissions: `MANAGE_MODULES`<br> OperationId: `FunctionControllerCreate`
     * @summary Create
     * @param {FunctionCreateDTO} [functionCreateDTO] FunctionCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FunctionApi
     */
    functionControllerCreate(functionCreateDTO, options) {
        return FunctionApiFp(this.configuration)
            .functionControllerCreate(functionCreateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_MODULES`<br> OperationId: `FunctionControllerGetOne`
     * @summary Get one
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FunctionApi
     */
    functionControllerGetOne(id, options) {
        return FunctionApiFp(this.configuration)
            .functionControllerGetOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_MODULES`<br> OperationId: `FunctionControllerRemove`
     * @summary Remove
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FunctionApi
     */
    functionControllerRemove(id, options) {
        return FunctionApiFp(this.configuration)
            .functionControllerRemove(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search functions   Required permissions: `READ_MODULES`<br> OperationId: `FunctionControllerSearch`
     * @summary Search
     * @param {FunctionSearchInputDTO} [functionSearchInputDTO] FunctionSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FunctionApi
     */
    functionControllerSearch(functionSearchInputDTO, options) {
        return FunctionApiFp(this.configuration)
            .functionControllerSearch(functionSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_MODULES`<br> OperationId: `FunctionControllerUpdate`
     * @summary Update
     * @param {string} id
     * @param {FunctionUpdateDTO} [functionUpdateDTO] FunctionUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FunctionApi
     */
    functionControllerUpdate(id, functionUpdateDTO, options) {
        return FunctionApiFp(this.configuration)
            .functionControllerUpdate(id, functionUpdateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * GameServerApi - axios parameter creator
 * @export
 */
export const GameServerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Ban a player from a gameserver. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerBanPlayer`
         * @summary Ban player
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {BanPlayerInputDTO} [banPlayerInputDTO] BanPlayerInputDTO
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        gameServerControllerBanPlayer: async (gameServerId, playerId, banPlayerInputDTO, options = {}) => {
            // verify required parameter 'gameServerId' is not null or undefined
            assertParamExists('gameServerControllerBanPlayer', 'gameServerId', gameServerId);
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('gameServerControllerBanPlayer', 'playerId', playerId);
            const localVarPath = `/gameserver/{gameServerId}/player/{playerId}/ban`
                .replace(`{${'gameServerId'}}`, encodeURIComponent(String(gameServerId)))
                .replace(`{${'playerId'}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(banPlayerInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a gameserver   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerCreate`
         * @summary Create
         * @param {GameServerCreateDTO} [gameServerCreateDTO] GameServerCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerCreate: async (gameServerCreateDTO, options = {}) => {
            const localVarPath = `/gameserver`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(gameServerCreateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Execute a raw command on a gameserver. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerExecuteCommand`
         * @summary Execute command
         * @param {string} id
         * @param {CommandExecuteInputDTO} [commandExecuteInputDTO] CommandExecuteInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerExecuteCommand: async (id, commandExecuteInputDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gameServerControllerExecuteCommand', 'id', id);
            const localVarPath = `/gameserver/{id}/command`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(commandExecuteInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch status of an import from CSMM   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerGetImport`
         * @summary Get import
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        gameServerControllerGetImport: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gameServerControllerGetImport', 'id', id);
            const localVarPath = `/gameserver/import/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a job status   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerGetJob`
         * @summary Get job
         * @param {string} type
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerGetJob: async (type, id, options = {}) => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('gameServerControllerGetJob', 'type', type);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gameServerControllerGetJob', 'id', id);
            const localVarPath = `/gameserver/job/{type}/{id}`
                .replace(`{${'type'}}`, encodeURIComponent(String(type)))
                .replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get map metadata<br> OperationId: `GameServerControllerGetMapInfo`
         * @summary Get map info
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerGetMapInfo: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gameServerControllerGetMapInfo', 'id', id);
            const localVarPath = `/gameserver/{id}/map/info`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a map tile<br> OperationId: `GameServerControllerGetMapTile`
         * @summary Get map tile
         * @param {string} id
         * @param {string} x
         * @param {string} y
         * @param {string} z
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerGetMapTile: async (id, x, y, z, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gameServerControllerGetMapTile', 'id', id);
            // verify required parameter 'x' is not null or undefined
            assertParamExists('gameServerControllerGetMapTile', 'x', x);
            // verify required parameter 'y' is not null or undefined
            assertParamExists('gameServerControllerGetMapTile', 'y', y);
            // verify required parameter 'z' is not null or undefined
            assertParamExists('gameServerControllerGetMapTile', 'z', z);
            const localVarPath = `/gameserver/{id}/map/tile/{x}/{y}/{z}`
                .replace(`{${'id'}}`, encodeURIComponent(String(id)))
                .replace(`{${'x'}}`, encodeURIComponent(String(x)))
                .replace(`{${'y'}}`, encodeURIComponent(String(y)))
                .replace(`{${'z'}}`, encodeURIComponent(String(z)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a gameserver by id<br> OperationId: `GameServerControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerGetOne: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gameServerControllerGetOne', 'id', id);
            const localVarPath = `/gameserver/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of players on a gameserver. Requires gameserver to be online and reachable. Please use the Player on GameServer (PoG) search endpoint instead: `POST /gameserver/player/search` for more flexible filtering, sorting, and pagination options.   Required permissions: `READ_PLAYERS`<br> OperationId: `GameServerControllerGetPlayers`
         * @summary Get players
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        gameServerControllerGetPlayers: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gameServerControllerGetPlayers', 'id', id);
            const localVarPath = `/gameserver/{id}/players`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch gameserver types (7dtd, Rust, ...)<br> OperationId: `GameServerControllerGetTypes`
         * @summary Get types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerGetTypes: async (options = {}) => {
            const localVarPath = `/gameserver/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Give an item to a player. Accepts item UUID (preferred) or item code. Requires gameserver to be online and reachable. Depending on the underlying game implementation, it\'s possible that the item is dropped on the ground instead of placed directly in the player\'s inventory.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerGiveItem`
         * @summary Give item
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {GiveItemInputDTO} [giveItemInputDTO] GiveItemInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerGiveItem: async (gameServerId, playerId, giveItemInputDTO, options = {}) => {
            // verify required parameter 'gameServerId' is not null or undefined
            assertParamExists('gameServerControllerGiveItem', 'gameServerId', gameServerId);
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('gameServerControllerGiveItem', 'playerId', playerId);
            const localVarPath = `/gameserver/{gameServerId}/player/{playerId}/giveItem`
                .replace(`{${'gameServerId'}}`, encodeURIComponent(String(gameServerId)))
                .replace(`{${'playerId'}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(giveItemInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import a gameserver from CSMM.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerImportFromCSMM`
         * @summary Import from csmm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerImportFromCSMM: async (options = {}) => {
            const localVarPath = `/gameserver/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Kick a player from a gameserver. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerKickPlayer`
         * @summary Kick player
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {KickPlayerInputDTO} [kickPlayerInputDTO] KickPlayerInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerKickPlayer: async (gameServerId, playerId, kickPlayerInputDTO, options = {}) => {
            // verify required parameter 'gameServerId' is not null or undefined
            assertParamExists('gameServerControllerKickPlayer', 'gameServerId', gameServerId);
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('gameServerControllerKickPlayer', 'playerId', playerId);
            const localVarPath = `/gameserver/{gameServerId}/player/{playerId}/kick`
                .replace(`{${'gameServerId'}}`, encodeURIComponent(String(gameServerId)))
                .replace(`{${'playerId'}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(kickPlayerInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List bans for a gameserver. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerListBans`
         * @summary List bans
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        gameServerControllerListBans: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gameServerControllerListBans', 'id', id);
            const localVarPath = `/gameserver/{id}/bans`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Regenerate the registration token for a gameserver. Careful, this will invalidate all existing connections.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerRegenerateRegistrationToken`
         * @summary Regenerate registration token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerRegenerateRegistrationToken: async (options = {}) => {
            const localVarPath = `/gameserver/registrationToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a gameserver   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerRemove: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gameServerControllerRemove', 'id', id);
            const localVarPath = `/gameserver/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resets all players\' currency to 0 on the specified game server. This action is irreversible.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerResetCurrency`
         * @summary Reset currency
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerResetCurrency: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gameServerControllerResetCurrency', 'id', id);
            const localVarPath = `/gameserver/{id}/reset-currency`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch gameservers<br> OperationId: `GameServerControllerSearch`
         * @summary Search
         * @param {GameServerSearchInputDTO} [gameServerSearchInputDTO] GameServerSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerSearch: async (gameServerSearchInputDTO, options = {}) => {
            const localVarPath = `/gameserver/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(gameServerSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send a message in gameserver chat. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerSendMessage`
         * @summary Send message
         * @param {string} id
         * @param {MessageSendInputDTO} [messageSendInputDTO] MessageSendInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerSendMessage: async (id, messageSendInputDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gameServerControllerSendMessage', 'id', id);
            const localVarPath = `/gameserver/{id}/message`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(messageSendInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Shuts down the gameserver. This is a \'soft\' shutdown, meaning the gameserver will be stopped gracefully. If the gameserver is not reachable, this will have no effect. Note that most hosting providers will automatically restart the gameserver after a shutdown, which makes this operation act as a \'restart\' instead.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerShutdown`
         * @summary Shutdown
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerShutdown: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gameServerControllerShutdown', 'id', id);
            const localVarPath = `/gameserver/{id}/shutdown`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Teleport a player to a location. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerTeleportPlayer`
         * @summary Teleport player
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {TeleportPlayerInputDTO} [teleportPlayerInputDTO] TeleportPlayerInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerTeleportPlayer: async (gameServerId, playerId, teleportPlayerInputDTO, options = {}) => {
            // verify required parameter 'gameServerId' is not null or undefined
            assertParamExists('gameServerControllerTeleportPlayer', 'gameServerId', gameServerId);
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('gameServerControllerTeleportPlayer', 'playerId', playerId);
            const localVarPath = `/gameserver/{gameServerId}/player/{playerId}/teleport`
                .replace(`{${'gameServerId'}}`, encodeURIComponent(String(gameServerId)))
                .replace(`{${'playerId'}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(teleportPlayerInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Test if Takaro can connect to a gameserver. Will do a thorough check and report details.<br> OperationId: `GameServerControllerTestReachability`
         * @summary Test reachability
         * @param {GameServerTestReachabilityInputDTO} [gameServerTestReachabilityInputDTO] GameServerTestReachabilityInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerTestReachability: async (gameServerTestReachabilityInputDTO, options = {}) => {
            const localVarPath = `/gameserver/reachability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(gameServerTestReachabilityInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Test if Takaro can connect to a gameserver. Will do a thorough check and report details.<br> OperationId: `GameServerControllerTestReachabilityForId`
         * @summary Test reachability for id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerTestReachabilityForId: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gameServerControllerTestReachabilityForId', 'id', id);
            const localVarPath = `/gameserver/{id}/reachability`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Manually trigger a job, you can poll the status with the GET endpoint   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerTriggerJob`
         * @summary Trigger job
         * @param {string} type
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerTriggerJob: async (type, id, options = {}) => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('gameServerControllerTriggerJob', 'type', type);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gameServerControllerTriggerJob', 'id', id);
            const localVarPath = `/gameserver/job/{type}/{id}`
                .replace(`{${'type'}}`, encodeURIComponent(String(type)))
                .replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unban a player from a gameserver. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerUnbanPlayer`
         * @summary Unban player
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        gameServerControllerUnbanPlayer: async (gameServerId, playerId, options = {}) => {
            // verify required parameter 'gameServerId' is not null or undefined
            assertParamExists('gameServerControllerUnbanPlayer', 'gameServerId', gameServerId);
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('gameServerControllerUnbanPlayer', 'playerId', playerId);
            const localVarPath = `/gameserver/{gameServerId}/player/{playerId}/unban`
                .replace(`{${'gameServerId'}}`, encodeURIComponent(String(gameServerId)))
                .replace(`{${'playerId'}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a gameserver   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {GameServerUpdateDTO} [gameServerUpdateDTO] GameServerUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerUpdate: async (id, gameServerUpdateDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gameServerControllerUpdate', 'id', id);
            const localVarPath = `/gameserver/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(gameServerUpdateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * GameServerApi - functional programming interface
 * @export
 */
export const GameServerApiFp = function (configuration) {
    const localVarAxiosParamCreator = GameServerApiAxiosParamCreator(configuration);
    return {
        /**
         * Ban a player from a gameserver. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerBanPlayer`
         * @summary Ban player
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {BanPlayerInputDTO} [banPlayerInputDTO] BanPlayerInputDTO
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async gameServerControllerBanPlayer(gameServerId, playerId, banPlayerInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerBanPlayer(gameServerId, playerId, banPlayerInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerBanPlayer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a gameserver   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerCreate`
         * @summary Create
         * @param {GameServerCreateDTO} [gameServerCreateDTO] GameServerCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameServerControllerCreate(gameServerCreateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerCreate(gameServerCreateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Execute a raw command on a gameserver. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerExecuteCommand`
         * @summary Execute command
         * @param {string} id
         * @param {CommandExecuteInputDTO} [commandExecuteInputDTO] CommandExecuteInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameServerControllerExecuteCommand(id, commandExecuteInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerExecuteCommand(id, commandExecuteInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerExecuteCommand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch status of an import from CSMM   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerGetImport`
         * @summary Get import
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async gameServerControllerGetImport(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerGetImport(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerGetImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch a job status   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerGetJob`
         * @summary Get job
         * @param {string} type
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameServerControllerGetJob(type, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerGetJob(type, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerGetJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get map metadata<br> OperationId: `GameServerControllerGetMapInfo`
         * @summary Get map info
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameServerControllerGetMapInfo(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerGetMapInfo(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerGetMapInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a map tile<br> OperationId: `GameServerControllerGetMapTile`
         * @summary Get map tile
         * @param {string} id
         * @param {string} x
         * @param {string} y
         * @param {string} z
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameServerControllerGetMapTile(id, x, y, z, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerGetMapTile(id, x, y, z, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerGetMapTile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch a gameserver by id<br> OperationId: `GameServerControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameServerControllerGetOne(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerGetOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerGetOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch a list of players on a gameserver. Requires gameserver to be online and reachable. Please use the Player on GameServer (PoG) search endpoint instead: `POST /gameserver/player/search` for more flexible filtering, sorting, and pagination options.   Required permissions: `READ_PLAYERS`<br> OperationId: `GameServerControllerGetPlayers`
         * @summary Get players
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async gameServerControllerGetPlayers(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerGetPlayers(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerGetPlayers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch gameserver types (7dtd, Rust, ...)<br> OperationId: `GameServerControllerGetTypes`
         * @summary Get types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameServerControllerGetTypes(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerGetTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerGetTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Give an item to a player. Accepts item UUID (preferred) or item code. Requires gameserver to be online and reachable. Depending on the underlying game implementation, it\'s possible that the item is dropped on the ground instead of placed directly in the player\'s inventory.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerGiveItem`
         * @summary Give item
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {GiveItemInputDTO} [giveItemInputDTO] GiveItemInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameServerControllerGiveItem(gameServerId, playerId, giveItemInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerGiveItem(gameServerId, playerId, giveItemInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerGiveItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import a gameserver from CSMM.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerImportFromCSMM`
         * @summary Import from csmm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameServerControllerImportFromCSMM(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerImportFromCSMM(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerImportFromCSMM']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Kick a player from a gameserver. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerKickPlayer`
         * @summary Kick player
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {KickPlayerInputDTO} [kickPlayerInputDTO] KickPlayerInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameServerControllerKickPlayer(gameServerId, playerId, kickPlayerInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerKickPlayer(gameServerId, playerId, kickPlayerInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerKickPlayer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List bans for a gameserver. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerListBans`
         * @summary List bans
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async gameServerControllerListBans(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerListBans(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerListBans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Regenerate the registration token for a gameserver. Careful, this will invalidate all existing connections.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerRegenerateRegistrationToken`
         * @summary Regenerate registration token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameServerControllerRegenerateRegistrationToken(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerRegenerateRegistrationToken(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerRegenerateRegistrationToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a gameserver   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameServerControllerRemove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerRemove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerRemove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resets all players\' currency to 0 on the specified game server. This action is irreversible.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerResetCurrency`
         * @summary Reset currency
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameServerControllerResetCurrency(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerResetCurrency(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerResetCurrency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch gameservers<br> OperationId: `GameServerControllerSearch`
         * @summary Search
         * @param {GameServerSearchInputDTO} [gameServerSearchInputDTO] GameServerSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameServerControllerSearch(gameServerSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerSearch(gameServerSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send a message in gameserver chat. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerSendMessage`
         * @summary Send message
         * @param {string} id
         * @param {MessageSendInputDTO} [messageSendInputDTO] MessageSendInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameServerControllerSendMessage(id, messageSendInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerSendMessage(id, messageSendInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerSendMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Shuts down the gameserver. This is a \'soft\' shutdown, meaning the gameserver will be stopped gracefully. If the gameserver is not reachable, this will have no effect. Note that most hosting providers will automatically restart the gameserver after a shutdown, which makes this operation act as a \'restart\' instead.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerShutdown`
         * @summary Shutdown
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameServerControllerShutdown(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerShutdown(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerShutdown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Teleport a player to a location. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerTeleportPlayer`
         * @summary Teleport player
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {TeleportPlayerInputDTO} [teleportPlayerInputDTO] TeleportPlayerInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameServerControllerTeleportPlayer(gameServerId, playerId, teleportPlayerInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerTeleportPlayer(gameServerId, playerId, teleportPlayerInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerTeleportPlayer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Test if Takaro can connect to a gameserver. Will do a thorough check and report details.<br> OperationId: `GameServerControllerTestReachability`
         * @summary Test reachability
         * @param {GameServerTestReachabilityInputDTO} [gameServerTestReachabilityInputDTO] GameServerTestReachabilityInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameServerControllerTestReachability(gameServerTestReachabilityInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerTestReachability(gameServerTestReachabilityInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerTestReachability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Test if Takaro can connect to a gameserver. Will do a thorough check and report details.<br> OperationId: `GameServerControllerTestReachabilityForId`
         * @summary Test reachability for id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameServerControllerTestReachabilityForId(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerTestReachabilityForId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerTestReachabilityForId']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Manually trigger a job, you can poll the status with the GET endpoint   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerTriggerJob`
         * @summary Trigger job
         * @param {string} type
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameServerControllerTriggerJob(type, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerTriggerJob(type, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerTriggerJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unban a player from a gameserver. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerUnbanPlayer`
         * @summary Unban player
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async gameServerControllerUnbanPlayer(gameServerId, playerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerUnbanPlayer(gameServerId, playerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerUnbanPlayer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a gameserver   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {GameServerUpdateDTO} [gameServerUpdateDTO] GameServerUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameServerControllerUpdate(id, gameServerUpdateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gameServerControllerUpdate(id, gameServerUpdateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GameServerApi.gameServerControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * GameServerApi - factory interface
 * @export
 */
export const GameServerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = GameServerApiFp(configuration);
    return {
        /**
         * Ban a player from a gameserver. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerBanPlayer`
         * @summary Ban player
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {BanPlayerInputDTO} [banPlayerInputDTO] BanPlayerInputDTO
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        gameServerControllerBanPlayer(gameServerId, playerId, banPlayerInputDTO, options) {
            return localVarFp
                .gameServerControllerBanPlayer(gameServerId, playerId, banPlayerInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a gameserver   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerCreate`
         * @summary Create
         * @param {GameServerCreateDTO} [gameServerCreateDTO] GameServerCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerCreate(gameServerCreateDTO, options) {
            return localVarFp
                .gameServerControllerCreate(gameServerCreateDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Execute a raw command on a gameserver. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerExecuteCommand`
         * @summary Execute command
         * @param {string} id
         * @param {CommandExecuteInputDTO} [commandExecuteInputDTO] CommandExecuteInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerExecuteCommand(id, commandExecuteInputDTO, options) {
            return localVarFp
                .gameServerControllerExecuteCommand(id, commandExecuteInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Fetch status of an import from CSMM   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerGetImport`
         * @summary Get import
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        gameServerControllerGetImport(id, options) {
            return localVarFp.gameServerControllerGetImport(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch a job status   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerGetJob`
         * @summary Get job
         * @param {string} type
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerGetJob(type, id, options) {
            return localVarFp.gameServerControllerGetJob(type, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get map metadata<br> OperationId: `GameServerControllerGetMapInfo`
         * @summary Get map info
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerGetMapInfo(id, options) {
            return localVarFp.gameServerControllerGetMapInfo(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a map tile<br> OperationId: `GameServerControllerGetMapTile`
         * @summary Get map tile
         * @param {string} id
         * @param {string} x
         * @param {string} y
         * @param {string} z
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerGetMapTile(id, x, y, z, options) {
            return localVarFp
                .gameServerControllerGetMapTile(id, x, y, z, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Fetch a gameserver by id<br> OperationId: `GameServerControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerGetOne(id, options) {
            return localVarFp.gameServerControllerGetOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch a list of players on a gameserver. Requires gameserver to be online and reachable. Please use the Player on GameServer (PoG) search endpoint instead: `POST /gameserver/player/search` for more flexible filtering, sorting, and pagination options.   Required permissions: `READ_PLAYERS`<br> OperationId: `GameServerControllerGetPlayers`
         * @summary Get players
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        gameServerControllerGetPlayers(id, options) {
            return localVarFp.gameServerControllerGetPlayers(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch gameserver types (7dtd, Rust, ...)<br> OperationId: `GameServerControllerGetTypes`
         * @summary Get types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerGetTypes(options) {
            return localVarFp.gameServerControllerGetTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * Give an item to a player. Accepts item UUID (preferred) or item code. Requires gameserver to be online and reachable. Depending on the underlying game implementation, it\'s possible that the item is dropped on the ground instead of placed directly in the player\'s inventory.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerGiveItem`
         * @summary Give item
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {GiveItemInputDTO} [giveItemInputDTO] GiveItemInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerGiveItem(gameServerId, playerId, giveItemInputDTO, options) {
            return localVarFp
                .gameServerControllerGiveItem(gameServerId, playerId, giveItemInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Import a gameserver from CSMM.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerImportFromCSMM`
         * @summary Import from csmm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerImportFromCSMM(options) {
            return localVarFp.gameServerControllerImportFromCSMM(options).then((request) => request(axios, basePath));
        },
        /**
         * Kick a player from a gameserver. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerKickPlayer`
         * @summary Kick player
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {KickPlayerInputDTO} [kickPlayerInputDTO] KickPlayerInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerKickPlayer(gameServerId, playerId, kickPlayerInputDTO, options) {
            return localVarFp
                .gameServerControllerKickPlayer(gameServerId, playerId, kickPlayerInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * List bans for a gameserver. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerListBans`
         * @summary List bans
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        gameServerControllerListBans(id, options) {
            return localVarFp.gameServerControllerListBans(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Regenerate the registration token for a gameserver. Careful, this will invalidate all existing connections.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerRegenerateRegistrationToken`
         * @summary Regenerate registration token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerRegenerateRegistrationToken(options) {
            return localVarFp
                .gameServerControllerRegenerateRegistrationToken(options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Delete a gameserver   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerRemove(id, options) {
            return localVarFp.gameServerControllerRemove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Resets all players\' currency to 0 on the specified game server. This action is irreversible.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerResetCurrency`
         * @summary Reset currency
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerResetCurrency(id, options) {
            return localVarFp.gameServerControllerResetCurrency(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch gameservers<br> OperationId: `GameServerControllerSearch`
         * @summary Search
         * @param {GameServerSearchInputDTO} [gameServerSearchInputDTO] GameServerSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerSearch(gameServerSearchInputDTO, options) {
            return localVarFp
                .gameServerControllerSearch(gameServerSearchInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Send a message in gameserver chat. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerSendMessage`
         * @summary Send message
         * @param {string} id
         * @param {MessageSendInputDTO} [messageSendInputDTO] MessageSendInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerSendMessage(id, messageSendInputDTO, options) {
            return localVarFp
                .gameServerControllerSendMessage(id, messageSendInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Shuts down the gameserver. This is a \'soft\' shutdown, meaning the gameserver will be stopped gracefully. If the gameserver is not reachable, this will have no effect. Note that most hosting providers will automatically restart the gameserver after a shutdown, which makes this operation act as a \'restart\' instead.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerShutdown`
         * @summary Shutdown
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerShutdown(id, options) {
            return localVarFp.gameServerControllerShutdown(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Teleport a player to a location. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerTeleportPlayer`
         * @summary Teleport player
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {TeleportPlayerInputDTO} [teleportPlayerInputDTO] TeleportPlayerInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerTeleportPlayer(gameServerId, playerId, teleportPlayerInputDTO, options) {
            return localVarFp
                .gameServerControllerTeleportPlayer(gameServerId, playerId, teleportPlayerInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Test if Takaro can connect to a gameserver. Will do a thorough check and report details.<br> OperationId: `GameServerControllerTestReachability`
         * @summary Test reachability
         * @param {GameServerTestReachabilityInputDTO} [gameServerTestReachabilityInputDTO] GameServerTestReachabilityInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerTestReachability(gameServerTestReachabilityInputDTO, options) {
            return localVarFp
                .gameServerControllerTestReachability(gameServerTestReachabilityInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Test if Takaro can connect to a gameserver. Will do a thorough check and report details.<br> OperationId: `GameServerControllerTestReachabilityForId`
         * @summary Test reachability for id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerTestReachabilityForId(id, options) {
            return localVarFp
                .gameServerControllerTestReachabilityForId(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Manually trigger a job, you can poll the status with the GET endpoint   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerTriggerJob`
         * @summary Trigger job
         * @param {string} type
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerTriggerJob(type, id, options) {
            return localVarFp.gameServerControllerTriggerJob(type, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Unban a player from a gameserver. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerUnbanPlayer`
         * @summary Unban player
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        gameServerControllerUnbanPlayer(gameServerId, playerId, options) {
            return localVarFp
                .gameServerControllerUnbanPlayer(gameServerId, playerId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update a gameserver   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {GameServerUpdateDTO} [gameServerUpdateDTO] GameServerUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameServerControllerUpdate(id, gameServerUpdateDTO, options) {
            return localVarFp
                .gameServerControllerUpdate(id, gameServerUpdateDTO, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * GameServerApi - object-oriented interface
 * @export
 * @class GameServerApi
 * @extends {BaseAPI}
 */
export class GameServerApi extends BaseAPI {
    /**
     * Ban a player from a gameserver. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerBanPlayer`
     * @summary Ban player
     * @param {string} gameServerId
     * @param {string} playerId
     * @param {BanPlayerInputDTO} [banPlayerInputDTO] BanPlayerInputDTO
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerBanPlayer(gameServerId, playerId, banPlayerInputDTO, options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerBanPlayer(gameServerId, playerId, banPlayerInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a gameserver   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerCreate`
     * @summary Create
     * @param {GameServerCreateDTO} [gameServerCreateDTO] GameServerCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerCreate(gameServerCreateDTO, options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerCreate(gameServerCreateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Execute a raw command on a gameserver. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerExecuteCommand`
     * @summary Execute command
     * @param {string} id
     * @param {CommandExecuteInputDTO} [commandExecuteInputDTO] CommandExecuteInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerExecuteCommand(id, commandExecuteInputDTO, options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerExecuteCommand(id, commandExecuteInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Fetch status of an import from CSMM   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerGetImport`
     * @summary Get import
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerGetImport(id, options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerGetImport(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Fetch a job status   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerGetJob`
     * @summary Get job
     * @param {string} type
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerGetJob(type, id, options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerGetJob(type, id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get map metadata<br> OperationId: `GameServerControllerGetMapInfo`
     * @summary Get map info
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerGetMapInfo(id, options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerGetMapInfo(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a map tile<br> OperationId: `GameServerControllerGetMapTile`
     * @summary Get map tile
     * @param {string} id
     * @param {string} x
     * @param {string} y
     * @param {string} z
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerGetMapTile(id, x, y, z, options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerGetMapTile(id, x, y, z, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Fetch a gameserver by id<br> OperationId: `GameServerControllerGetOne`
     * @summary Get one
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerGetOne(id, options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerGetOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Fetch a list of players on a gameserver. Requires gameserver to be online and reachable. Please use the Player on GameServer (PoG) search endpoint instead: `POST /gameserver/player/search` for more flexible filtering, sorting, and pagination options.   Required permissions: `READ_PLAYERS`<br> OperationId: `GameServerControllerGetPlayers`
     * @summary Get players
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerGetPlayers(id, options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerGetPlayers(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Fetch gameserver types (7dtd, Rust, ...)<br> OperationId: `GameServerControllerGetTypes`
     * @summary Get types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerGetTypes(options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerGetTypes(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Give an item to a player. Accepts item UUID (preferred) or item code. Requires gameserver to be online and reachable. Depending on the underlying game implementation, it\'s possible that the item is dropped on the ground instead of placed directly in the player\'s inventory.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerGiveItem`
     * @summary Give item
     * @param {string} gameServerId
     * @param {string} playerId
     * @param {GiveItemInputDTO} [giveItemInputDTO] GiveItemInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerGiveItem(gameServerId, playerId, giveItemInputDTO, options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerGiveItem(gameServerId, playerId, giveItemInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Import a gameserver from CSMM.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerImportFromCSMM`
     * @summary Import from csmm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerImportFromCSMM(options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerImportFromCSMM(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Kick a player from a gameserver. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerKickPlayer`
     * @summary Kick player
     * @param {string} gameServerId
     * @param {string} playerId
     * @param {KickPlayerInputDTO} [kickPlayerInputDTO] KickPlayerInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerKickPlayer(gameServerId, playerId, kickPlayerInputDTO, options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerKickPlayer(gameServerId, playerId, kickPlayerInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * List bans for a gameserver. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerListBans`
     * @summary List bans
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerListBans(id, options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerListBans(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Regenerate the registration token for a gameserver. Careful, this will invalidate all existing connections.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerRegenerateRegistrationToken`
     * @summary Regenerate registration token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerRegenerateRegistrationToken(options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerRegenerateRegistrationToken(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete a gameserver   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerRemove`
     * @summary Remove
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerRemove(id, options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerRemove(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Resets all players\' currency to 0 on the specified game server. This action is irreversible.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerResetCurrency`
     * @summary Reset currency
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerResetCurrency(id, options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerResetCurrency(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Fetch gameservers<br> OperationId: `GameServerControllerSearch`
     * @summary Search
     * @param {GameServerSearchInputDTO} [gameServerSearchInputDTO] GameServerSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerSearch(gameServerSearchInputDTO, options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerSearch(gameServerSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Send a message in gameserver chat. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerSendMessage`
     * @summary Send message
     * @param {string} id
     * @param {MessageSendInputDTO} [messageSendInputDTO] MessageSendInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerSendMessage(id, messageSendInputDTO, options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerSendMessage(id, messageSendInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Shuts down the gameserver. This is a \'soft\' shutdown, meaning the gameserver will be stopped gracefully. If the gameserver is not reachable, this will have no effect. Note that most hosting providers will automatically restart the gameserver after a shutdown, which makes this operation act as a \'restart\' instead.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerShutdown`
     * @summary Shutdown
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerShutdown(id, options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerShutdown(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Teleport a player to a location. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerTeleportPlayer`
     * @summary Teleport player
     * @param {string} gameServerId
     * @param {string} playerId
     * @param {TeleportPlayerInputDTO} [teleportPlayerInputDTO] TeleportPlayerInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerTeleportPlayer(gameServerId, playerId, teleportPlayerInputDTO, options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerTeleportPlayer(gameServerId, playerId, teleportPlayerInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Test if Takaro can connect to a gameserver. Will do a thorough check and report details.<br> OperationId: `GameServerControllerTestReachability`
     * @summary Test reachability
     * @param {GameServerTestReachabilityInputDTO} [gameServerTestReachabilityInputDTO] GameServerTestReachabilityInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerTestReachability(gameServerTestReachabilityInputDTO, options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerTestReachability(gameServerTestReachabilityInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Test if Takaro can connect to a gameserver. Will do a thorough check and report details.<br> OperationId: `GameServerControllerTestReachabilityForId`
     * @summary Test reachability for id
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerTestReachabilityForId(id, options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerTestReachabilityForId(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Manually trigger a job, you can poll the status with the GET endpoint   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerTriggerJob`
     * @summary Trigger job
     * @param {string} type
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerTriggerJob(type, id, options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerTriggerJob(type, id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Unban a player from a gameserver. Requires gameserver to be online and reachable.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerUnbanPlayer`
     * @summary Unban player
     * @param {string} gameServerId
     * @param {string} playerId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerUnbanPlayer(gameServerId, playerId, options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerUnbanPlayer(gameServerId, playerId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update a gameserver   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `GameServerControllerUpdate`
     * @summary Update
     * @param {string} id
     * @param {GameServerUpdateDTO} [gameServerUpdateDTO] GameServerUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameServerApi
     */
    gameServerControllerUpdate(id, gameServerUpdateDTO, options) {
        return GameServerApiFp(this.configuration)
            .gameServerControllerUpdate(id, gameServerUpdateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * HookApi - axios parameter creator
 * @export
 */
export const HookApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `HookControllerCreate`
         * @summary Create
         * @param {HookCreateDTO} [hookCreateDTO] HookCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hookControllerCreate: async (hookCreateDTO, options = {}) => {
            const localVarPath = `/hook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(hookCreateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `HookControllerGetExecutions`
         * @summary Get executions
         * @param {string} id
         * @param {any} [success]
         * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hookControllerGetExecutions: async (id, success, eventSearchInputDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('hookControllerGetExecutions', 'id', id);
            const localVarPath = `/hook/{id}/executions`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            if (success !== undefined) {
                for (const [key, value] of Object.entries(success)) {
                    localVarQueryParameter[key] = value;
                }
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(eventSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `HookControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hookControllerGetOne: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('hookControllerGetOne', 'id', id);
            const localVarPath = `/hook/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `HookControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hookControllerRemove: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('hookControllerRemove', 'id', id);
            const localVarPath = `/hook/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search hooks   Required permissions: `READ_MODULES`<br> OperationId: `HookControllerSearch`
         * @summary Search
         * @param {HookSearchInputDTO} [hookSearchInputDTO] HookSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hookControllerSearch: async (hookSearchInputDTO, options = {}) => {
            const localVarPath = `/hook/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(hookSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Trigger a hook. This is used for testing purposes, the event will not actually be created but the hook-logic will be executed.      You can pass any data you want, but it must validate against the corresponding event metadata. Eg to trigger the `chat-message` event, you must pass an object with a `message` property   Required permissions: `MANAGE_MODULES`<br> OperationId: `HookControllerTrigger`
         * @summary Trigger
         * @param {HookTriggerDTO} [hookTriggerDTO] HookTriggerDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hookControllerTrigger: async (hookTriggerDTO, options = {}) => {
            const localVarPath = `/hook/trigger`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(hookTriggerDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `HookControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {HookUpdateDTO} [hookUpdateDTO] HookUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hookControllerUpdate: async (id, hookUpdateDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('hookControllerUpdate', 'id', id);
            const localVarPath = `/hook/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(hookUpdateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * HookApi - functional programming interface
 * @export
 */
export const HookApiFp = function (configuration) {
    const localVarAxiosParamCreator = HookApiAxiosParamCreator(configuration);
    return {
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `HookControllerCreate`
         * @summary Create
         * @param {HookCreateDTO} [hookCreateDTO] HookCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hookControllerCreate(hookCreateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hookControllerCreate(hookCreateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HookApi.hookControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `HookControllerGetExecutions`
         * @summary Get executions
         * @param {string} id
         * @param {any} [success]
         * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hookControllerGetExecutions(id, success, eventSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hookControllerGetExecutions(id, success, eventSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HookApi.hookControllerGetExecutions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `HookControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hookControllerGetOne(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hookControllerGetOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HookApi.hookControllerGetOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `HookControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hookControllerRemove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hookControllerRemove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HookApi.hookControllerRemove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search hooks   Required permissions: `READ_MODULES`<br> OperationId: `HookControllerSearch`
         * @summary Search
         * @param {HookSearchInputDTO} [hookSearchInputDTO] HookSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hookControllerSearch(hookSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hookControllerSearch(hookSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HookApi.hookControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Trigger a hook. This is used for testing purposes, the event will not actually be created but the hook-logic will be executed.      You can pass any data you want, but it must validate against the corresponding event metadata. Eg to trigger the `chat-message` event, you must pass an object with a `message` property   Required permissions: `MANAGE_MODULES`<br> OperationId: `HookControllerTrigger`
         * @summary Trigger
         * @param {HookTriggerDTO} [hookTriggerDTO] HookTriggerDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hookControllerTrigger(hookTriggerDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hookControllerTrigger(hookTriggerDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HookApi.hookControllerTrigger']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `HookControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {HookUpdateDTO} [hookUpdateDTO] HookUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hookControllerUpdate(id, hookUpdateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hookControllerUpdate(id, hookUpdateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HookApi.hookControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * HookApi - factory interface
 * @export
 */
export const HookApiFactory = function (configuration, basePath, axios) {
    const localVarFp = HookApiFp(configuration);
    return {
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `HookControllerCreate`
         * @summary Create
         * @param {HookCreateDTO} [hookCreateDTO] HookCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hookControllerCreate(hookCreateDTO, options) {
            return localVarFp.hookControllerCreate(hookCreateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `HookControllerGetExecutions`
         * @summary Get executions
         * @param {string} id
         * @param {any} [success]
         * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hookControllerGetExecutions(id, success, eventSearchInputDTO, options) {
            return localVarFp
                .hookControllerGetExecutions(id, success, eventSearchInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `HookControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hookControllerGetOne(id, options) {
            return localVarFp.hookControllerGetOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `HookControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hookControllerRemove(id, options) {
            return localVarFp.hookControllerRemove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Search hooks   Required permissions: `READ_MODULES`<br> OperationId: `HookControllerSearch`
         * @summary Search
         * @param {HookSearchInputDTO} [hookSearchInputDTO] HookSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hookControllerSearch(hookSearchInputDTO, options) {
            return localVarFp.hookControllerSearch(hookSearchInputDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Trigger a hook. This is used for testing purposes, the event will not actually be created but the hook-logic will be executed.      You can pass any data you want, but it must validate against the corresponding event metadata. Eg to trigger the `chat-message` event, you must pass an object with a `message` property   Required permissions: `MANAGE_MODULES`<br> OperationId: `HookControllerTrigger`
         * @summary Trigger
         * @param {HookTriggerDTO} [hookTriggerDTO] HookTriggerDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hookControllerTrigger(hookTriggerDTO, options) {
            return localVarFp.hookControllerTrigger(hookTriggerDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_MODULES`<br> OperationId: `HookControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {HookUpdateDTO} [hookUpdateDTO] HookUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hookControllerUpdate(id, hookUpdateDTO, options) {
            return localVarFp.hookControllerUpdate(id, hookUpdateDTO, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * HookApi - object-oriented interface
 * @export
 * @class HookApi
 * @extends {BaseAPI}
 */
export class HookApi extends BaseAPI {
    /**
     *    Required permissions: `MANAGE_MODULES`<br> OperationId: `HookControllerCreate`
     * @summary Create
     * @param {HookCreateDTO} [hookCreateDTO] HookCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HookApi
     */
    hookControllerCreate(hookCreateDTO, options) {
        return HookApiFp(this.configuration)
            .hookControllerCreate(hookCreateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_MODULES`<br> OperationId: `HookControllerGetExecutions`
     * @summary Get executions
     * @param {string} id
     * @param {any} [success]
     * @param {EventSearchInputDTO} [eventSearchInputDTO] EventSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HookApi
     */
    hookControllerGetExecutions(id, success, eventSearchInputDTO, options) {
        return HookApiFp(this.configuration)
            .hookControllerGetExecutions(id, success, eventSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_MODULES`<br> OperationId: `HookControllerGetOne`
     * @summary Get one
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HookApi
     */
    hookControllerGetOne(id, options) {
        return HookApiFp(this.configuration)
            .hookControllerGetOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_MODULES`<br> OperationId: `HookControllerRemove`
     * @summary Remove
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HookApi
     */
    hookControllerRemove(id, options) {
        return HookApiFp(this.configuration)
            .hookControllerRemove(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search hooks   Required permissions: `READ_MODULES`<br> OperationId: `HookControllerSearch`
     * @summary Search
     * @param {HookSearchInputDTO} [hookSearchInputDTO] HookSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HookApi
     */
    hookControllerSearch(hookSearchInputDTO, options) {
        return HookApiFp(this.configuration)
            .hookControllerSearch(hookSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Trigger a hook. This is used for testing purposes, the event will not actually be created but the hook-logic will be executed.      You can pass any data you want, but it must validate against the corresponding event metadata. Eg to trigger the `chat-message` event, you must pass an object with a `message` property   Required permissions: `MANAGE_MODULES`<br> OperationId: `HookControllerTrigger`
     * @summary Trigger
     * @param {HookTriggerDTO} [hookTriggerDTO] HookTriggerDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HookApi
     */
    hookControllerTrigger(hookTriggerDTO, options) {
        return HookApiFp(this.configuration)
            .hookControllerTrigger(hookTriggerDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_MODULES`<br> OperationId: `HookControllerUpdate`
     * @summary Update
     * @param {string} id
     * @param {HookUpdateDTO} [hookUpdateDTO] HookUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HookApi
     */
    hookControllerUpdate(id, hookUpdateDTO, options) {
        return HookApiFp(this.configuration)
            .hookControllerUpdate(id, hookUpdateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ItemApi - axios parameter creator
 * @export
 */
export const ItemApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *    Required permissions: `READ_ITEMS`<br> OperationId: `ItemControllerFindOne`
         * @summary Find one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemControllerFindOne: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('itemControllerFindOne', 'id', id);
            const localVarPath = `/items/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search items   Required permissions: `READ_ITEMS`<br> OperationId: `ItemControllerSearch`
         * @summary Search
         * @param {ItemSearchInputDTO} [itemSearchInputDTO] ItemSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemControllerSearch: async (itemSearchInputDTO, options = {}) => {
            const localVarPath = `/items/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(itemSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ItemApi - functional programming interface
 * @export
 */
export const ItemApiFp = function (configuration) {
    const localVarAxiosParamCreator = ItemApiAxiosParamCreator(configuration);
    return {
        /**
         *    Required permissions: `READ_ITEMS`<br> OperationId: `ItemControllerFindOne`
         * @summary Find one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemControllerFindOne(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemControllerFindOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ItemApi.itemControllerFindOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search items   Required permissions: `READ_ITEMS`<br> OperationId: `ItemControllerSearch`
         * @summary Search
         * @param {ItemSearchInputDTO} [itemSearchInputDTO] ItemSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemControllerSearch(itemSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemControllerSearch(itemSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ItemApi.itemControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ItemApi - factory interface
 * @export
 */
export const ItemApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ItemApiFp(configuration);
    return {
        /**
         *    Required permissions: `READ_ITEMS`<br> OperationId: `ItemControllerFindOne`
         * @summary Find one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemControllerFindOne(id, options) {
            return localVarFp.itemControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Search items   Required permissions: `READ_ITEMS`<br> OperationId: `ItemControllerSearch`
         * @summary Search
         * @param {ItemSearchInputDTO} [itemSearchInputDTO] ItemSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemControllerSearch(itemSearchInputDTO, options) {
            return localVarFp.itemControllerSearch(itemSearchInputDTO, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ItemApi - object-oriented interface
 * @export
 * @class ItemApi
 * @extends {BaseAPI}
 */
export class ItemApi extends BaseAPI {
    /**
     *    Required permissions: `READ_ITEMS`<br> OperationId: `ItemControllerFindOne`
     * @summary Find one
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemApi
     */
    itemControllerFindOne(id, options) {
        return ItemApiFp(this.configuration)
            .itemControllerFindOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search items   Required permissions: `READ_ITEMS`<br> OperationId: `ItemControllerSearch`
     * @summary Search
     * @param {ItemSearchInputDTO} [itemSearchInputDTO] ItemSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemApi
     */
    itemControllerSearch(itemSearchInputDTO, options) {
        return ItemApiFp(this.configuration)
            .itemControllerSearch(itemSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MetaApi - axios parameter creator
 * @export
 */
export const MetaApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * <br> OperationId: `MetaGetHealth`
         * @summary Get health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaGetHealth: async (options = {}) => {
            const localVarPath = `/healthz`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <br> OperationId: `MetaGetMetrics`
         * @summary Get metrics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaGetMetrics: async (options = {}) => {
            const localVarPath = `/metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <br> OperationId: `MetaGetOpenApi`
         * @summary Get open api
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaGetOpenApi: async (options = {}) => {
            const localVarPath = `/openapi.json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <br> OperationId: `MetaGetOpenApiHtml`
         * @summary Get open api html
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaGetOpenApiHtml: async (options = {}) => {
            const localVarPath = `/api.html`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <br> OperationId: `MetaGetReadiness`
         * @summary Get readiness
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaGetReadiness: async (options = {}) => {
            const localVarPath = `/readyz`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <br> OperationId: `MetaGetRoot`
         * @summary Get root
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaGetRoot: async (options = {}) => {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * MetaApi - functional programming interface
 * @export
 */
export const MetaApiFp = function (configuration) {
    const localVarAxiosParamCreator = MetaApiAxiosParamCreator(configuration);
    return {
        /**
         * <br> OperationId: `MetaGetHealth`
         * @summary Get health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metaGetHealth(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metaGetHealth(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetaApi.metaGetHealth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <br> OperationId: `MetaGetMetrics`
         * @summary Get metrics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metaGetMetrics(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metaGetMetrics(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetaApi.metaGetMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <br> OperationId: `MetaGetOpenApi`
         * @summary Get open api
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metaGetOpenApi(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metaGetOpenApi(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetaApi.metaGetOpenApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <br> OperationId: `MetaGetOpenApiHtml`
         * @summary Get open api html
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metaGetOpenApiHtml(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metaGetOpenApiHtml(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetaApi.metaGetOpenApiHtml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <br> OperationId: `MetaGetReadiness`
         * @summary Get readiness
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metaGetReadiness(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metaGetReadiness(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetaApi.metaGetReadiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <br> OperationId: `MetaGetRoot`
         * @summary Get root
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metaGetRoot(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metaGetRoot(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetaApi.metaGetRoot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * MetaApi - factory interface
 * @export
 */
export const MetaApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MetaApiFp(configuration);
    return {
        /**
         * <br> OperationId: `MetaGetHealth`
         * @summary Get health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaGetHealth(options) {
            return localVarFp.metaGetHealth(options).then((request) => request(axios, basePath));
        },
        /**
         * <br> OperationId: `MetaGetMetrics`
         * @summary Get metrics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaGetMetrics(options) {
            return localVarFp.metaGetMetrics(options).then((request) => request(axios, basePath));
        },
        /**
         * <br> OperationId: `MetaGetOpenApi`
         * @summary Get open api
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaGetOpenApi(options) {
            return localVarFp.metaGetOpenApi(options).then((request) => request(axios, basePath));
        },
        /**
         * <br> OperationId: `MetaGetOpenApiHtml`
         * @summary Get open api html
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaGetOpenApiHtml(options) {
            return localVarFp.metaGetOpenApiHtml(options).then((request) => request(axios, basePath));
        },
        /**
         * <br> OperationId: `MetaGetReadiness`
         * @summary Get readiness
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaGetReadiness(options) {
            return localVarFp.metaGetReadiness(options).then((request) => request(axios, basePath));
        },
        /**
         * <br> OperationId: `MetaGetRoot`
         * @summary Get root
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaGetRoot(options) {
            return localVarFp.metaGetRoot(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MetaApi - object-oriented interface
 * @export
 * @class MetaApi
 * @extends {BaseAPI}
 */
export class MetaApi extends BaseAPI {
    /**
     * <br> OperationId: `MetaGetHealth`
     * @summary Get health
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    metaGetHealth(options) {
        return MetaApiFp(this.configuration)
            .metaGetHealth(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * <br> OperationId: `MetaGetMetrics`
     * @summary Get metrics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    metaGetMetrics(options) {
        return MetaApiFp(this.configuration)
            .metaGetMetrics(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * <br> OperationId: `MetaGetOpenApi`
     * @summary Get open api
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    metaGetOpenApi(options) {
        return MetaApiFp(this.configuration)
            .metaGetOpenApi(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * <br> OperationId: `MetaGetOpenApiHtml`
     * @summary Get open api html
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    metaGetOpenApiHtml(options) {
        return MetaApiFp(this.configuration)
            .metaGetOpenApiHtml(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * <br> OperationId: `MetaGetReadiness`
     * @summary Get readiness
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    metaGetReadiness(options) {
        return MetaApiFp(this.configuration)
            .metaGetReadiness(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * <br> OperationId: `MetaGetRoot`
     * @summary Get root
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    metaGetRoot(options) {
        return MetaApiFp(this.configuration)
            .metaGetRoot(options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ModuleApi - axios parameter creator
 * @export
 */
export const ModuleApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create a new module   Required permissions: `MANAGE_MODULES`<br> OperationId: `ModuleControllerCreate`
         * @summary Create module
         * @param {ModuleCreateAPIDTO} [moduleCreateAPIDTO] ModuleCreateAPIDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleControllerCreate: async (moduleCreateAPIDTO, options = {}) => {
            const localVarPath = `/module`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(moduleCreateAPIDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exports a module to a format that can be imported into another Takaro instance. This endpoint will export all known versions of the module   Required permissions: `READ_MODULES`<br> OperationId: `ModuleControllerExport`
         * @summary Export a module
         * @param {string} id
         * @param {ModuleExportOptionsDTO} [moduleExportOptionsDTO] ModuleExportOptionsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleControllerExport: async (id, moduleExportOptionsDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('moduleControllerExport', 'id', id);
            const localVarPath = `/module/{id}/export`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(moduleExportOptionsDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleControllerGetOne`
         * @summary Get one module
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleControllerGetOne: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('moduleControllerGetOne', 'id', id);
            const localVarPath = `/module/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Imports a module from a format that was exported from another Takaro instance   Required permissions: `MANAGE_MODULES`<br> OperationId: `ModuleControllerImport`
         * @summary Import a module
         * @param {any} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleControllerImport: async (body, options = {}) => {
            const localVarPath = `/module/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes a module, including all versions and config   Required permissions: `MANAGE_MODULES`<br> OperationId: `ModuleControllerRemove`
         * @summary Remove a module
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleControllerRemove: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('moduleControllerRemove', 'id', id);
            const localVarPath = `/module/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleControllerSearch`
         * @summary Search modules
         * @param {ModuleSearchInputDTO} [moduleSearchInputDTO] ModuleSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleControllerSearch: async (moduleSearchInputDTO, options = {}) => {
            const localVarPath = `/module/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(moduleSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a module   Required permissions: `MANAGE_MODULES`<br> OperationId: `ModuleControllerUpdate`
         * @summary Update a module
         * @param {string} id
         * @param {ModuleUpdateDTO} [moduleUpdateDTO] ModuleUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleControllerUpdate: async (id, moduleUpdateDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('moduleControllerUpdate', 'id', id);
            const localVarPath = `/module/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(moduleUpdateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleInstallationsControllerGetInstalledModules`
         * @summary Search module installations
         * @param {ModuleInstallationSearchInputDTO} [moduleInstallationSearchInputDTO] ModuleInstallationSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleInstallationsControllerGetInstalledModules: async (moduleInstallationSearchInputDTO, options = {}) => {
            const localVarPath = `/module/installation/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(moduleInstallationSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleInstallationsControllerGetModuleInstallation`
         * @summary Get one installation
         * @param {string} moduleId
         * @param {string} gameServerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleInstallationsControllerGetModuleInstallation: async (moduleId, gameServerId, options = {}) => {
            // verify required parameter 'moduleId' is not null or undefined
            assertParamExists('moduleInstallationsControllerGetModuleInstallation', 'moduleId', moduleId);
            // verify required parameter 'gameServerId' is not null or undefined
            assertParamExists('moduleInstallationsControllerGetModuleInstallation', 'gameServerId', gameServerId);
            const localVarPath = `/module/{moduleId}/gameserver/{gameServerId}/installation`
                .replace(`{${'moduleId'}}`, encodeURIComponent(String(moduleId)))
                .replace(`{${'gameServerId'}}`, encodeURIComponent(String(gameServerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Install a module on a gameserver. You can have multiple installations of the same module on the same gameserver.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `ModuleInstallationsControllerInstallModule`
         * @summary Install module
         * @param {InstallModuleDTO} [installModuleDTO] InstallModuleDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleInstallationsControllerInstallModule: async (installModuleDTO, options = {}) => {
            const localVarPath = `/module/installation/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(installModuleDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uninstall a module from a gameserver. This will not delete the module from the database.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `ModuleInstallationsControllerUninstallModule`
         * @summary Uninstall module
         * @param {string} moduleId
         * @param {string} gameServerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleInstallationsControllerUninstallModule: async (moduleId, gameServerId, options = {}) => {
            // verify required parameter 'moduleId' is not null or undefined
            assertParamExists('moduleInstallationsControllerUninstallModule', 'moduleId', moduleId);
            // verify required parameter 'gameServerId' is not null or undefined
            assertParamExists('moduleInstallationsControllerUninstallModule', 'gameServerId', gameServerId);
            const localVarPath = `/module/{moduleId}/gameserver/{gameServerId}/installation`
                .replace(`{${'moduleId'}}`, encodeURIComponent(String(moduleId)))
                .replace(`{${'gameServerId'}}`, encodeURIComponent(String(gameServerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleVersionControllerGetModuleVersion`
         * @summary Get one version
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleVersionControllerGetModuleVersion: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('moduleVersionControllerGetModuleVersion', 'id', id);
            const localVarPath = `/module/version/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleVersionControllerSearchVersions`
         * @summary Search module versions
         * @param {ModuleVersionSearchInputDTO} [moduleVersionSearchInputDTO] ModuleVersionSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleVersionControllerSearchVersions: async (moduleVersionSearchInputDTO, options = {}) => {
            const localVarPath = `/module/version/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(moduleVersionSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new version of a module, copying all config (commands,hooks,cronjobs,...) from the \"latest\" version into a new, immutable version   Required permissions: `MANAGE_MODULES`<br> OperationId: `ModuleVersionControllerTagVersion`
         * @summary Tag a new version
         * @param {ModuleVersionCreateAPIDTO} [moduleVersionCreateAPIDTO] ModuleVersionCreateAPIDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleVersionControllerTagVersion: async (moduleVersionCreateAPIDTO, options = {}) => {
            const localVarPath = `/module/version/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(moduleVersionCreateAPIDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ModuleApi - functional programming interface
 * @export
 */
export const ModuleApiFp = function (configuration) {
    const localVarAxiosParamCreator = ModuleApiAxiosParamCreator(configuration);
    return {
        /**
         * Create a new module   Required permissions: `MANAGE_MODULES`<br> OperationId: `ModuleControllerCreate`
         * @summary Create module
         * @param {ModuleCreateAPIDTO} [moduleCreateAPIDTO] ModuleCreateAPIDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleControllerCreate(moduleCreateAPIDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleControllerCreate(moduleCreateAPIDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModuleApi.moduleControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Exports a module to a format that can be imported into another Takaro instance. This endpoint will export all known versions of the module   Required permissions: `READ_MODULES`<br> OperationId: `ModuleControllerExport`
         * @summary Export a module
         * @param {string} id
         * @param {ModuleExportOptionsDTO} [moduleExportOptionsDTO] ModuleExportOptionsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleControllerExport(id, moduleExportOptionsDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleControllerExport(id, moduleExportOptionsDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModuleApi.moduleControllerExport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleControllerGetOne`
         * @summary Get one module
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleControllerGetOne(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleControllerGetOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModuleApi.moduleControllerGetOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Imports a module from a format that was exported from another Takaro instance   Required permissions: `MANAGE_MODULES`<br> OperationId: `ModuleControllerImport`
         * @summary Import a module
         * @param {any} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleControllerImport(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleControllerImport(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModuleApi.moduleControllerImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes a module, including all versions and config   Required permissions: `MANAGE_MODULES`<br> OperationId: `ModuleControllerRemove`
         * @summary Remove a module
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleControllerRemove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleControllerRemove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModuleApi.moduleControllerRemove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleControllerSearch`
         * @summary Search modules
         * @param {ModuleSearchInputDTO} [moduleSearchInputDTO] ModuleSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleControllerSearch(moduleSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleControllerSearch(moduleSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModuleApi.moduleControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a module   Required permissions: `MANAGE_MODULES`<br> OperationId: `ModuleControllerUpdate`
         * @summary Update a module
         * @param {string} id
         * @param {ModuleUpdateDTO} [moduleUpdateDTO] ModuleUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleControllerUpdate(id, moduleUpdateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleControllerUpdate(id, moduleUpdateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModuleApi.moduleControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleInstallationsControllerGetInstalledModules`
         * @summary Search module installations
         * @param {ModuleInstallationSearchInputDTO} [moduleInstallationSearchInputDTO] ModuleInstallationSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleInstallationsControllerGetInstalledModules(moduleInstallationSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleInstallationsControllerGetInstalledModules(moduleInstallationSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModuleApi.moduleInstallationsControllerGetInstalledModules']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleInstallationsControllerGetModuleInstallation`
         * @summary Get one installation
         * @param {string} moduleId
         * @param {string} gameServerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleInstallationsControllerGetModuleInstallation(moduleId, gameServerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleInstallationsControllerGetModuleInstallation(moduleId, gameServerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModuleApi.moduleInstallationsControllerGetModuleInstallation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Install a module on a gameserver. You can have multiple installations of the same module on the same gameserver.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `ModuleInstallationsControllerInstallModule`
         * @summary Install module
         * @param {InstallModuleDTO} [installModuleDTO] InstallModuleDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleInstallationsControllerInstallModule(installModuleDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleInstallationsControllerInstallModule(installModuleDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModuleApi.moduleInstallationsControllerInstallModule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Uninstall a module from a gameserver. This will not delete the module from the database.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `ModuleInstallationsControllerUninstallModule`
         * @summary Uninstall module
         * @param {string} moduleId
         * @param {string} gameServerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleInstallationsControllerUninstallModule(moduleId, gameServerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleInstallationsControllerUninstallModule(moduleId, gameServerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModuleApi.moduleInstallationsControllerUninstallModule']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleVersionControllerGetModuleVersion`
         * @summary Get one version
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleVersionControllerGetModuleVersion(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleVersionControllerGetModuleVersion(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModuleApi.moduleVersionControllerGetModuleVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleVersionControllerSearchVersions`
         * @summary Search module versions
         * @param {ModuleVersionSearchInputDTO} [moduleVersionSearchInputDTO] ModuleVersionSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleVersionControllerSearchVersions(moduleVersionSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleVersionControllerSearchVersions(moduleVersionSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModuleApi.moduleVersionControllerSearchVersions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new version of a module, copying all config (commands,hooks,cronjobs,...) from the \"latest\" version into a new, immutable version   Required permissions: `MANAGE_MODULES`<br> OperationId: `ModuleVersionControllerTagVersion`
         * @summary Tag a new version
         * @param {ModuleVersionCreateAPIDTO} [moduleVersionCreateAPIDTO] ModuleVersionCreateAPIDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moduleVersionControllerTagVersion(moduleVersionCreateAPIDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moduleVersionControllerTagVersion(moduleVersionCreateAPIDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModuleApi.moduleVersionControllerTagVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ModuleApi - factory interface
 * @export
 */
export const ModuleApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ModuleApiFp(configuration);
    return {
        /**
         * Create a new module   Required permissions: `MANAGE_MODULES`<br> OperationId: `ModuleControllerCreate`
         * @summary Create module
         * @param {ModuleCreateAPIDTO} [moduleCreateAPIDTO] ModuleCreateAPIDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleControllerCreate(moduleCreateAPIDTO, options) {
            return localVarFp.moduleControllerCreate(moduleCreateAPIDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Exports a module to a format that can be imported into another Takaro instance. This endpoint will export all known versions of the module   Required permissions: `READ_MODULES`<br> OperationId: `ModuleControllerExport`
         * @summary Export a module
         * @param {string} id
         * @param {ModuleExportOptionsDTO} [moduleExportOptionsDTO] ModuleExportOptionsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleControllerExport(id, moduleExportOptionsDTO, options) {
            return localVarFp
                .moduleControllerExport(id, moduleExportOptionsDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleControllerGetOne`
         * @summary Get one module
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleControllerGetOne(id, options) {
            return localVarFp.moduleControllerGetOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Imports a module from a format that was exported from another Takaro instance   Required permissions: `MANAGE_MODULES`<br> OperationId: `ModuleControllerImport`
         * @summary Import a module
         * @param {any} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleControllerImport(body, options) {
            return localVarFp.moduleControllerImport(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes a module, including all versions and config   Required permissions: `MANAGE_MODULES`<br> OperationId: `ModuleControllerRemove`
         * @summary Remove a module
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleControllerRemove(id, options) {
            return localVarFp.moduleControllerRemove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleControllerSearch`
         * @summary Search modules
         * @param {ModuleSearchInputDTO} [moduleSearchInputDTO] ModuleSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleControllerSearch(moduleSearchInputDTO, options) {
            return localVarFp
                .moduleControllerSearch(moduleSearchInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update a module   Required permissions: `MANAGE_MODULES`<br> OperationId: `ModuleControllerUpdate`
         * @summary Update a module
         * @param {string} id
         * @param {ModuleUpdateDTO} [moduleUpdateDTO] ModuleUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleControllerUpdate(id, moduleUpdateDTO, options) {
            return localVarFp
                .moduleControllerUpdate(id, moduleUpdateDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleInstallationsControllerGetInstalledModules`
         * @summary Search module installations
         * @param {ModuleInstallationSearchInputDTO} [moduleInstallationSearchInputDTO] ModuleInstallationSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleInstallationsControllerGetInstalledModules(moduleInstallationSearchInputDTO, options) {
            return localVarFp
                .moduleInstallationsControllerGetInstalledModules(moduleInstallationSearchInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleInstallationsControllerGetModuleInstallation`
         * @summary Get one installation
         * @param {string} moduleId
         * @param {string} gameServerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleInstallationsControllerGetModuleInstallation(moduleId, gameServerId, options) {
            return localVarFp
                .moduleInstallationsControllerGetModuleInstallation(moduleId, gameServerId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Install a module on a gameserver. You can have multiple installations of the same module on the same gameserver.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `ModuleInstallationsControllerInstallModule`
         * @summary Install module
         * @param {InstallModuleDTO} [installModuleDTO] InstallModuleDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleInstallationsControllerInstallModule(installModuleDTO, options) {
            return localVarFp
                .moduleInstallationsControllerInstallModule(installModuleDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Uninstall a module from a gameserver. This will not delete the module from the database.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `ModuleInstallationsControllerUninstallModule`
         * @summary Uninstall module
         * @param {string} moduleId
         * @param {string} gameServerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleInstallationsControllerUninstallModule(moduleId, gameServerId, options) {
            return localVarFp
                .moduleInstallationsControllerUninstallModule(moduleId, gameServerId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleVersionControllerGetModuleVersion`
         * @summary Get one version
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleVersionControllerGetModuleVersion(id, options) {
            return localVarFp
                .moduleVersionControllerGetModuleVersion(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleVersionControllerSearchVersions`
         * @summary Search module versions
         * @param {ModuleVersionSearchInputDTO} [moduleVersionSearchInputDTO] ModuleVersionSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleVersionControllerSearchVersions(moduleVersionSearchInputDTO, options) {
            return localVarFp
                .moduleVersionControllerSearchVersions(moduleVersionSearchInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Creates a new version of a module, copying all config (commands,hooks,cronjobs,...) from the \"latest\" version into a new, immutable version   Required permissions: `MANAGE_MODULES`<br> OperationId: `ModuleVersionControllerTagVersion`
         * @summary Tag a new version
         * @param {ModuleVersionCreateAPIDTO} [moduleVersionCreateAPIDTO] ModuleVersionCreateAPIDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moduleVersionControllerTagVersion(moduleVersionCreateAPIDTO, options) {
            return localVarFp
                .moduleVersionControllerTagVersion(moduleVersionCreateAPIDTO, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * ModuleApi - object-oriented interface
 * @export
 * @class ModuleApi
 * @extends {BaseAPI}
 */
export class ModuleApi extends BaseAPI {
    /**
     * Create a new module   Required permissions: `MANAGE_MODULES`<br> OperationId: `ModuleControllerCreate`
     * @summary Create module
     * @param {ModuleCreateAPIDTO} [moduleCreateAPIDTO] ModuleCreateAPIDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModuleApi
     */
    moduleControllerCreate(moduleCreateAPIDTO, options) {
        return ModuleApiFp(this.configuration)
            .moduleControllerCreate(moduleCreateAPIDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Exports a module to a format that can be imported into another Takaro instance. This endpoint will export all known versions of the module   Required permissions: `READ_MODULES`<br> OperationId: `ModuleControllerExport`
     * @summary Export a module
     * @param {string} id
     * @param {ModuleExportOptionsDTO} [moduleExportOptionsDTO] ModuleExportOptionsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModuleApi
     */
    moduleControllerExport(id, moduleExportOptionsDTO, options) {
        return ModuleApiFp(this.configuration)
            .moduleControllerExport(id, moduleExportOptionsDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleControllerGetOne`
     * @summary Get one module
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModuleApi
     */
    moduleControllerGetOne(id, options) {
        return ModuleApiFp(this.configuration)
            .moduleControllerGetOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Imports a module from a format that was exported from another Takaro instance   Required permissions: `MANAGE_MODULES`<br> OperationId: `ModuleControllerImport`
     * @summary Import a module
     * @param {any} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModuleApi
     */
    moduleControllerImport(body, options) {
        return ModuleApiFp(this.configuration)
            .moduleControllerImport(body, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Removes a module, including all versions and config   Required permissions: `MANAGE_MODULES`<br> OperationId: `ModuleControllerRemove`
     * @summary Remove a module
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModuleApi
     */
    moduleControllerRemove(id, options) {
        return ModuleApiFp(this.configuration)
            .moduleControllerRemove(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleControllerSearch`
     * @summary Search modules
     * @param {ModuleSearchInputDTO} [moduleSearchInputDTO] ModuleSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModuleApi
     */
    moduleControllerSearch(moduleSearchInputDTO, options) {
        return ModuleApiFp(this.configuration)
            .moduleControllerSearch(moduleSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update a module   Required permissions: `MANAGE_MODULES`<br> OperationId: `ModuleControllerUpdate`
     * @summary Update a module
     * @param {string} id
     * @param {ModuleUpdateDTO} [moduleUpdateDTO] ModuleUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModuleApi
     */
    moduleControllerUpdate(id, moduleUpdateDTO, options) {
        return ModuleApiFp(this.configuration)
            .moduleControllerUpdate(id, moduleUpdateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleInstallationsControllerGetInstalledModules`
     * @summary Search module installations
     * @param {ModuleInstallationSearchInputDTO} [moduleInstallationSearchInputDTO] ModuleInstallationSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModuleApi
     */
    moduleInstallationsControllerGetInstalledModules(moduleInstallationSearchInputDTO, options) {
        return ModuleApiFp(this.configuration)
            .moduleInstallationsControllerGetInstalledModules(moduleInstallationSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleInstallationsControllerGetModuleInstallation`
     * @summary Get one installation
     * @param {string} moduleId
     * @param {string} gameServerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModuleApi
     */
    moduleInstallationsControllerGetModuleInstallation(moduleId, gameServerId, options) {
        return ModuleApiFp(this.configuration)
            .moduleInstallationsControllerGetModuleInstallation(moduleId, gameServerId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Install a module on a gameserver. You can have multiple installations of the same module on the same gameserver.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `ModuleInstallationsControllerInstallModule`
     * @summary Install module
     * @param {InstallModuleDTO} [installModuleDTO] InstallModuleDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModuleApi
     */
    moduleInstallationsControllerInstallModule(installModuleDTO, options) {
        return ModuleApiFp(this.configuration)
            .moduleInstallationsControllerInstallModule(installModuleDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Uninstall a module from a gameserver. This will not delete the module from the database.   Required permissions: `MANAGE_GAMESERVERS`<br> OperationId: `ModuleInstallationsControllerUninstallModule`
     * @summary Uninstall module
     * @param {string} moduleId
     * @param {string} gameServerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModuleApi
     */
    moduleInstallationsControllerUninstallModule(moduleId, gameServerId, options) {
        return ModuleApiFp(this.configuration)
            .moduleInstallationsControllerUninstallModule(moduleId, gameServerId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleVersionControllerGetModuleVersion`
     * @summary Get one version
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModuleApi
     */
    moduleVersionControllerGetModuleVersion(id, options) {
        return ModuleApiFp(this.configuration)
            .moduleVersionControllerGetModuleVersion(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_MODULES`<br> OperationId: `ModuleVersionControllerSearchVersions`
     * @summary Search module versions
     * @param {ModuleVersionSearchInputDTO} [moduleVersionSearchInputDTO] ModuleVersionSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModuleApi
     */
    moduleVersionControllerSearchVersions(moduleVersionSearchInputDTO, options) {
        return ModuleApiFp(this.configuration)
            .moduleVersionControllerSearchVersions(moduleVersionSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a new version of a module, copying all config (commands,hooks,cronjobs,...) from the \"latest\" version into a new, immutable version   Required permissions: `MANAGE_MODULES`<br> OperationId: `ModuleVersionControllerTagVersion`
     * @summary Tag a new version
     * @param {ModuleVersionCreateAPIDTO} [moduleVersionCreateAPIDTO] ModuleVersionCreateAPIDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModuleApi
     */
    moduleVersionControllerTagVersion(moduleVersionCreateAPIDTO, options) {
        return ModuleApiFp(this.configuration)
            .moduleVersionControllerTagVersion(moduleVersionCreateAPIDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PlayerApi - axios parameter creator
 * @export
 */
export const PlayerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create a new ban, creating a ban via the API will always make it takaro managed.   Required permissions: `MANAGE_PLAYERS`<br> OperationId: `BanControllerCreate`
         * @summary Ban player
         * @param {BanCreateDTO} [banCreateDTO] BanCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        banControllerCreate: async (banCreateDTO, options = {}) => {
            const localVarPath = `/player/ban`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(banCreateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unban player. This will remove the ban from Takaro and the gameserver(s)   Required permissions: `MANAGE_PLAYERS`<br> OperationId: `BanControllerDelete`
         * @summary Unban player
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        banControllerDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('banControllerDelete', 'id', id);
            const localVarPath = `/player/ban/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single ban   Required permissions: `READ_PLAYERS`<br> OperationId: `BanControllerGetOne`
         * @summary Get a single ban
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        banControllerGetOne: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('banControllerGetOne', 'id', id);
            const localVarPath = `/player/ban/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for bans   Required permissions: `READ_PLAYERS`<br> OperationId: `BanControllerSearch`
         * @summary Search for bans
         * @param {BanSearchInputDTO} [banSearchInputDTO] BanSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        banControllerSearch: async (banSearchInputDTO, options = {}) => {
            const localVarPath = `/player/ban/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(banSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing ban, updating a ban via the API will always make it takaro managed.   Required permissions: `MANAGE_PLAYERS`<br> OperationId: `BanControllerUpdate`
         * @summary Update ban
         * @param {string} id
         * @param {BanUpdateDTO} [banUpdateDTO] BanUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        banControllerUpdate: async (id, banUpdateDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('banControllerUpdate', 'id', id);
            const localVarPath = `/player/ban/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(banUpdateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_PLAYERS`, `MANAGE_ROLES`<br> OperationId: `PlayerControllerAssignRole`
         * @summary Assign role
         * @param {string} id
         * @param {string} roleId
         * @param {PlayerRoleAssignChangeDTO} [playerRoleAssignChangeDTO] PlayerRoleAssignChangeDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerControllerAssignRole: async (id, roleId, playerRoleAssignChangeDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('playerControllerAssignRole', 'id', id);
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('playerControllerAssignRole', 'roleId', roleId);
            const localVarPath = `/player/{id}/role/{roleId}`
                .replace(`{${'id'}}`, encodeURIComponent(String(id)))
                .replace(`{${'roleId'}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(playerRoleAssignChangeDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk delete players by their IDs. Deletes Player records which cascades to POG records.   Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerControllerBulkDelete`
         * @summary Bulk delete
         * @param {PlayerBulkDeleteInputDTO} [playerBulkDeleteInputDTO] PlayerBulkDeleteInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerControllerBulkDelete: async (playerBulkDeleteInputDTO, options = {}) => {
            const localVarPath = `/player`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(playerBulkDeleteInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerControllerDelete`
         * @summary Delete
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerControllerDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('playerControllerDelete', 'id', id);
            const localVarPath = `/player/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the player that is currently authenticated. This is a low-privilege route, returning limited data.<br> OperationId: `PlayerControllerGetMe`
         * @summary Get current player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerControllerGetMe: async (options = {}) => {
            const localVarPath = `/player/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `PlayerControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerControllerGetOne: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('playerControllerGetOne', 'id', id);
            const localVarPath = `/player/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_PLAYERS`, `MANAGE_ROLES`<br> OperationId: `PlayerControllerRemoveRole`
         * @summary Remove role
         * @param {string} id
         * @param {string} roleId
         * @param {PlayerRoleAssignChangeDTO} [playerRoleAssignChangeDTO] PlayerRoleAssignChangeDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerControllerRemoveRole: async (id, roleId, playerRoleAssignChangeDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('playerControllerRemoveRole', 'id', id);
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('playerControllerRemoveRole', 'roleId', roleId);
            const localVarPath = `/player/{id}/role/{roleId}`
                .replace(`{${'id'}}`, encodeURIComponent(String(id)))
                .replace(`{${'roleId'}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(playerRoleAssignChangeDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `PlayerControllerSearch`
         * @summary Search
         * @param {PlayerSearchInputDTO} [playerSearchInputDTO] PlayerSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerControllerSearch: async (playerSearchInputDTO, options = {}) => {
            const localVarPath = `/player/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(playerSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PlayerApi - functional programming interface
 * @export
 */
export const PlayerApiFp = function (configuration) {
    const localVarAxiosParamCreator = PlayerApiAxiosParamCreator(configuration);
    return {
        /**
         * Create a new ban, creating a ban via the API will always make it takaro managed.   Required permissions: `MANAGE_PLAYERS`<br> OperationId: `BanControllerCreate`
         * @summary Ban player
         * @param {BanCreateDTO} [banCreateDTO] BanCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async banControllerCreate(banCreateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.banControllerCreate(banCreateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayerApi.banControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unban player. This will remove the ban from Takaro and the gameserver(s)   Required permissions: `MANAGE_PLAYERS`<br> OperationId: `BanControllerDelete`
         * @summary Unban player
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async banControllerDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.banControllerDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayerApi.banControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single ban   Required permissions: `READ_PLAYERS`<br> OperationId: `BanControllerGetOne`
         * @summary Get a single ban
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async banControllerGetOne(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.banControllerGetOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayerApi.banControllerGetOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for bans   Required permissions: `READ_PLAYERS`<br> OperationId: `BanControllerSearch`
         * @summary Search for bans
         * @param {BanSearchInputDTO} [banSearchInputDTO] BanSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async banControllerSearch(banSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.banControllerSearch(banSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayerApi.banControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing ban, updating a ban via the API will always make it takaro managed.   Required permissions: `MANAGE_PLAYERS`<br> OperationId: `BanControllerUpdate`
         * @summary Update ban
         * @param {string} id
         * @param {BanUpdateDTO} [banUpdateDTO] BanUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async banControllerUpdate(id, banUpdateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.banControllerUpdate(id, banUpdateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayerApi.banControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_PLAYERS`, `MANAGE_ROLES`<br> OperationId: `PlayerControllerAssignRole`
         * @summary Assign role
         * @param {string} id
         * @param {string} roleId
         * @param {PlayerRoleAssignChangeDTO} [playerRoleAssignChangeDTO] PlayerRoleAssignChangeDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async playerControllerAssignRole(id, roleId, playerRoleAssignChangeDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.playerControllerAssignRole(id, roleId, playerRoleAssignChangeDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayerApi.playerControllerAssignRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bulk delete players by their IDs. Deletes Player records which cascades to POG records.   Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerControllerBulkDelete`
         * @summary Bulk delete
         * @param {PlayerBulkDeleteInputDTO} [playerBulkDeleteInputDTO] PlayerBulkDeleteInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async playerControllerBulkDelete(playerBulkDeleteInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.playerControllerBulkDelete(playerBulkDeleteInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayerApi.playerControllerBulkDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerControllerDelete`
         * @summary Delete
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async playerControllerDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.playerControllerDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayerApi.playerControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the player that is currently authenticated. This is a low-privilege route, returning limited data.<br> OperationId: `PlayerControllerGetMe`
         * @summary Get current player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async playerControllerGetMe(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.playerControllerGetMe(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayerApi.playerControllerGetMe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `PlayerControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async playerControllerGetOne(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.playerControllerGetOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayerApi.playerControllerGetOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_PLAYERS`, `MANAGE_ROLES`<br> OperationId: `PlayerControllerRemoveRole`
         * @summary Remove role
         * @param {string} id
         * @param {string} roleId
         * @param {PlayerRoleAssignChangeDTO} [playerRoleAssignChangeDTO] PlayerRoleAssignChangeDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async playerControllerRemoveRole(id, roleId, playerRoleAssignChangeDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.playerControllerRemoveRole(id, roleId, playerRoleAssignChangeDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayerApi.playerControllerRemoveRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `PlayerControllerSearch`
         * @summary Search
         * @param {PlayerSearchInputDTO} [playerSearchInputDTO] PlayerSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async playerControllerSearch(playerSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.playerControllerSearch(playerSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayerApi.playerControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PlayerApi - factory interface
 * @export
 */
export const PlayerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PlayerApiFp(configuration);
    return {
        /**
         * Create a new ban, creating a ban via the API will always make it takaro managed.   Required permissions: `MANAGE_PLAYERS`<br> OperationId: `BanControllerCreate`
         * @summary Ban player
         * @param {BanCreateDTO} [banCreateDTO] BanCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        banControllerCreate(banCreateDTO, options) {
            return localVarFp.banControllerCreate(banCreateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Unban player. This will remove the ban from Takaro and the gameserver(s)   Required permissions: `MANAGE_PLAYERS`<br> OperationId: `BanControllerDelete`
         * @summary Unban player
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        banControllerDelete(id, options) {
            return localVarFp.banControllerDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single ban   Required permissions: `READ_PLAYERS`<br> OperationId: `BanControllerGetOne`
         * @summary Get a single ban
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        banControllerGetOne(id, options) {
            return localVarFp.banControllerGetOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for bans   Required permissions: `READ_PLAYERS`<br> OperationId: `BanControllerSearch`
         * @summary Search for bans
         * @param {BanSearchInputDTO} [banSearchInputDTO] BanSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        banControllerSearch(banSearchInputDTO, options) {
            return localVarFp.banControllerSearch(banSearchInputDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing ban, updating a ban via the API will always make it takaro managed.   Required permissions: `MANAGE_PLAYERS`<br> OperationId: `BanControllerUpdate`
         * @summary Update ban
         * @param {string} id
         * @param {BanUpdateDTO} [banUpdateDTO] BanUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        banControllerUpdate(id, banUpdateDTO, options) {
            return localVarFp.banControllerUpdate(id, banUpdateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_PLAYERS`, `MANAGE_ROLES`<br> OperationId: `PlayerControllerAssignRole`
         * @summary Assign role
         * @param {string} id
         * @param {string} roleId
         * @param {PlayerRoleAssignChangeDTO} [playerRoleAssignChangeDTO] PlayerRoleAssignChangeDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerControllerAssignRole(id, roleId, playerRoleAssignChangeDTO, options) {
            return localVarFp
                .playerControllerAssignRole(id, roleId, playerRoleAssignChangeDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Bulk delete players by their IDs. Deletes Player records which cascades to POG records.   Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerControllerBulkDelete`
         * @summary Bulk delete
         * @param {PlayerBulkDeleteInputDTO} [playerBulkDeleteInputDTO] PlayerBulkDeleteInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerControllerBulkDelete(playerBulkDeleteInputDTO, options) {
            return localVarFp
                .playerControllerBulkDelete(playerBulkDeleteInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerControllerDelete`
         * @summary Delete
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerControllerDelete(id, options) {
            return localVarFp.playerControllerDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the player that is currently authenticated. This is a low-privilege route, returning limited data.<br> OperationId: `PlayerControllerGetMe`
         * @summary Get current player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerControllerGetMe(options) {
            return localVarFp.playerControllerGetMe(options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `PlayerControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerControllerGetOne(id, options) {
            return localVarFp.playerControllerGetOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_PLAYERS`, `MANAGE_ROLES`<br> OperationId: `PlayerControllerRemoveRole`
         * @summary Remove role
         * @param {string} id
         * @param {string} roleId
         * @param {PlayerRoleAssignChangeDTO} [playerRoleAssignChangeDTO] PlayerRoleAssignChangeDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerControllerRemoveRole(id, roleId, playerRoleAssignChangeDTO, options) {
            return localVarFp
                .playerControllerRemoveRole(id, roleId, playerRoleAssignChangeDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `PlayerControllerSearch`
         * @summary Search
         * @param {PlayerSearchInputDTO} [playerSearchInputDTO] PlayerSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerControllerSearch(playerSearchInputDTO, options) {
            return localVarFp
                .playerControllerSearch(playerSearchInputDTO, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * PlayerApi - object-oriented interface
 * @export
 * @class PlayerApi
 * @extends {BaseAPI}
 */
export class PlayerApi extends BaseAPI {
    /**
     * Create a new ban, creating a ban via the API will always make it takaro managed.   Required permissions: `MANAGE_PLAYERS`<br> OperationId: `BanControllerCreate`
     * @summary Ban player
     * @param {BanCreateDTO} [banCreateDTO] BanCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    banControllerCreate(banCreateDTO, options) {
        return PlayerApiFp(this.configuration)
            .banControllerCreate(banCreateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Unban player. This will remove the ban from Takaro and the gameserver(s)   Required permissions: `MANAGE_PLAYERS`<br> OperationId: `BanControllerDelete`
     * @summary Unban player
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    banControllerDelete(id, options) {
        return PlayerApiFp(this.configuration)
            .banControllerDelete(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a single ban   Required permissions: `READ_PLAYERS`<br> OperationId: `BanControllerGetOne`
     * @summary Get a single ban
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    banControllerGetOne(id, options) {
        return PlayerApiFp(this.configuration)
            .banControllerGetOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search for bans   Required permissions: `READ_PLAYERS`<br> OperationId: `BanControllerSearch`
     * @summary Search for bans
     * @param {BanSearchInputDTO} [banSearchInputDTO] BanSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    banControllerSearch(banSearchInputDTO, options) {
        return PlayerApiFp(this.configuration)
            .banControllerSearch(banSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update an existing ban, updating a ban via the API will always make it takaro managed.   Required permissions: `MANAGE_PLAYERS`<br> OperationId: `BanControllerUpdate`
     * @summary Update ban
     * @param {string} id
     * @param {BanUpdateDTO} [banUpdateDTO] BanUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    banControllerUpdate(id, banUpdateDTO, options) {
        return PlayerApiFp(this.configuration)
            .banControllerUpdate(id, banUpdateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_PLAYERS`, `MANAGE_ROLES`<br> OperationId: `PlayerControllerAssignRole`
     * @summary Assign role
     * @param {string} id
     * @param {string} roleId
     * @param {PlayerRoleAssignChangeDTO} [playerRoleAssignChangeDTO] PlayerRoleAssignChangeDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    playerControllerAssignRole(id, roleId, playerRoleAssignChangeDTO, options) {
        return PlayerApiFp(this.configuration)
            .playerControllerAssignRole(id, roleId, playerRoleAssignChangeDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Bulk delete players by their IDs. Deletes Player records which cascades to POG records.   Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerControllerBulkDelete`
     * @summary Bulk delete
     * @param {PlayerBulkDeleteInputDTO} [playerBulkDeleteInputDTO] PlayerBulkDeleteInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    playerControllerBulkDelete(playerBulkDeleteInputDTO, options) {
        return PlayerApiFp(this.configuration)
            .playerControllerBulkDelete(playerBulkDeleteInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerControllerDelete`
     * @summary Delete
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    playerControllerDelete(id, options) {
        return PlayerApiFp(this.configuration)
            .playerControllerDelete(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the player that is currently authenticated. This is a low-privilege route, returning limited data.<br> OperationId: `PlayerControllerGetMe`
     * @summary Get current player
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    playerControllerGetMe(options) {
        return PlayerApiFp(this.configuration)
            .playerControllerGetMe(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_PLAYERS`<br> OperationId: `PlayerControllerGetOne`
     * @summary Get one
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    playerControllerGetOne(id, options) {
        return PlayerApiFp(this.configuration)
            .playerControllerGetOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_PLAYERS`, `MANAGE_ROLES`<br> OperationId: `PlayerControllerRemoveRole`
     * @summary Remove role
     * @param {string} id
     * @param {string} roleId
     * @param {PlayerRoleAssignChangeDTO} [playerRoleAssignChangeDTO] PlayerRoleAssignChangeDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    playerControllerRemoveRole(id, roleId, playerRoleAssignChangeDTO, options) {
        return PlayerApiFp(this.configuration)
            .playerControllerRemoveRole(id, roleId, playerRoleAssignChangeDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_PLAYERS`<br> OperationId: `PlayerControllerSearch`
     * @summary Search
     * @param {PlayerSearchInputDTO} [playerSearchInputDTO] PlayerSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    playerControllerSearch(playerSearchInputDTO, options) {
        return PlayerApiFp(this.configuration)
            .playerControllerSearch(playerSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PlayerOnGameServerApi - axios parameter creator
 * @export
 */
export const PlayerOnGameServerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerAddCurrency`
         * @summary Add currency
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {PlayerOnGameServerSetCurrencyInputDTO} [playerOnGameServerSetCurrencyInputDTO] PlayerOnGameServerSetCurrencyInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerOnGameServerControllerAddCurrency: async (gameServerId, playerId, playerOnGameServerSetCurrencyInputDTO, options = {}) => {
            // verify required parameter 'gameServerId' is not null or undefined
            assertParamExists('playerOnGameServerControllerAddCurrency', 'gameServerId', gameServerId);
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('playerOnGameServerControllerAddCurrency', 'playerId', playerId);
            const localVarPath = `/gameserver/{gameServerId}/player/{playerId}/add-currency`
                .replace(`{${'gameServerId'}}`, encodeURIComponent(String(gameServerId)))
                .replace(`{${'playerId'}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(playerOnGameServerSetCurrencyInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk delete POG records by player IDs for a specific gameserver. Deletes POG records only, Player records remain intact.   Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerBulkDelete`
         * @summary Bulk delete
         * @param {string} gameServerId
         * @param {PogBulkDeleteInputDTO} [pogBulkDeleteInputDTO] PogBulkDeleteInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerOnGameServerControllerBulkDelete: async (gameServerId, pogBulkDeleteInputDTO, options = {}) => {
            // verify required parameter 'gameServerId' is not null or undefined
            assertParamExists('playerOnGameServerControllerBulkDelete', 'gameServerId', gameServerId);
            const localVarPath = `/gameserver/{gameServerId}/player`.replace(`{${'gameServerId'}}`, encodeURIComponent(String(gameServerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(pogBulkDeleteInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerDeductCurrency`
         * @summary Deduct currency
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {PlayerOnGameServerSetCurrencyInputDTO} [playerOnGameServerSetCurrencyInputDTO] PlayerOnGameServerSetCurrencyInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerOnGameServerControllerDeductCurrency: async (gameServerId, playerId, playerOnGameServerSetCurrencyInputDTO, options = {}) => {
            // verify required parameter 'gameServerId' is not null or undefined
            assertParamExists('playerOnGameServerControllerDeductCurrency', 'gameServerId', gameServerId);
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('playerOnGameServerControllerDeductCurrency', 'playerId', playerId);
            const localVarPath = `/gameserver/{gameServerId}/player/{playerId}/deduct-currency`
                .replace(`{${'gameServerId'}}`, encodeURIComponent(String(gameServerId)))
                .replace(`{${'playerId'}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(playerOnGameServerSetCurrencyInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerDelete`
         * @summary Delete
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerOnGameServerControllerDelete: async (gameServerId, playerId, options = {}) => {
            // verify required parameter 'gameServerId' is not null or undefined
            assertParamExists('playerOnGameServerControllerDelete', 'gameServerId', gameServerId);
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('playerOnGameServerControllerDelete', 'playerId', playerId);
            const localVarPath = `/gameserver/{gameServerId}/player/{playerId}`
                .replace(`{${'gameServerId'}}`, encodeURIComponent(String(gameServerId)))
                .replace(`{${'playerId'}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerGetOne`
         * @summary Get one
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerOnGameServerControllerGetOne: async (gameServerId, playerId, options = {}) => {
            // verify required parameter 'gameServerId' is not null or undefined
            assertParamExists('playerOnGameServerControllerGetOne', 'gameServerId', gameServerId);
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('playerOnGameServerControllerGetOne', 'playerId', playerId);
            const localVarPath = `/gameserver/{gameServerId}/player/{playerId}`
                .replace(`{${'gameServerId'}}`, encodeURIComponent(String(gameServerId)))
                .replace(`{${'playerId'}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerSearch`
         * @summary Search
         * @param {PlayerOnGameServerSearchInputDTO} [playerOnGameServerSearchInputDTO] PlayerOnGameServerSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerOnGameServerControllerSearch: async (playerOnGameServerSearchInputDTO, options = {}) => {
            const localVarPath = `/gameserver/player/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(playerOnGameServerSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerSetCurrency`
         * @summary Set currency
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {PlayerOnGameServerSetCurrencyInputDTO} [playerOnGameServerSetCurrencyInputDTO] PlayerOnGameServerSetCurrencyInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerOnGameServerControllerSetCurrency: async (gameServerId, playerId, playerOnGameServerSetCurrencyInputDTO, options = {}) => {
            // verify required parameter 'gameServerId' is not null or undefined
            assertParamExists('playerOnGameServerControllerSetCurrency', 'gameServerId', gameServerId);
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('playerOnGameServerControllerSetCurrency', 'playerId', playerId);
            const localVarPath = `/gameserver/{gameServerId}/player/{playerId}/currency`
                .replace(`{${'gameServerId'}}`, encodeURIComponent(String(gameServerId)))
                .replace(`{${'playerId'}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(playerOnGameServerSetCurrencyInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerTransactBetweenPlayers`
         * @summary Transact between players
         * @param {string} gameServerId
         * @param {string} sender
         * @param {string} receiver
         * @param {PlayerOnGameServerSetCurrencyInputDTO} [playerOnGameServerSetCurrencyInputDTO] PlayerOnGameServerSetCurrencyInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerOnGameServerControllerTransactBetweenPlayers: async (gameServerId, sender, receiver, playerOnGameServerSetCurrencyInputDTO, options = {}) => {
            // verify required parameter 'gameServerId' is not null or undefined
            assertParamExists('playerOnGameServerControllerTransactBetweenPlayers', 'gameServerId', gameServerId);
            // verify required parameter 'sender' is not null or undefined
            assertParamExists('playerOnGameServerControllerTransactBetweenPlayers', 'sender', sender);
            // verify required parameter 'receiver' is not null or undefined
            assertParamExists('playerOnGameServerControllerTransactBetweenPlayers', 'receiver', receiver);
            const localVarPath = `/gameserver/{gameServerId}/player/{sender}/{receiver}/transfer`
                .replace(`{${'gameServerId'}}`, encodeURIComponent(String(gameServerId)))
                .replace(`{${'sender'}}`, encodeURIComponent(String(sender)))
                .replace(`{${'receiver'}}`, encodeURIComponent(String(receiver)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(playerOnGameServerSetCurrencyInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PlayerOnGameServerApi - functional programming interface
 * @export
 */
export const PlayerOnGameServerApiFp = function (configuration) {
    const localVarAxiosParamCreator = PlayerOnGameServerApiAxiosParamCreator(configuration);
    return {
        /**
         *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerAddCurrency`
         * @summary Add currency
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {PlayerOnGameServerSetCurrencyInputDTO} [playerOnGameServerSetCurrencyInputDTO] PlayerOnGameServerSetCurrencyInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async playerOnGameServerControllerAddCurrency(gameServerId, playerId, playerOnGameServerSetCurrencyInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.playerOnGameServerControllerAddCurrency(gameServerId, playerId, playerOnGameServerSetCurrencyInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayerOnGameServerApi.playerOnGameServerControllerAddCurrency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bulk delete POG records by player IDs for a specific gameserver. Deletes POG records only, Player records remain intact.   Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerBulkDelete`
         * @summary Bulk delete
         * @param {string} gameServerId
         * @param {PogBulkDeleteInputDTO} [pogBulkDeleteInputDTO] PogBulkDeleteInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async playerOnGameServerControllerBulkDelete(gameServerId, pogBulkDeleteInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.playerOnGameServerControllerBulkDelete(gameServerId, pogBulkDeleteInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayerOnGameServerApi.playerOnGameServerControllerBulkDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerDeductCurrency`
         * @summary Deduct currency
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {PlayerOnGameServerSetCurrencyInputDTO} [playerOnGameServerSetCurrencyInputDTO] PlayerOnGameServerSetCurrencyInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async playerOnGameServerControllerDeductCurrency(gameServerId, playerId, playerOnGameServerSetCurrencyInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.playerOnGameServerControllerDeductCurrency(gameServerId, playerId, playerOnGameServerSetCurrencyInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayerOnGameServerApi.playerOnGameServerControllerDeductCurrency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerDelete`
         * @summary Delete
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async playerOnGameServerControllerDelete(gameServerId, playerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.playerOnGameServerControllerDelete(gameServerId, playerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayerOnGameServerApi.playerOnGameServerControllerDelete']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerGetOne`
         * @summary Get one
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async playerOnGameServerControllerGetOne(gameServerId, playerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.playerOnGameServerControllerGetOne(gameServerId, playerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayerOnGameServerApi.playerOnGameServerControllerGetOne']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerSearch`
         * @summary Search
         * @param {PlayerOnGameServerSearchInputDTO} [playerOnGameServerSearchInputDTO] PlayerOnGameServerSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async playerOnGameServerControllerSearch(playerOnGameServerSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.playerOnGameServerControllerSearch(playerOnGameServerSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayerOnGameServerApi.playerOnGameServerControllerSearch']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerSetCurrency`
         * @summary Set currency
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {PlayerOnGameServerSetCurrencyInputDTO} [playerOnGameServerSetCurrencyInputDTO] PlayerOnGameServerSetCurrencyInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async playerOnGameServerControllerSetCurrency(gameServerId, playerId, playerOnGameServerSetCurrencyInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.playerOnGameServerControllerSetCurrency(gameServerId, playerId, playerOnGameServerSetCurrencyInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayerOnGameServerApi.playerOnGameServerControllerSetCurrency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerTransactBetweenPlayers`
         * @summary Transact between players
         * @param {string} gameServerId
         * @param {string} sender
         * @param {string} receiver
         * @param {PlayerOnGameServerSetCurrencyInputDTO} [playerOnGameServerSetCurrencyInputDTO] PlayerOnGameServerSetCurrencyInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async playerOnGameServerControllerTransactBetweenPlayers(gameServerId, sender, receiver, playerOnGameServerSetCurrencyInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.playerOnGameServerControllerTransactBetweenPlayers(gameServerId, sender, receiver, playerOnGameServerSetCurrencyInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayerOnGameServerApi.playerOnGameServerControllerTransactBetweenPlayers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PlayerOnGameServerApi - factory interface
 * @export
 */
export const PlayerOnGameServerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PlayerOnGameServerApiFp(configuration);
    return {
        /**
         *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerAddCurrency`
         * @summary Add currency
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {PlayerOnGameServerSetCurrencyInputDTO} [playerOnGameServerSetCurrencyInputDTO] PlayerOnGameServerSetCurrencyInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerOnGameServerControllerAddCurrency(gameServerId, playerId, playerOnGameServerSetCurrencyInputDTO, options) {
            return localVarFp
                .playerOnGameServerControllerAddCurrency(gameServerId, playerId, playerOnGameServerSetCurrencyInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Bulk delete POG records by player IDs for a specific gameserver. Deletes POG records only, Player records remain intact.   Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerBulkDelete`
         * @summary Bulk delete
         * @param {string} gameServerId
         * @param {PogBulkDeleteInputDTO} [pogBulkDeleteInputDTO] PogBulkDeleteInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerOnGameServerControllerBulkDelete(gameServerId, pogBulkDeleteInputDTO, options) {
            return localVarFp
                .playerOnGameServerControllerBulkDelete(gameServerId, pogBulkDeleteInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerDeductCurrency`
         * @summary Deduct currency
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {PlayerOnGameServerSetCurrencyInputDTO} [playerOnGameServerSetCurrencyInputDTO] PlayerOnGameServerSetCurrencyInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerOnGameServerControllerDeductCurrency(gameServerId, playerId, playerOnGameServerSetCurrencyInputDTO, options) {
            return localVarFp
                .playerOnGameServerControllerDeductCurrency(gameServerId, playerId, playerOnGameServerSetCurrencyInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerDelete`
         * @summary Delete
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerOnGameServerControllerDelete(gameServerId, playerId, options) {
            return localVarFp
                .playerOnGameServerControllerDelete(gameServerId, playerId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerGetOne`
         * @summary Get one
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerOnGameServerControllerGetOne(gameServerId, playerId, options) {
            return localVarFp
                .playerOnGameServerControllerGetOne(gameServerId, playerId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerSearch`
         * @summary Search
         * @param {PlayerOnGameServerSearchInputDTO} [playerOnGameServerSearchInputDTO] PlayerOnGameServerSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerOnGameServerControllerSearch(playerOnGameServerSearchInputDTO, options) {
            return localVarFp
                .playerOnGameServerControllerSearch(playerOnGameServerSearchInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerSetCurrency`
         * @summary Set currency
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {PlayerOnGameServerSetCurrencyInputDTO} [playerOnGameServerSetCurrencyInputDTO] PlayerOnGameServerSetCurrencyInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerOnGameServerControllerSetCurrency(gameServerId, playerId, playerOnGameServerSetCurrencyInputDTO, options) {
            return localVarFp
                .playerOnGameServerControllerSetCurrency(gameServerId, playerId, playerOnGameServerSetCurrencyInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerTransactBetweenPlayers`
         * @summary Transact between players
         * @param {string} gameServerId
         * @param {string} sender
         * @param {string} receiver
         * @param {PlayerOnGameServerSetCurrencyInputDTO} [playerOnGameServerSetCurrencyInputDTO] PlayerOnGameServerSetCurrencyInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playerOnGameServerControllerTransactBetweenPlayers(gameServerId, sender, receiver, playerOnGameServerSetCurrencyInputDTO, options) {
            return localVarFp
                .playerOnGameServerControllerTransactBetweenPlayers(gameServerId, sender, receiver, playerOnGameServerSetCurrencyInputDTO, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * PlayerOnGameServerApi - object-oriented interface
 * @export
 * @class PlayerOnGameServerApi
 * @extends {BaseAPI}
 */
export class PlayerOnGameServerApi extends BaseAPI {
    /**
     *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerAddCurrency`
     * @summary Add currency
     * @param {string} gameServerId
     * @param {string} playerId
     * @param {PlayerOnGameServerSetCurrencyInputDTO} [playerOnGameServerSetCurrencyInputDTO] PlayerOnGameServerSetCurrencyInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerOnGameServerApi
     */
    playerOnGameServerControllerAddCurrency(gameServerId, playerId, playerOnGameServerSetCurrencyInputDTO, options) {
        return PlayerOnGameServerApiFp(this.configuration)
            .playerOnGameServerControllerAddCurrency(gameServerId, playerId, playerOnGameServerSetCurrencyInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Bulk delete POG records by player IDs for a specific gameserver. Deletes POG records only, Player records remain intact.   Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerBulkDelete`
     * @summary Bulk delete
     * @param {string} gameServerId
     * @param {PogBulkDeleteInputDTO} [pogBulkDeleteInputDTO] PogBulkDeleteInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerOnGameServerApi
     */
    playerOnGameServerControllerBulkDelete(gameServerId, pogBulkDeleteInputDTO, options) {
        return PlayerOnGameServerApiFp(this.configuration)
            .playerOnGameServerControllerBulkDelete(gameServerId, pogBulkDeleteInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerDeductCurrency`
     * @summary Deduct currency
     * @param {string} gameServerId
     * @param {string} playerId
     * @param {PlayerOnGameServerSetCurrencyInputDTO} [playerOnGameServerSetCurrencyInputDTO] PlayerOnGameServerSetCurrencyInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerOnGameServerApi
     */
    playerOnGameServerControllerDeductCurrency(gameServerId, playerId, playerOnGameServerSetCurrencyInputDTO, options) {
        return PlayerOnGameServerApiFp(this.configuration)
            .playerOnGameServerControllerDeductCurrency(gameServerId, playerId, playerOnGameServerSetCurrencyInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerDelete`
     * @summary Delete
     * @param {string} gameServerId
     * @param {string} playerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerOnGameServerApi
     */
    playerOnGameServerControllerDelete(gameServerId, playerId, options) {
        return PlayerOnGameServerApiFp(this.configuration)
            .playerOnGameServerControllerDelete(gameServerId, playerId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerGetOne`
     * @summary Get one
     * @param {string} gameServerId
     * @param {string} playerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerOnGameServerApi
     */
    playerOnGameServerControllerGetOne(gameServerId, playerId, options) {
        return PlayerOnGameServerApiFp(this.configuration)
            .playerOnGameServerControllerGetOne(gameServerId, playerId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerSearch`
     * @summary Search
     * @param {PlayerOnGameServerSearchInputDTO} [playerOnGameServerSearchInputDTO] PlayerOnGameServerSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerOnGameServerApi
     */
    playerOnGameServerControllerSearch(playerOnGameServerSearchInputDTO, options) {
        return PlayerOnGameServerApiFp(this.configuration)
            .playerOnGameServerControllerSearch(playerOnGameServerSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerSetCurrency`
     * @summary Set currency
     * @param {string} gameServerId
     * @param {string} playerId
     * @param {PlayerOnGameServerSetCurrencyInputDTO} [playerOnGameServerSetCurrencyInputDTO] PlayerOnGameServerSetCurrencyInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerOnGameServerApi
     */
    playerOnGameServerControllerSetCurrency(gameServerId, playerId, playerOnGameServerSetCurrencyInputDTO, options) {
        return PlayerOnGameServerApiFp(this.configuration)
            .playerOnGameServerControllerSetCurrency(gameServerId, playerId, playerOnGameServerSetCurrencyInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_PLAYERS`<br> OperationId: `PlayerOnGameServerControllerTransactBetweenPlayers`
     * @summary Transact between players
     * @param {string} gameServerId
     * @param {string} sender
     * @param {string} receiver
     * @param {PlayerOnGameServerSetCurrencyInputDTO} [playerOnGameServerSetCurrencyInputDTO] PlayerOnGameServerSetCurrencyInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerOnGameServerApi
     */
    playerOnGameServerControllerTransactBetweenPlayers(gameServerId, sender, receiver, playerOnGameServerSetCurrencyInputDTO, options) {
        return PlayerOnGameServerApiFp(this.configuration)
            .playerOnGameServerControllerTransactBetweenPlayers(gameServerId, sender, receiver, playerOnGameServerSetCurrencyInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * RoleApi - axios parameter creator
 * @export
 */
export const RoleApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *    Required permissions: `MANAGE_ROLES`<br> OperationId: `RoleControllerCreate`
         * @summary Create
         * @param {RoleCreateInputDTO} [roleCreateInputDTO] RoleCreateInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleControllerCreate: async (roleCreateInputDTO, options = {}) => {
            const localVarPath = `/role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(roleCreateInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_ROLES`<br> OperationId: `RoleControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleControllerGetOne: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('roleControllerGetOne', 'id', id);
            const localVarPath = `/role/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <br> OperationId: `RoleControllerGetPermissions`
         * @summary Get permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleControllerGetPermissions: async (options = {}) => {
            const localVarPath = `/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_ROLES`<br> OperationId: `RoleControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleControllerRemove: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('roleControllerRemove', 'id', id);
            const localVarPath = `/role/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_ROLES`<br> OperationId: `RoleControllerSearch`
         * @summary Search
         * @param {RoleSearchInputDTO} [roleSearchInputDTO] RoleSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleControllerSearch: async (roleSearchInputDTO, options = {}) => {
            const localVarPath = `/role/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(roleSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_ROLES`<br> OperationId: `RoleControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {RoleUpdateInputDTO} [roleUpdateInputDTO] RoleUpdateInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleControllerUpdate: async (id, roleUpdateInputDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('roleControllerUpdate', 'id', id);
            const localVarPath = `/role/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(roleUpdateInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RoleApi - functional programming interface
 * @export
 */
export const RoleApiFp = function (configuration) {
    const localVarAxiosParamCreator = RoleApiAxiosParamCreator(configuration);
    return {
        /**
         *    Required permissions: `MANAGE_ROLES`<br> OperationId: `RoleControllerCreate`
         * @summary Create
         * @param {RoleCreateInputDTO} [roleCreateInputDTO] RoleCreateInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roleControllerCreate(roleCreateInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roleControllerCreate(roleCreateInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoleApi.roleControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_ROLES`<br> OperationId: `RoleControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roleControllerGetOne(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roleControllerGetOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoleApi.roleControllerGetOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <br> OperationId: `RoleControllerGetPermissions`
         * @summary Get permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roleControllerGetPermissions(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roleControllerGetPermissions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoleApi.roleControllerGetPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_ROLES`<br> OperationId: `RoleControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roleControllerRemove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roleControllerRemove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoleApi.roleControllerRemove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_ROLES`<br> OperationId: `RoleControllerSearch`
         * @summary Search
         * @param {RoleSearchInputDTO} [roleSearchInputDTO] RoleSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roleControllerSearch(roleSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roleControllerSearch(roleSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoleApi.roleControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_ROLES`<br> OperationId: `RoleControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {RoleUpdateInputDTO} [roleUpdateInputDTO] RoleUpdateInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roleControllerUpdate(id, roleUpdateInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roleControllerUpdate(id, roleUpdateInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoleApi.roleControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * RoleApi - factory interface
 * @export
 */
export const RoleApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RoleApiFp(configuration);
    return {
        /**
         *    Required permissions: `MANAGE_ROLES`<br> OperationId: `RoleControllerCreate`
         * @summary Create
         * @param {RoleCreateInputDTO} [roleCreateInputDTO] RoleCreateInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleControllerCreate(roleCreateInputDTO, options) {
            return localVarFp.roleControllerCreate(roleCreateInputDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_ROLES`<br> OperationId: `RoleControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleControllerGetOne(id, options) {
            return localVarFp.roleControllerGetOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * <br> OperationId: `RoleControllerGetPermissions`
         * @summary Get permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleControllerGetPermissions(options) {
            return localVarFp.roleControllerGetPermissions(options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_ROLES`<br> OperationId: `RoleControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleControllerRemove(id, options) {
            return localVarFp.roleControllerRemove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_ROLES`<br> OperationId: `RoleControllerSearch`
         * @summary Search
         * @param {RoleSearchInputDTO} [roleSearchInputDTO] RoleSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleControllerSearch(roleSearchInputDTO, options) {
            return localVarFp.roleControllerSearch(roleSearchInputDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_ROLES`<br> OperationId: `RoleControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {RoleUpdateInputDTO} [roleUpdateInputDTO] RoleUpdateInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleControllerUpdate(id, roleUpdateInputDTO, options) {
            return localVarFp
                .roleControllerUpdate(id, roleUpdateInputDTO, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * RoleApi - object-oriented interface
 * @export
 * @class RoleApi
 * @extends {BaseAPI}
 */
export class RoleApi extends BaseAPI {
    /**
     *    Required permissions: `MANAGE_ROLES`<br> OperationId: `RoleControllerCreate`
     * @summary Create
     * @param {RoleCreateInputDTO} [roleCreateInputDTO] RoleCreateInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    roleControllerCreate(roleCreateInputDTO, options) {
        return RoleApiFp(this.configuration)
            .roleControllerCreate(roleCreateInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_ROLES`<br> OperationId: `RoleControllerGetOne`
     * @summary Get one
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    roleControllerGetOne(id, options) {
        return RoleApiFp(this.configuration)
            .roleControllerGetOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * <br> OperationId: `RoleControllerGetPermissions`
     * @summary Get permissions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    roleControllerGetPermissions(options) {
        return RoleApiFp(this.configuration)
            .roleControllerGetPermissions(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_ROLES`<br> OperationId: `RoleControllerRemove`
     * @summary Remove
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    roleControllerRemove(id, options) {
        return RoleApiFp(this.configuration)
            .roleControllerRemove(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_ROLES`<br> OperationId: `RoleControllerSearch`
     * @summary Search
     * @param {RoleSearchInputDTO} [roleSearchInputDTO] RoleSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    roleControllerSearch(roleSearchInputDTO, options) {
        return RoleApiFp(this.configuration)
            .roleControllerSearch(roleSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_ROLES`<br> OperationId: `RoleControllerUpdate`
     * @summary Update
     * @param {string} id
     * @param {RoleUpdateInputDTO} [roleUpdateInputDTO] RoleUpdateInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    roleControllerUpdate(id, roleUpdateInputDTO, options) {
        return RoleApiFp(this.configuration)
            .roleControllerUpdate(id, roleUpdateInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SettingsApi - axios parameter creator
 * @export
 */
export const SettingsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *    Required permissions: `MANAGE_SETTINGS`<br> OperationId: `SettingsControllerDelete`
         * @summary Delete
         * @param {string} key
         * @param {string} [gameServerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingsControllerDelete: async (key, gameServerId, options = {}) => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('settingsControllerDelete', 'key', key);
            const localVarPath = `/settings/{key}`.replace(`{${'key'}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            if (gameServerId !== undefined) {
                localVarQueryParameter['gameServerId'] = gameServerId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <br> OperationId: `SettingsControllerGet`
         * @summary Get
         * @param {Array<SettingsControllerGetKeysEnum>} [keys]
         * @param {string} [gameServerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingsControllerGet: async (keys, gameServerId, options = {}) => {
            const localVarPath = `/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            if (keys) {
                localVarQueryParameter['keys'] = keys;
            }
            if (gameServerId !== undefined) {
                localVarQueryParameter['gameServerId'] = gameServerId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <br> OperationId: `SettingsControllerGetOne`
         * @summary Get one
         * @param {string} key
         * @param {string} [gameServerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingsControllerGetOne: async (key, gameServerId, options = {}) => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('settingsControllerGetOne', 'key', key);
            const localVarPath = `/settings/{key}`.replace(`{${'key'}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            if (gameServerId !== undefined) {
                localVarQueryParameter['gameServerId'] = gameServerId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_SETTINGS`<br> OperationId: `SettingsControllerSet`
         * @summary Set
         * @param {string} key
         * @param {SettingsSetDTO} [settingsSetDTO] SettingsSetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingsControllerSet: async (key, settingsSetDTO, options = {}) => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('settingsControllerSet', 'key', key);
            const localVarPath = `/settings/{key}`.replace(`{${'key'}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(settingsSetDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SettingsApi - functional programming interface
 * @export
 */
export const SettingsApiFp = function (configuration) {
    const localVarAxiosParamCreator = SettingsApiAxiosParamCreator(configuration);
    return {
        /**
         *    Required permissions: `MANAGE_SETTINGS`<br> OperationId: `SettingsControllerDelete`
         * @summary Delete
         * @param {string} key
         * @param {string} [gameServerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settingsControllerDelete(key, gameServerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settingsControllerDelete(key, gameServerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.settingsControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <br> OperationId: `SettingsControllerGet`
         * @summary Get
         * @param {Array<SettingsControllerGetKeysEnum>} [keys]
         * @param {string} [gameServerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settingsControllerGet(keys, gameServerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settingsControllerGet(keys, gameServerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.settingsControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <br> OperationId: `SettingsControllerGetOne`
         * @summary Get one
         * @param {string} key
         * @param {string} [gameServerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settingsControllerGetOne(key, gameServerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settingsControllerGetOne(key, gameServerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.settingsControllerGetOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_SETTINGS`<br> OperationId: `SettingsControllerSet`
         * @summary Set
         * @param {string} key
         * @param {SettingsSetDTO} [settingsSetDTO] SettingsSetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settingsControllerSet(key, settingsSetDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settingsControllerSet(key, settingsSetDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.settingsControllerSet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SettingsApi - factory interface
 * @export
 */
export const SettingsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SettingsApiFp(configuration);
    return {
        /**
         *    Required permissions: `MANAGE_SETTINGS`<br> OperationId: `SettingsControllerDelete`
         * @summary Delete
         * @param {string} key
         * @param {string} [gameServerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingsControllerDelete(key, gameServerId, options) {
            return localVarFp
                .settingsControllerDelete(key, gameServerId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * <br> OperationId: `SettingsControllerGet`
         * @summary Get
         * @param {Array<SettingsControllerGetKeysEnum>} [keys]
         * @param {string} [gameServerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingsControllerGet(keys, gameServerId, options) {
            return localVarFp.settingsControllerGet(keys, gameServerId, options).then((request) => request(axios, basePath));
        },
        /**
         * <br> OperationId: `SettingsControllerGetOne`
         * @summary Get one
         * @param {string} key
         * @param {string} [gameServerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingsControllerGetOne(key, gameServerId, options) {
            return localVarFp
                .settingsControllerGetOne(key, gameServerId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_SETTINGS`<br> OperationId: `SettingsControllerSet`
         * @summary Set
         * @param {string} key
         * @param {SettingsSetDTO} [settingsSetDTO] SettingsSetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingsControllerSet(key, settingsSetDTO, options) {
            return localVarFp.settingsControllerSet(key, settingsSetDTO, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SettingsApi - object-oriented interface
 * @export
 * @class SettingsApi
 * @extends {BaseAPI}
 */
export class SettingsApi extends BaseAPI {
    /**
     *    Required permissions: `MANAGE_SETTINGS`<br> OperationId: `SettingsControllerDelete`
     * @summary Delete
     * @param {string} key
     * @param {string} [gameServerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    settingsControllerDelete(key, gameServerId, options) {
        return SettingsApiFp(this.configuration)
            .settingsControllerDelete(key, gameServerId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * <br> OperationId: `SettingsControllerGet`
     * @summary Get
     * @param {Array<SettingsControllerGetKeysEnum>} [keys]
     * @param {string} [gameServerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    settingsControllerGet(keys, gameServerId, options) {
        return SettingsApiFp(this.configuration)
            .settingsControllerGet(keys, gameServerId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * <br> OperationId: `SettingsControllerGetOne`
     * @summary Get one
     * @param {string} key
     * @param {string} [gameServerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    settingsControllerGetOne(key, gameServerId, options) {
        return SettingsApiFp(this.configuration)
            .settingsControllerGetOne(key, gameServerId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_SETTINGS`<br> OperationId: `SettingsControllerSet`
     * @summary Set
     * @param {string} key
     * @param {SettingsSetDTO} [settingsSetDTO] SettingsSetDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    settingsControllerSet(key, settingsSetDTO, options) {
        return SettingsApiFp(this.configuration)
            .settingsControllerSet(key, settingsSetDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const SettingsControllerGetKeysEnum = {
    CommandPrefix: 'commandPrefix',
    ServerChatName: 'serverChatName',
    EconomyEnabled: 'economyEnabled',
    CurrencyName: 'currencyName',
    DeveloperMode: 'developerMode',
    MessagePrefix: 'messagePrefix',
    DomainName: 'domainName',
    DiscordRoleSyncEnabled: 'discordRoleSyncEnabled',
    DiscordRoleSyncPreferDiscord: 'discordRoleSyncPreferDiscord',
    UnknownCommandFeedbackEnabled: 'unknownCommandFeedbackEnabled',
    UnknownCommandFeedbackMessage: 'unknownCommandFeedbackMessage',
};
/**
 * ShopCategoryApi - axios parameter creator
 * @export
 */
export const ShopCategoryApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Bulk assign categories to multiple shop listings   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopCategoryControllerBulkAssign`
         * @summary Bulk assign
         * @param {ShopCategoryBulkAssignDTO} [shopCategoryBulkAssignDTO] ShopCategoryBulkAssignDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopCategoryControllerBulkAssign: async (shopCategoryBulkAssignDTO, options = {}) => {
            const localVarPath = `/shop/category/bulk-assign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(shopCategoryBulkAssignDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new shop category   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopCategoryControllerCreate`
         * @summary Create
         * @param {ShopCategoryCreateDTO} [shopCategoryCreateDTO] ShopCategoryCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopCategoryControllerCreate: async (shopCategoryCreateDTO, options = {}) => {
            const localVarPath = `/shop/category/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(shopCategoryCreateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all shop categories<br> OperationId: `ShopCategoryControllerGetAll`
         * @summary Get all
         * @param {string} [gameServerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopCategoryControllerGetAll: async (gameServerId, options = {}) => {
            const localVarPath = `/shop/category/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            if (gameServerId !== undefined) {
                localVarQueryParameter['gameServerId'] = gameServerId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a shop category by id<br> OperationId: `ShopCategoryControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {string} [gameServerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopCategoryControllerGetOne: async (id, gameServerId, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('shopCategoryControllerGetOne', 'id', id);
            const localVarPath = `/shop/category/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            if (gameServerId !== undefined) {
                localVarQueryParameter['gameServerId'] = gameServerId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Move a shop category to a different parent   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopCategoryControllerMove`
         * @summary Move
         * @param {string} id
         * @param {ShopCategoryMoveDTO} [shopCategoryMoveDTO] ShopCategoryMoveDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopCategoryControllerMove: async (id, shopCategoryMoveDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('shopCategoryControllerMove', 'id', id);
            const localVarPath = `/shop/category/{id}/move`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(shopCategoryMoveDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a shop category   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopCategoryControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopCategoryControllerRemove: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('shopCategoryControllerRemove', 'id', id);
            const localVarPath = `/shop/category/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search shop categories<br> OperationId: `ShopCategoryControllerSearch`
         * @summary Search
         * @param {ShopCategorySearchInputDTO} [shopCategorySearchInputDTO] ShopCategorySearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopCategoryControllerSearch: async (shopCategorySearchInputDTO, options = {}) => {
            const localVarPath = `/shop/category/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(shopCategorySearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a shop category   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopCategoryControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {ShopCategoryUpdateDTO} [shopCategoryUpdateDTO] ShopCategoryUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopCategoryControllerUpdate: async (id, shopCategoryUpdateDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('shopCategoryControllerUpdate', 'id', id);
            const localVarPath = `/shop/category/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(shopCategoryUpdateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ShopCategoryApi - functional programming interface
 * @export
 */
export const ShopCategoryApiFp = function (configuration) {
    const localVarAxiosParamCreator = ShopCategoryApiAxiosParamCreator(configuration);
    return {
        /**
         * Bulk assign categories to multiple shop listings   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopCategoryControllerBulkAssign`
         * @summary Bulk assign
         * @param {ShopCategoryBulkAssignDTO} [shopCategoryBulkAssignDTO] ShopCategoryBulkAssignDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopCategoryControllerBulkAssign(shopCategoryBulkAssignDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopCategoryControllerBulkAssign(shopCategoryBulkAssignDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopCategoryApi.shopCategoryControllerBulkAssign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new shop category   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopCategoryControllerCreate`
         * @summary Create
         * @param {ShopCategoryCreateDTO} [shopCategoryCreateDTO] ShopCategoryCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopCategoryControllerCreate(shopCategoryCreateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopCategoryControllerCreate(shopCategoryCreateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopCategoryApi.shopCategoryControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all shop categories<br> OperationId: `ShopCategoryControllerGetAll`
         * @summary Get all
         * @param {string} [gameServerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopCategoryControllerGetAll(gameServerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopCategoryControllerGetAll(gameServerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopCategoryApi.shopCategoryControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a shop category by id<br> OperationId: `ShopCategoryControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {string} [gameServerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopCategoryControllerGetOne(id, gameServerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopCategoryControllerGetOne(id, gameServerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopCategoryApi.shopCategoryControllerGetOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Move a shop category to a different parent   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopCategoryControllerMove`
         * @summary Move
         * @param {string} id
         * @param {ShopCategoryMoveDTO} [shopCategoryMoveDTO] ShopCategoryMoveDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopCategoryControllerMove(id, shopCategoryMoveDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopCategoryControllerMove(id, shopCategoryMoveDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopCategoryApi.shopCategoryControllerMove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a shop category   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopCategoryControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopCategoryControllerRemove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopCategoryControllerRemove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopCategoryApi.shopCategoryControllerRemove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search shop categories<br> OperationId: `ShopCategoryControllerSearch`
         * @summary Search
         * @param {ShopCategorySearchInputDTO} [shopCategorySearchInputDTO] ShopCategorySearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopCategoryControllerSearch(shopCategorySearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopCategoryControllerSearch(shopCategorySearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopCategoryApi.shopCategoryControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a shop category   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopCategoryControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {ShopCategoryUpdateDTO} [shopCategoryUpdateDTO] ShopCategoryUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopCategoryControllerUpdate(id, shopCategoryUpdateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopCategoryControllerUpdate(id, shopCategoryUpdateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopCategoryApi.shopCategoryControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ShopCategoryApi - factory interface
 * @export
 */
export const ShopCategoryApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ShopCategoryApiFp(configuration);
    return {
        /**
         * Bulk assign categories to multiple shop listings   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopCategoryControllerBulkAssign`
         * @summary Bulk assign
         * @param {ShopCategoryBulkAssignDTO} [shopCategoryBulkAssignDTO] ShopCategoryBulkAssignDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopCategoryControllerBulkAssign(shopCategoryBulkAssignDTO, options) {
            return localVarFp
                .shopCategoryControllerBulkAssign(shopCategoryBulkAssignDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a new shop category   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopCategoryControllerCreate`
         * @summary Create
         * @param {ShopCategoryCreateDTO} [shopCategoryCreateDTO] ShopCategoryCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopCategoryControllerCreate(shopCategoryCreateDTO, options) {
            return localVarFp
                .shopCategoryControllerCreate(shopCategoryCreateDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get all shop categories<br> OperationId: `ShopCategoryControllerGetAll`
         * @summary Get all
         * @param {string} [gameServerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopCategoryControllerGetAll(gameServerId, options) {
            return localVarFp.shopCategoryControllerGetAll(gameServerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a shop category by id<br> OperationId: `ShopCategoryControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {string} [gameServerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopCategoryControllerGetOne(id, gameServerId, options) {
            return localVarFp
                .shopCategoryControllerGetOne(id, gameServerId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Move a shop category to a different parent   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopCategoryControllerMove`
         * @summary Move
         * @param {string} id
         * @param {ShopCategoryMoveDTO} [shopCategoryMoveDTO] ShopCategoryMoveDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopCategoryControllerMove(id, shopCategoryMoveDTO, options) {
            return localVarFp
                .shopCategoryControllerMove(id, shopCategoryMoveDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Delete a shop category   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopCategoryControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopCategoryControllerRemove(id, options) {
            return localVarFp.shopCategoryControllerRemove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Search shop categories<br> OperationId: `ShopCategoryControllerSearch`
         * @summary Search
         * @param {ShopCategorySearchInputDTO} [shopCategorySearchInputDTO] ShopCategorySearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopCategoryControllerSearch(shopCategorySearchInputDTO, options) {
            return localVarFp
                .shopCategoryControllerSearch(shopCategorySearchInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update a shop category   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopCategoryControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {ShopCategoryUpdateDTO} [shopCategoryUpdateDTO] ShopCategoryUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopCategoryControllerUpdate(id, shopCategoryUpdateDTO, options) {
            return localVarFp
                .shopCategoryControllerUpdate(id, shopCategoryUpdateDTO, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * ShopCategoryApi - object-oriented interface
 * @export
 * @class ShopCategoryApi
 * @extends {BaseAPI}
 */
export class ShopCategoryApi extends BaseAPI {
    /**
     * Bulk assign categories to multiple shop listings   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopCategoryControllerBulkAssign`
     * @summary Bulk assign
     * @param {ShopCategoryBulkAssignDTO} [shopCategoryBulkAssignDTO] ShopCategoryBulkAssignDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopCategoryApi
     */
    shopCategoryControllerBulkAssign(shopCategoryBulkAssignDTO, options) {
        return ShopCategoryApiFp(this.configuration)
            .shopCategoryControllerBulkAssign(shopCategoryBulkAssignDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new shop category   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopCategoryControllerCreate`
     * @summary Create
     * @param {ShopCategoryCreateDTO} [shopCategoryCreateDTO] ShopCategoryCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopCategoryApi
     */
    shopCategoryControllerCreate(shopCategoryCreateDTO, options) {
        return ShopCategoryApiFp(this.configuration)
            .shopCategoryControllerCreate(shopCategoryCreateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all shop categories<br> OperationId: `ShopCategoryControllerGetAll`
     * @summary Get all
     * @param {string} [gameServerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopCategoryApi
     */
    shopCategoryControllerGetAll(gameServerId, options) {
        return ShopCategoryApiFp(this.configuration)
            .shopCategoryControllerGetAll(gameServerId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a shop category by id<br> OperationId: `ShopCategoryControllerGetOne`
     * @summary Get one
     * @param {string} id
     * @param {string} [gameServerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopCategoryApi
     */
    shopCategoryControllerGetOne(id, gameServerId, options) {
        return ShopCategoryApiFp(this.configuration)
            .shopCategoryControllerGetOne(id, gameServerId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Move a shop category to a different parent   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopCategoryControllerMove`
     * @summary Move
     * @param {string} id
     * @param {ShopCategoryMoveDTO} [shopCategoryMoveDTO] ShopCategoryMoveDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopCategoryApi
     */
    shopCategoryControllerMove(id, shopCategoryMoveDTO, options) {
        return ShopCategoryApiFp(this.configuration)
            .shopCategoryControllerMove(id, shopCategoryMoveDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete a shop category   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopCategoryControllerRemove`
     * @summary Remove
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopCategoryApi
     */
    shopCategoryControllerRemove(id, options) {
        return ShopCategoryApiFp(this.configuration)
            .shopCategoryControllerRemove(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search shop categories<br> OperationId: `ShopCategoryControllerSearch`
     * @summary Search
     * @param {ShopCategorySearchInputDTO} [shopCategorySearchInputDTO] ShopCategorySearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopCategoryApi
     */
    shopCategoryControllerSearch(shopCategorySearchInputDTO, options) {
        return ShopCategoryApiFp(this.configuration)
            .shopCategoryControllerSearch(shopCategorySearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update a shop category   Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopCategoryControllerUpdate`
     * @summary Update
     * @param {string} id
     * @param {ShopCategoryUpdateDTO} [shopCategoryUpdateDTO] ShopCategoryUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopCategoryApi
     */
    shopCategoryControllerUpdate(id, shopCategoryUpdateDTO, options) {
        return ShopCategoryApiFp(this.configuration)
            .shopCategoryControllerUpdate(id, shopCategoryUpdateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ShopListingApi - axios parameter creator
 * @export
 */
export const ShopListingApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *    Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopListingControllerCreate`
         * @summary Create
         * @param {ShopListingCreateDTO} [shopListingCreateDTO] ShopListingCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopListingControllerCreate: async (shopListingCreateDTO, options = {}) => {
            const localVarPath = `/shop/listing/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(shopListingCreateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopListingControllerDelete`
         * @summary Delete
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopListingControllerDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('shopListingControllerDelete', 'id', id);
            const localVarPath = `/shop/listing/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <br> OperationId: `ShopListingControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopListingControllerGetOne: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('shopListingControllerGetOne', 'id', id);
            const localVarPath = `/shop/listing/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopListingControllerImportListings`
         * @summary Import listings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopListingControllerImportListings: async (options = {}) => {
            const localVarPath = `/shop/listing/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search shop listings<br> OperationId: `ShopListingControllerSearch`
         * @summary Search
         * @param {ShopListingSearchInputDTO} [shopListingSearchInputDTO] ShopListingSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopListingControllerSearch: async (shopListingSearchInputDTO, options = {}) => {
            const localVarPath = `/shop/listing/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(shopListingSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopListingControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {ShopListingUpdateDTO} [shopListingUpdateDTO] ShopListingUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopListingControllerUpdate: async (id, shopListingUpdateDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('shopListingControllerUpdate', 'id', id);
            const localVarPath = `/shop/listing/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(shopListingUpdateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ShopListingApi - functional programming interface
 * @export
 */
export const ShopListingApiFp = function (configuration) {
    const localVarAxiosParamCreator = ShopListingApiAxiosParamCreator(configuration);
    return {
        /**
         *    Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopListingControllerCreate`
         * @summary Create
         * @param {ShopListingCreateDTO} [shopListingCreateDTO] ShopListingCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopListingControllerCreate(shopListingCreateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopListingControllerCreate(shopListingCreateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopListingApi.shopListingControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopListingControllerDelete`
         * @summary Delete
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopListingControllerDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopListingControllerDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopListingApi.shopListingControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <br> OperationId: `ShopListingControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopListingControllerGetOne(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopListingControllerGetOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopListingApi.shopListingControllerGetOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopListingControllerImportListings`
         * @summary Import listings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopListingControllerImportListings(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopListingControllerImportListings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopListingApi.shopListingControllerImportListings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search shop listings<br> OperationId: `ShopListingControllerSearch`
         * @summary Search
         * @param {ShopListingSearchInputDTO} [shopListingSearchInputDTO] ShopListingSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopListingControllerSearch(shopListingSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopListingControllerSearch(shopListingSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopListingApi.shopListingControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopListingControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {ShopListingUpdateDTO} [shopListingUpdateDTO] ShopListingUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopListingControllerUpdate(id, shopListingUpdateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopListingControllerUpdate(id, shopListingUpdateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopListingApi.shopListingControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ShopListingApi - factory interface
 * @export
 */
export const ShopListingApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ShopListingApiFp(configuration);
    return {
        /**
         *    Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopListingControllerCreate`
         * @summary Create
         * @param {ShopListingCreateDTO} [shopListingCreateDTO] ShopListingCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopListingControllerCreate(shopListingCreateDTO, options) {
            return localVarFp
                .shopListingControllerCreate(shopListingCreateDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopListingControllerDelete`
         * @summary Delete
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopListingControllerDelete(id, options) {
            return localVarFp.shopListingControllerDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * <br> OperationId: `ShopListingControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopListingControllerGetOne(id, options) {
            return localVarFp.shopListingControllerGetOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopListingControllerImportListings`
         * @summary Import listings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopListingControllerImportListings(options) {
            return localVarFp.shopListingControllerImportListings(options).then((request) => request(axios, basePath));
        },
        /**
         * Search shop listings<br> OperationId: `ShopListingControllerSearch`
         * @summary Search
         * @param {ShopListingSearchInputDTO} [shopListingSearchInputDTO] ShopListingSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopListingControllerSearch(shopListingSearchInputDTO, options) {
            return localVarFp
                .shopListingControllerSearch(shopListingSearchInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopListingControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {ShopListingUpdateDTO} [shopListingUpdateDTO] ShopListingUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopListingControllerUpdate(id, shopListingUpdateDTO, options) {
            return localVarFp
                .shopListingControllerUpdate(id, shopListingUpdateDTO, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * ShopListingApi - object-oriented interface
 * @export
 * @class ShopListingApi
 * @extends {BaseAPI}
 */
export class ShopListingApi extends BaseAPI {
    /**
     *    Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopListingControllerCreate`
     * @summary Create
     * @param {ShopListingCreateDTO} [shopListingCreateDTO] ShopListingCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopListingApi
     */
    shopListingControllerCreate(shopListingCreateDTO, options) {
        return ShopListingApiFp(this.configuration)
            .shopListingControllerCreate(shopListingCreateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopListingControllerDelete`
     * @summary Delete
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopListingApi
     */
    shopListingControllerDelete(id, options) {
        return ShopListingApiFp(this.configuration)
            .shopListingControllerDelete(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * <br> OperationId: `ShopListingControllerGetOne`
     * @summary Get one
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopListingApi
     */
    shopListingControllerGetOne(id, options) {
        return ShopListingApiFp(this.configuration)
            .shopListingControllerGetOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopListingControllerImportListings`
     * @summary Import listings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopListingApi
     */
    shopListingControllerImportListings(options) {
        return ShopListingApiFp(this.configuration)
            .shopListingControllerImportListings(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search shop listings<br> OperationId: `ShopListingControllerSearch`
     * @summary Search
     * @param {ShopListingSearchInputDTO} [shopListingSearchInputDTO] ShopListingSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopListingApi
     */
    shopListingControllerSearch(shopListingSearchInputDTO, options) {
        return ShopListingApiFp(this.configuration)
            .shopListingControllerSearch(shopListingSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_SHOP_LISTINGS`<br> OperationId: `ShopListingControllerUpdate`
     * @summary Update
     * @param {string} id
     * @param {ShopListingUpdateDTO} [shopListingUpdateDTO] ShopListingUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopListingApi
     */
    shopListingControllerUpdate(id, shopListingUpdateDTO, options) {
        return ShopListingApiFp(this.configuration)
            .shopListingControllerUpdate(id, shopListingUpdateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ShopOrderApi - axios parameter creator
 * @export
 */
export const ShopOrderApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * <br> OperationId: `ShopOrderControllerCancel`
         * @summary Cancel
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopOrderControllerCancel: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('shopOrderControllerCancel', 'id', id);
            const localVarPath = `/shop/order/{id}/cancel`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Claiming an order will mark it as completed and give the user the item in-game<br> OperationId: `ShopOrderControllerClaim`
         * @summary Claim an order
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopOrderControllerClaim: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('shopOrderControllerClaim', 'id', id);
            const localVarPath = `/shop/order/{id}/claim`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <br> OperationId: `ShopOrderControllerCreate`
         * @summary Create
         * @param {ShopOrderCreateDTO} [shopOrderCreateDTO] ShopOrderCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopOrderControllerCreate: async (shopOrderCreateDTO, options = {}) => {
            const localVarPath = `/shop/order/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(shopOrderCreateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an order by its ID. This endpoint only returns orders that belong to the caller. When the caller has permission to view all orders, they can get any order.<br> OperationId: `ShopOrderControllerGetOne`
         * @summary Get order by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopOrderControllerGetOne: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('shopOrderControllerGetOne', 'id', id);
            const localVarPath = `/shop/order/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for orders. By default, this endpoint only returns your own orders. When the caller has permission to view all orders, they can search for all orders.<br> OperationId: `ShopOrderControllerSearch`
         * @summary Search orders
         * @param {ShopOrderSearchInputDTO} [shopOrderSearchInputDTO] ShopOrderSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopOrderControllerSearch: async (shopOrderSearchInputDTO, options = {}) => {
            const localVarPath = `/shop/order/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(shopOrderSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ShopOrderApi - functional programming interface
 * @export
 */
export const ShopOrderApiFp = function (configuration) {
    const localVarAxiosParamCreator = ShopOrderApiAxiosParamCreator(configuration);
    return {
        /**
         * <br> OperationId: `ShopOrderControllerCancel`
         * @summary Cancel
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopOrderControllerCancel(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopOrderControllerCancel(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopOrderApi.shopOrderControllerCancel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Claiming an order will mark it as completed and give the user the item in-game<br> OperationId: `ShopOrderControllerClaim`
         * @summary Claim an order
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopOrderControllerClaim(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopOrderControllerClaim(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopOrderApi.shopOrderControllerClaim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <br> OperationId: `ShopOrderControllerCreate`
         * @summary Create
         * @param {ShopOrderCreateDTO} [shopOrderCreateDTO] ShopOrderCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopOrderControllerCreate(shopOrderCreateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopOrderControllerCreate(shopOrderCreateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopOrderApi.shopOrderControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get an order by its ID. This endpoint only returns orders that belong to the caller. When the caller has permission to view all orders, they can get any order.<br> OperationId: `ShopOrderControllerGetOne`
         * @summary Get order by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopOrderControllerGetOne(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopOrderControllerGetOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopOrderApi.shopOrderControllerGetOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for orders. By default, this endpoint only returns your own orders. When the caller has permission to view all orders, they can search for all orders.<br> OperationId: `ShopOrderControllerSearch`
         * @summary Search orders
         * @param {ShopOrderSearchInputDTO} [shopOrderSearchInputDTO] ShopOrderSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopOrderControllerSearch(shopOrderSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopOrderControllerSearch(shopOrderSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopOrderApi.shopOrderControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ShopOrderApi - factory interface
 * @export
 */
export const ShopOrderApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ShopOrderApiFp(configuration);
    return {
        /**
         * <br> OperationId: `ShopOrderControllerCancel`
         * @summary Cancel
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopOrderControllerCancel(id, options) {
            return localVarFp.shopOrderControllerCancel(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Claiming an order will mark it as completed and give the user the item in-game<br> OperationId: `ShopOrderControllerClaim`
         * @summary Claim an order
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopOrderControllerClaim(id, options) {
            return localVarFp.shopOrderControllerClaim(id, options).then((request) => request(axios, basePath));
        },
        /**
         * <br> OperationId: `ShopOrderControllerCreate`
         * @summary Create
         * @param {ShopOrderCreateDTO} [shopOrderCreateDTO] ShopOrderCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopOrderControllerCreate(shopOrderCreateDTO, options) {
            return localVarFp
                .shopOrderControllerCreate(shopOrderCreateDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get an order by its ID. This endpoint only returns orders that belong to the caller. When the caller has permission to view all orders, they can get any order.<br> OperationId: `ShopOrderControllerGetOne`
         * @summary Get order by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopOrderControllerGetOne(id, options) {
            return localVarFp.shopOrderControllerGetOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for orders. By default, this endpoint only returns your own orders. When the caller has permission to view all orders, they can search for all orders.<br> OperationId: `ShopOrderControllerSearch`
         * @summary Search orders
         * @param {ShopOrderSearchInputDTO} [shopOrderSearchInputDTO] ShopOrderSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopOrderControllerSearch(shopOrderSearchInputDTO, options) {
            return localVarFp
                .shopOrderControllerSearch(shopOrderSearchInputDTO, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * ShopOrderApi - object-oriented interface
 * @export
 * @class ShopOrderApi
 * @extends {BaseAPI}
 */
export class ShopOrderApi extends BaseAPI {
    /**
     * <br> OperationId: `ShopOrderControllerCancel`
     * @summary Cancel
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    shopOrderControllerCancel(id, options) {
        return ShopOrderApiFp(this.configuration)
            .shopOrderControllerCancel(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Claiming an order will mark it as completed and give the user the item in-game<br> OperationId: `ShopOrderControllerClaim`
     * @summary Claim an order
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    shopOrderControllerClaim(id, options) {
        return ShopOrderApiFp(this.configuration)
            .shopOrderControllerClaim(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * <br> OperationId: `ShopOrderControllerCreate`
     * @summary Create
     * @param {ShopOrderCreateDTO} [shopOrderCreateDTO] ShopOrderCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    shopOrderControllerCreate(shopOrderCreateDTO, options) {
        return ShopOrderApiFp(this.configuration)
            .shopOrderControllerCreate(shopOrderCreateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get an order by its ID. This endpoint only returns orders that belong to the caller. When the caller has permission to view all orders, they can get any order.<br> OperationId: `ShopOrderControllerGetOne`
     * @summary Get order by ID
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    shopOrderControllerGetOne(id, options) {
        return ShopOrderApiFp(this.configuration)
            .shopOrderControllerGetOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search for orders. By default, this endpoint only returns your own orders. When the caller has permission to view all orders, they can search for all orders.<br> OperationId: `ShopOrderControllerSearch`
     * @summary Search orders
     * @param {ShopOrderSearchInputDTO} [shopOrderSearchInputDTO] ShopOrderSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    shopOrderControllerSearch(shopOrderSearchInputDTO, options) {
        return ShopOrderApiFp(this.configuration)
            .shopOrderControllerSearch(shopOrderSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * StatsApi - axios parameter creator
 * @export
 */
export const StatsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetActivityStats`
         * @summary Get activity stats
         * @param {StatsControllerGetActivityStatsTimeTypeEnum} timeType
         * @param {StatsControllerGetActivityStatsDataTypeEnum} dataType
         * @param {string} [gameServerId]
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statsControllerGetActivityStats: async (timeType, dataType, gameServerId, startDate, endDate, options = {}) => {
            // verify required parameter 'timeType' is not null or undefined
            assertParamExists('statsControllerGetActivityStats', 'timeType', timeType);
            // verify required parameter 'dataType' is not null or undefined
            assertParamExists('statsControllerGetActivityStats', 'dataType', dataType);
            const localVarPath = `/stats/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            if (gameServerId !== undefined) {
                localVarQueryParameter['gameServerId'] = gameServerId;
            }
            if (timeType !== undefined) {
                localVarQueryParameter['timeType'] = timeType;
            }
            if (dataType !== undefined) {
                localVarQueryParameter['dataType'] = dataType;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Calculates how many players are from each country. Returns a count per country (ISO3166).   Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetCountryStats`
         * @summary Get statistics about the countries of the players
         * @param {Array<string>} [gameServerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statsControllerGetCountryStats: async (gameServerId, options = {}) => {
            const localVarPath = `/stats/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            if (gameServerId) {
                localVarQueryParameter['gameServerId'] = gameServerId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetCurrencyStats`
         * @summary Get currency stats
         * @param {string} gameServerId
         * @param {string} [playerId]
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statsControllerGetCurrencyStats: async (gameServerId, playerId, startDate, endDate, options = {}) => {
            // verify required parameter 'gameServerId' is not null or undefined
            assertParamExists('statsControllerGetCurrencyStats', 'gameServerId', gameServerId);
            const localVarPath = `/stats/currency`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            if (gameServerId !== undefined) {
                localVarQueryParameter['gameServerId'] = gameServerId;
            }
            if (playerId !== undefined) {
                localVarQueryParameter['playerId'] = playerId;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Calculates how many times an event type has occured over `bucketStep` time. Supports different filters and can return multiple series at a time.   Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetEventsCount`
         * @summary Get event count over time
         * @param {StatsControllerGetEventsCountEventNameEnum} eventName
         * @param {StatsControllerGetEventsCountBucketStepEnum} bucketStep
         * @param {Array<StatsControllerGetEventsCountSumByEnum>} [sumBy]
         * @param {string} [gameServerId]
         * @param {string} [moduleId]
         * @param {string} [playerId]
         * @param {string} [userId]
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statsControllerGetEventsCount: async (eventName, bucketStep, sumBy, gameServerId, moduleId, playerId, userId, startDate, endDate, options = {}) => {
            // verify required parameter 'eventName' is not null or undefined
            assertParamExists('statsControllerGetEventsCount', 'eventName', eventName);
            // verify required parameter 'bucketStep' is not null or undefined
            assertParamExists('statsControllerGetEventsCount', 'bucketStep', bucketStep);
            const localVarPath = `/stats/events-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            if (eventName !== undefined) {
                localVarQueryParameter['eventName'] = eventName;
            }
            if (sumBy) {
                localVarQueryParameter['sumBy'] = sumBy;
            }
            if (gameServerId !== undefined) {
                localVarQueryParameter['gameServerId'] = gameServerId;
            }
            if (moduleId !== undefined) {
                localVarQueryParameter['moduleId'] = moduleId;
            }
            if (playerId !== undefined) {
                localVarQueryParameter['playerId'] = playerId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (bucketStep !== undefined) {
                localVarQueryParameter['bucketStep'] = bucketStep;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The roundtrip time for reachability tests between Takaro and the game server<br> OperationId: `StatsControllerGetLatencyStats`
         * @summary Get latency stats
         * @param {string} gameServerId
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statsControllerGetLatencyStats: async (gameServerId, startDate, endDate, options = {}) => {
            // verify required parameter 'gameServerId' is not null or undefined
            assertParamExists('statsControllerGetLatencyStats', 'gameServerId', gameServerId);
            const localVarPath = `/stats/latency`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            if (gameServerId !== undefined) {
                localVarQueryParameter['gameServerId'] = gameServerId;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetPingStats`
         * @summary Get ping stats
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statsControllerGetPingStats: async (gameServerId, playerId, startDate, endDate, options = {}) => {
            // verify required parameter 'gameServerId' is not null or undefined
            assertParamExists('statsControllerGetPingStats', 'gameServerId', gameServerId);
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('statsControllerGetPingStats', 'playerId', playerId);
            const localVarPath = `/stats/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            if (gameServerId !== undefined) {
                localVarQueryParameter['gameServerId'] = gameServerId;
            }
            if (playerId !== undefined) {
                localVarQueryParameter['playerId'] = playerId;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetPlayerOnlineStats`
         * @summary Get player online stats
         * @param {string} [gameServerId]
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statsControllerGetPlayerOnlineStats: async (gameServerId, startDate, endDate, options = {}) => {
            const localVarPath = `/stats/players-online`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            if (gameServerId !== undefined) {
                localVarQueryParameter['gameServerId'] = gameServerId;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * StatsApi - functional programming interface
 * @export
 */
export const StatsApiFp = function (configuration) {
    const localVarAxiosParamCreator = StatsApiAxiosParamCreator(configuration);
    return {
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetActivityStats`
         * @summary Get activity stats
         * @param {StatsControllerGetActivityStatsTimeTypeEnum} timeType
         * @param {StatsControllerGetActivityStatsDataTypeEnum} dataType
         * @param {string} [gameServerId]
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statsControllerGetActivityStats(timeType, dataType, gameServerId, startDate, endDate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statsControllerGetActivityStats(timeType, dataType, gameServerId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatsApi.statsControllerGetActivityStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Calculates how many players are from each country. Returns a count per country (ISO3166).   Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetCountryStats`
         * @summary Get statistics about the countries of the players
         * @param {Array<string>} [gameServerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statsControllerGetCountryStats(gameServerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statsControllerGetCountryStats(gameServerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatsApi.statsControllerGetCountryStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetCurrencyStats`
         * @summary Get currency stats
         * @param {string} gameServerId
         * @param {string} [playerId]
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statsControllerGetCurrencyStats(gameServerId, playerId, startDate, endDate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statsControllerGetCurrencyStats(gameServerId, playerId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatsApi.statsControllerGetCurrencyStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Calculates how many times an event type has occured over `bucketStep` time. Supports different filters and can return multiple series at a time.   Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetEventsCount`
         * @summary Get event count over time
         * @param {StatsControllerGetEventsCountEventNameEnum} eventName
         * @param {StatsControllerGetEventsCountBucketStepEnum} bucketStep
         * @param {Array<StatsControllerGetEventsCountSumByEnum>} [sumBy]
         * @param {string} [gameServerId]
         * @param {string} [moduleId]
         * @param {string} [playerId]
         * @param {string} [userId]
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statsControllerGetEventsCount(eventName, bucketStep, sumBy, gameServerId, moduleId, playerId, userId, startDate, endDate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statsControllerGetEventsCount(eventName, bucketStep, sumBy, gameServerId, moduleId, playerId, userId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatsApi.statsControllerGetEventsCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The roundtrip time for reachability tests between Takaro and the game server<br> OperationId: `StatsControllerGetLatencyStats`
         * @summary Get latency stats
         * @param {string} gameServerId
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statsControllerGetLatencyStats(gameServerId, startDate, endDate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statsControllerGetLatencyStats(gameServerId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatsApi.statsControllerGetLatencyStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetPingStats`
         * @summary Get ping stats
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statsControllerGetPingStats(gameServerId, playerId, startDate, endDate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statsControllerGetPingStats(gameServerId, playerId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatsApi.statsControllerGetPingStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetPlayerOnlineStats`
         * @summary Get player online stats
         * @param {string} [gameServerId]
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statsControllerGetPlayerOnlineStats(gameServerId, startDate, endDate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statsControllerGetPlayerOnlineStats(gameServerId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatsApi.statsControllerGetPlayerOnlineStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * StatsApi - factory interface
 * @export
 */
export const StatsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = StatsApiFp(configuration);
    return {
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetActivityStats`
         * @summary Get activity stats
         * @param {StatsControllerGetActivityStatsTimeTypeEnum} timeType
         * @param {StatsControllerGetActivityStatsDataTypeEnum} dataType
         * @param {string} [gameServerId]
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statsControllerGetActivityStats(timeType, dataType, gameServerId, startDate, endDate, options) {
            return localVarFp
                .statsControllerGetActivityStats(timeType, dataType, gameServerId, startDate, endDate, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Calculates how many players are from each country. Returns a count per country (ISO3166).   Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetCountryStats`
         * @summary Get statistics about the countries of the players
         * @param {Array<string>} [gameServerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statsControllerGetCountryStats(gameServerId, options) {
            return localVarFp
                .statsControllerGetCountryStats(gameServerId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetCurrencyStats`
         * @summary Get currency stats
         * @param {string} gameServerId
         * @param {string} [playerId]
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statsControllerGetCurrencyStats(gameServerId, playerId, startDate, endDate, options) {
            return localVarFp
                .statsControllerGetCurrencyStats(gameServerId, playerId, startDate, endDate, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Calculates how many times an event type has occured over `bucketStep` time. Supports different filters and can return multiple series at a time.   Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetEventsCount`
         * @summary Get event count over time
         * @param {StatsControllerGetEventsCountEventNameEnum} eventName
         * @param {StatsControllerGetEventsCountBucketStepEnum} bucketStep
         * @param {Array<StatsControllerGetEventsCountSumByEnum>} [sumBy]
         * @param {string} [gameServerId]
         * @param {string} [moduleId]
         * @param {string} [playerId]
         * @param {string} [userId]
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statsControllerGetEventsCount(eventName, bucketStep, sumBy, gameServerId, moduleId, playerId, userId, startDate, endDate, options) {
            return localVarFp
                .statsControllerGetEventsCount(eventName, bucketStep, sumBy, gameServerId, moduleId, playerId, userId, startDate, endDate, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * The roundtrip time for reachability tests between Takaro and the game server<br> OperationId: `StatsControllerGetLatencyStats`
         * @summary Get latency stats
         * @param {string} gameServerId
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statsControllerGetLatencyStats(gameServerId, startDate, endDate, options) {
            return localVarFp
                .statsControllerGetLatencyStats(gameServerId, startDate, endDate, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetPingStats`
         * @summary Get ping stats
         * @param {string} gameServerId
         * @param {string} playerId
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statsControllerGetPingStats(gameServerId, playerId, startDate, endDate, options) {
            return localVarFp
                .statsControllerGetPingStats(gameServerId, playerId, startDate, endDate, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetPlayerOnlineStats`
         * @summary Get player online stats
         * @param {string} [gameServerId]
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statsControllerGetPlayerOnlineStats(gameServerId, startDate, endDate, options) {
            return localVarFp
                .statsControllerGetPlayerOnlineStats(gameServerId, startDate, endDate, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * StatsApi - object-oriented interface
 * @export
 * @class StatsApi
 * @extends {BaseAPI}
 */
export class StatsApi extends BaseAPI {
    /**
     *    Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetActivityStats`
     * @summary Get activity stats
     * @param {StatsControllerGetActivityStatsTimeTypeEnum} timeType
     * @param {StatsControllerGetActivityStatsDataTypeEnum} dataType
     * @param {string} [gameServerId]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    statsControllerGetActivityStats(timeType, dataType, gameServerId, startDate, endDate, options) {
        return StatsApiFp(this.configuration)
            .statsControllerGetActivityStats(timeType, dataType, gameServerId, startDate, endDate, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Calculates how many players are from each country. Returns a count per country (ISO3166).   Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetCountryStats`
     * @summary Get statistics about the countries of the players
     * @param {Array<string>} [gameServerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    statsControllerGetCountryStats(gameServerId, options) {
        return StatsApiFp(this.configuration)
            .statsControllerGetCountryStats(gameServerId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetCurrencyStats`
     * @summary Get currency stats
     * @param {string} gameServerId
     * @param {string} [playerId]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    statsControllerGetCurrencyStats(gameServerId, playerId, startDate, endDate, options) {
        return StatsApiFp(this.configuration)
            .statsControllerGetCurrencyStats(gameServerId, playerId, startDate, endDate, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Calculates how many times an event type has occured over `bucketStep` time. Supports different filters and can return multiple series at a time.   Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetEventsCount`
     * @summary Get event count over time
     * @param {StatsControllerGetEventsCountEventNameEnum} eventName
     * @param {StatsControllerGetEventsCountBucketStepEnum} bucketStep
     * @param {Array<StatsControllerGetEventsCountSumByEnum>} [sumBy]
     * @param {string} [gameServerId]
     * @param {string} [moduleId]
     * @param {string} [playerId]
     * @param {string} [userId]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    statsControllerGetEventsCount(eventName, bucketStep, sumBy, gameServerId, moduleId, playerId, userId, startDate, endDate, options) {
        return StatsApiFp(this.configuration)
            .statsControllerGetEventsCount(eventName, bucketStep, sumBy, gameServerId, moduleId, playerId, userId, startDate, endDate, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * The roundtrip time for reachability tests between Takaro and the game server<br> OperationId: `StatsControllerGetLatencyStats`
     * @summary Get latency stats
     * @param {string} gameServerId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    statsControllerGetLatencyStats(gameServerId, startDate, endDate, options) {
        return StatsApiFp(this.configuration)
            .statsControllerGetLatencyStats(gameServerId, startDate, endDate, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetPingStats`
     * @summary Get ping stats
     * @param {string} gameServerId
     * @param {string} playerId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    statsControllerGetPingStats(gameServerId, playerId, startDate, endDate, options) {
        return StatsApiFp(this.configuration)
            .statsControllerGetPingStats(gameServerId, playerId, startDate, endDate, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_PLAYERS`<br> OperationId: `StatsControllerGetPlayerOnlineStats`
     * @summary Get player online stats
     * @param {string} [gameServerId]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    statsControllerGetPlayerOnlineStats(gameServerId, startDate, endDate, options) {
        return StatsApiFp(this.configuration)
            .statsControllerGetPlayerOnlineStats(gameServerId, startDate, endDate, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const StatsControllerGetActivityStatsTimeTypeEnum = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly',
};
/**
 * @export
 */
export const StatsControllerGetActivityStatsDataTypeEnum = {
    Users: 'users',
    Players: 'players',
};
/**
 * @export
 */
export const StatsControllerGetEventsCountEventNameEnum = {
    RoleAssigned: 'role-assigned',
    RoleRemoved: 'role-removed',
    RoleCreated: 'role-created',
    RoleUpdated: 'role-updated',
    RoleDeleted: 'role-deleted',
    CommandExecuted: 'command-executed',
    CommandExecutionDenied: 'command-execution-denied',
    HookExecuted: 'hook-executed',
    CronjobExecuted: 'cronjob-executed',
    CurrencyAdded: 'currency-added',
    CurrencyDeducted: 'currency-deducted',
    CurrencyResetAll: 'currency-reset-all',
    SettingsSet: 'settings-set',
    PlayerNewIpDetected: 'player-new-ip-detected',
    PlayerNewNameDetected: 'player-new-name-detected',
    ServerStatusChanged: 'server-status-changed',
    ModuleCreated: 'module-created',
    ModuleUpdated: 'module-updated',
    ModuleDeleted: 'module-deleted',
    ModuleInstalled: 'module-installed',
    ModuleUninstalled: 'module-uninstalled',
    PlayerCreated: 'player-created',
    ShopListingCreated: 'shop-listing-created',
    ShopListingUpdated: 'shop-listing-updated',
    ShopListingDeleted: 'shop-listing-deleted',
    ShopOrderCreated: 'shop-order-created',
    ShopOrderStatusChanged: 'shop-order-status-changed',
    ShopOrderDeliveryFailed: 'shop-order-delivery-failed',
    PlayerLinked: 'player-linked',
    GameserverCreated: 'gameserver-created',
    GameserverUpdated: 'gameserver-updated',
    GameserverDeleted: 'gameserver-deleted',
    PlayerBanned: 'player-banned',
    PlayerUnbanned: 'player-unbanned',
    PlayerDeleted: 'player-deleted',
    PlayerConnected: 'player-connected',
    PlayerDisconnected: 'player-disconnected',
    ChatMessage: 'chat-message',
    PlayerDeath: 'player-death',
    EntityKilled: 'entity-killed',
};
/**
 * @export
 */
export const StatsControllerGetEventsCountBucketStepEnum = {
    _5m: '5m',
    _30m: '30m',
    _1h: '1h',
    _6h: '6h',
    _12h: '12h',
    _24h: '24h',
};
/**
 * @export
 */
export const StatsControllerGetEventsCountSumByEnum = {
    Player: 'player',
    Module: 'module',
    User: 'user',
    Gameserver: 'gameserver',
};
/**
 * TrackingApi - axios parameter creator
 * @export
 */
export const TrackingApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Find all players within a 3D rectangular volume at a specific time   Required permissions: `READ_PLAYERS`<br> OperationId: `TrackingControllerGetBoundingBoxPlayers`
         * @summary Get bounding box players
         * @param {BoundingBoxSearchInputDTO} [boundingBoxSearchInputDTO] BoundingBoxSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingControllerGetBoundingBoxPlayers: async (boundingBoxSearchInputDTO, options = {}) => {
            const localVarPath = `/tracking/location/box`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(boundingBoxSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get inventory changes for a player between two timestamps   Required permissions: `READ_PLAYERS`<br> OperationId: `TrackingControllerGetPlayerInventoryHistory`
         * @summary Get player inventory history
         * @param {PlayerInventoryHistoryInputDTO} [playerInventoryHistoryInputDTO] PlayerInventoryHistoryInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingControllerGetPlayerInventoryHistory: async (playerInventoryHistoryInputDTO, options = {}) => {
            const localVarPath = `/tracking/inventory/player`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(playerInventoryHistoryInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get movement history for players within date bounds   Required permissions: `READ_PLAYERS`<br> OperationId: `TrackingControllerGetPlayerMovementHistory`
         * @summary Get player movement history
         * @param {PlayerMovementHistoryInputDTO} [playerMovementHistoryInputDTO] PlayerMovementHistoryInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingControllerGetPlayerMovementHistory: async (playerMovementHistoryInputDTO, options = {}) => {
            const localVarPath = `/tracking/location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(playerMovementHistoryInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find all players who have had a specific item in their inventory   Required permissions: `READ_PLAYERS`<br> OperationId: `TrackingControllerGetPlayersByItem`
         * @summary Get players by item
         * @param {PlayersByItemInputDTO} [playersByItemInputDTO] PlayersByItemInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingControllerGetPlayersByItem: async (playersByItemInputDTO, options = {}) => {
            const localVarPath = `/tracking/inventory/item`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(playersByItemInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find all players within a spherical area from a center point   Required permissions: `READ_PLAYERS`<br> OperationId: `TrackingControllerGetRadiusPlayers`
         * @summary Get radius players
         * @param {RadiusSearchInputDTO} [radiusSearchInputDTO] RadiusSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingControllerGetRadiusPlayers: async (radiusSearchInputDTO, options = {}) => {
            const localVarPath = `/tracking/location/radius`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(radiusSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TrackingApi - functional programming interface
 * @export
 */
export const TrackingApiFp = function (configuration) {
    const localVarAxiosParamCreator = TrackingApiAxiosParamCreator(configuration);
    return {
        /**
         * Find all players within a 3D rectangular volume at a specific time   Required permissions: `READ_PLAYERS`<br> OperationId: `TrackingControllerGetBoundingBoxPlayers`
         * @summary Get bounding box players
         * @param {BoundingBoxSearchInputDTO} [boundingBoxSearchInputDTO] BoundingBoxSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trackingControllerGetBoundingBoxPlayers(boundingBoxSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trackingControllerGetBoundingBoxPlayers(boundingBoxSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackingApi.trackingControllerGetBoundingBoxPlayers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get inventory changes for a player between two timestamps   Required permissions: `READ_PLAYERS`<br> OperationId: `TrackingControllerGetPlayerInventoryHistory`
         * @summary Get player inventory history
         * @param {PlayerInventoryHistoryInputDTO} [playerInventoryHistoryInputDTO] PlayerInventoryHistoryInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trackingControllerGetPlayerInventoryHistory(playerInventoryHistoryInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trackingControllerGetPlayerInventoryHistory(playerInventoryHistoryInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackingApi.trackingControllerGetPlayerInventoryHistory']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get movement history for players within date bounds   Required permissions: `READ_PLAYERS`<br> OperationId: `TrackingControllerGetPlayerMovementHistory`
         * @summary Get player movement history
         * @param {PlayerMovementHistoryInputDTO} [playerMovementHistoryInputDTO] PlayerMovementHistoryInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trackingControllerGetPlayerMovementHistory(playerMovementHistoryInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trackingControllerGetPlayerMovementHistory(playerMovementHistoryInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackingApi.trackingControllerGetPlayerMovementHistory']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find all players who have had a specific item in their inventory   Required permissions: `READ_PLAYERS`<br> OperationId: `TrackingControllerGetPlayersByItem`
         * @summary Get players by item
         * @param {PlayersByItemInputDTO} [playersByItemInputDTO] PlayersByItemInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trackingControllerGetPlayersByItem(playersByItemInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trackingControllerGetPlayersByItem(playersByItemInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackingApi.trackingControllerGetPlayersByItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find all players within a spherical area from a center point   Required permissions: `READ_PLAYERS`<br> OperationId: `TrackingControllerGetRadiusPlayers`
         * @summary Get radius players
         * @param {RadiusSearchInputDTO} [radiusSearchInputDTO] RadiusSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trackingControllerGetRadiusPlayers(radiusSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trackingControllerGetRadiusPlayers(radiusSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackingApi.trackingControllerGetRadiusPlayers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * TrackingApi - factory interface
 * @export
 */
export const TrackingApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TrackingApiFp(configuration);
    return {
        /**
         * Find all players within a 3D rectangular volume at a specific time   Required permissions: `READ_PLAYERS`<br> OperationId: `TrackingControllerGetBoundingBoxPlayers`
         * @summary Get bounding box players
         * @param {BoundingBoxSearchInputDTO} [boundingBoxSearchInputDTO] BoundingBoxSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingControllerGetBoundingBoxPlayers(boundingBoxSearchInputDTO, options) {
            return localVarFp
                .trackingControllerGetBoundingBoxPlayers(boundingBoxSearchInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get inventory changes for a player between two timestamps   Required permissions: `READ_PLAYERS`<br> OperationId: `TrackingControllerGetPlayerInventoryHistory`
         * @summary Get player inventory history
         * @param {PlayerInventoryHistoryInputDTO} [playerInventoryHistoryInputDTO] PlayerInventoryHistoryInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingControllerGetPlayerInventoryHistory(playerInventoryHistoryInputDTO, options) {
            return localVarFp
                .trackingControllerGetPlayerInventoryHistory(playerInventoryHistoryInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get movement history for players within date bounds   Required permissions: `READ_PLAYERS`<br> OperationId: `TrackingControllerGetPlayerMovementHistory`
         * @summary Get player movement history
         * @param {PlayerMovementHistoryInputDTO} [playerMovementHistoryInputDTO] PlayerMovementHistoryInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingControllerGetPlayerMovementHistory(playerMovementHistoryInputDTO, options) {
            return localVarFp
                .trackingControllerGetPlayerMovementHistory(playerMovementHistoryInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Find all players who have had a specific item in their inventory   Required permissions: `READ_PLAYERS`<br> OperationId: `TrackingControllerGetPlayersByItem`
         * @summary Get players by item
         * @param {PlayersByItemInputDTO} [playersByItemInputDTO] PlayersByItemInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingControllerGetPlayersByItem(playersByItemInputDTO, options) {
            return localVarFp
                .trackingControllerGetPlayersByItem(playersByItemInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Find all players within a spherical area from a center point   Required permissions: `READ_PLAYERS`<br> OperationId: `TrackingControllerGetRadiusPlayers`
         * @summary Get radius players
         * @param {RadiusSearchInputDTO} [radiusSearchInputDTO] RadiusSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingControllerGetRadiusPlayers(radiusSearchInputDTO, options) {
            return localVarFp
                .trackingControllerGetRadiusPlayers(radiusSearchInputDTO, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * TrackingApi - object-oriented interface
 * @export
 * @class TrackingApi
 * @extends {BaseAPI}
 */
export class TrackingApi extends BaseAPI {
    /**
     * Find all players within a 3D rectangular volume at a specific time   Required permissions: `READ_PLAYERS`<br> OperationId: `TrackingControllerGetBoundingBoxPlayers`
     * @summary Get bounding box players
     * @param {BoundingBoxSearchInputDTO} [boundingBoxSearchInputDTO] BoundingBoxSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApi
     */
    trackingControllerGetBoundingBoxPlayers(boundingBoxSearchInputDTO, options) {
        return TrackingApiFp(this.configuration)
            .trackingControllerGetBoundingBoxPlayers(boundingBoxSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get inventory changes for a player between two timestamps   Required permissions: `READ_PLAYERS`<br> OperationId: `TrackingControllerGetPlayerInventoryHistory`
     * @summary Get player inventory history
     * @param {PlayerInventoryHistoryInputDTO} [playerInventoryHistoryInputDTO] PlayerInventoryHistoryInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApi
     */
    trackingControllerGetPlayerInventoryHistory(playerInventoryHistoryInputDTO, options) {
        return TrackingApiFp(this.configuration)
            .trackingControllerGetPlayerInventoryHistory(playerInventoryHistoryInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get movement history for players within date bounds   Required permissions: `READ_PLAYERS`<br> OperationId: `TrackingControllerGetPlayerMovementHistory`
     * @summary Get player movement history
     * @param {PlayerMovementHistoryInputDTO} [playerMovementHistoryInputDTO] PlayerMovementHistoryInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApi
     */
    trackingControllerGetPlayerMovementHistory(playerMovementHistoryInputDTO, options) {
        return TrackingApiFp(this.configuration)
            .trackingControllerGetPlayerMovementHistory(playerMovementHistoryInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Find all players who have had a specific item in their inventory   Required permissions: `READ_PLAYERS`<br> OperationId: `TrackingControllerGetPlayersByItem`
     * @summary Get players by item
     * @param {PlayersByItemInputDTO} [playersByItemInputDTO] PlayersByItemInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApi
     */
    trackingControllerGetPlayersByItem(playersByItemInputDTO, options) {
        return TrackingApiFp(this.configuration)
            .trackingControllerGetPlayersByItem(playersByItemInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Find all players within a spherical area from a center point   Required permissions: `READ_PLAYERS`<br> OperationId: `TrackingControllerGetRadiusPlayers`
     * @summary Get radius players
     * @param {RadiusSearchInputDTO} [radiusSearchInputDTO] RadiusSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApi
     */
    trackingControllerGetRadiusPlayers(radiusSearchInputDTO, options) {
        return TrackingApiFp(this.configuration)
            .trackingControllerGetRadiusPlayers(radiusSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *    Required permissions: `MANAGE_USERS`, `MANAGE_ROLES`<br> OperationId: `UserControllerAssignRole`
         * @summary Assign role
         * @param {string} id
         * @param {string} roleId
         * @param {UserRoleAssignChangeDTO} [userRoleAssignChangeDTO] UserRoleAssignChangeDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerAssignRole: async (id, roleId, userRoleAssignChangeDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userControllerAssignRole', 'id', id);
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('userControllerAssignRole', 'roleId', roleId);
            const localVarPath = `/user/{id}/role/{roleId}`
                .replace(`{${'id'}}`, encodeURIComponent(String(id)))
                .replace(`{${'roleId'}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(userRoleAssignChangeDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_USERS`<br> OperationId: `UserControllerCreate`
         * @summary Create
         * @param {UserCreateInputDTO} [userCreateInputDTO] UserCreateInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerCreate: async (userCreateInputDTO, options = {}) => {
            const localVarPath = `/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(userCreateInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unset the selected domain for the user, this will clear the domain cookie. On the next request, the backend will set this again.<br> OperationId: `UserControllerDeleteSelectedDomainCookie`
         * @summary Unset the selected domain for the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerDeleteSelectedDomainCookie: async (options = {}) => {
            const localVarPath = `/selected-domain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_USERS`<br> OperationId: `UserControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetOne: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userControllerGetOne', 'id', id);
            const localVarPath = `/user/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_USERS`<br> OperationId: `UserControllerInvite`
         * @summary Invite
         * @param {InviteCreateDTO} [inviteCreateDTO] InviteCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerInvite: async (inviteCreateDTO, options = {}) => {
            const localVarPath = `/user/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(inviteCreateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Link your player profile to Takaro, allowing web access for things like shop and stats. To get the code, use the /link command in the game.<br> OperationId: `UserControllerLinkPlayerProfile`
         * @summary Link player profile
         * @param {LinkPlayerUnauthedInputDTO} [linkPlayerUnauthedInputDTO] LinkPlayerUnauthedInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerLinkPlayerProfile: async (linkPlayerUnauthedInputDTO, options = {}) => {
            const localVarPath = `/user/player`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(linkPlayerUnauthedInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <br> OperationId: `UserControllerLogin`
         * @summary Login
         * @param {LoginDTO} [loginDTO] LoginDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerLogin: async (loginDTO, options = {}) => {
            const localVarPath = `/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(loginDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <br> OperationId: `UserControllerLogout`
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerLogout: async (options = {}) => {
            const localVarPath = `/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the current user and the domains that the user has access to. Note that you can only make requests in the scope of a single domain. In order to switch the domain, you need to use the domain selection endpoints<br> OperationId: `UserControllerMe`
         * @summary Get the current logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerMe: async (options = {}) => {
            const localVarPath = `/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_USERS`<br> OperationId: `UserControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerRemove: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userControllerRemove', 'id', id);
            const localVarPath = `/user/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_USERS`, `MANAGE_ROLES`<br> OperationId: `UserControllerRemoveRole`
         * @summary Remove role
         * @param {string} id
         * @param {string} roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerRemoveRole: async (id, roleId, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userControllerRemoveRole', 'id', id);
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('userControllerRemoveRole', 'roleId', roleId);
            const localVarPath = `/user/{id}/role/{roleId}`
                .replace(`{${'id'}}`, encodeURIComponent(String(id)))
                .replace(`{${'roleId'}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_USERS`<br> OperationId: `UserControllerSearch`
         * @summary Search
         * @param {UserSearchInputDTO} [userSearchInputDTO] UserSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerSearch: async (userSearchInputDTO, options = {}) => {
            const localVarPath = `/user/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(userSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * One user can have multiple domains, this endpoint is a helper to set the selected domain for the user<br> OperationId: `UserControllerSetSelectedDomain`
         * @summary Set the selected domain for the user
         * @param {string} domainId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerSetSelectedDomain: async (domainId, options = {}) => {
            // verify required parameter 'domainId' is not null or undefined
            assertParamExists('userControllerSetSelectedDomain', 'domainId', domainId);
            const localVarPath = `/selected-domain/{domainId}`.replace(`{${'domainId'}}`, encodeURIComponent(String(domainId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_USERS`<br> OperationId: `UserControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {UserUpdateDTO} [userUpdateDTO] UserUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUpdate: async (id, userUpdateDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userControllerUpdate', 'id', id);
            const localVarPath = `/user/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(userUpdateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration);
    return {
        /**
         *    Required permissions: `MANAGE_USERS`, `MANAGE_ROLES`<br> OperationId: `UserControllerAssignRole`
         * @summary Assign role
         * @param {string} id
         * @param {string} roleId
         * @param {UserRoleAssignChangeDTO} [userRoleAssignChangeDTO] UserRoleAssignChangeDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerAssignRole(id, roleId, userRoleAssignChangeDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerAssignRole(id, roleId, userRoleAssignChangeDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userControllerAssignRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_USERS`<br> OperationId: `UserControllerCreate`
         * @summary Create
         * @param {UserCreateInputDTO} [userCreateInputDTO] UserCreateInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerCreate(userCreateInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerCreate(userCreateInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unset the selected domain for the user, this will clear the domain cookie. On the next request, the backend will set this again.<br> OperationId: `UserControllerDeleteSelectedDomainCookie`
         * @summary Unset the selected domain for the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerDeleteSelectedDomainCookie(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerDeleteSelectedDomainCookie(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userControllerDeleteSelectedDomainCookie']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_USERS`<br> OperationId: `UserControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetOne(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userControllerGetOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_USERS`<br> OperationId: `UserControllerInvite`
         * @summary Invite
         * @param {InviteCreateDTO} [inviteCreateDTO] InviteCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerInvite(inviteCreateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerInvite(inviteCreateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userControllerInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Link your player profile to Takaro, allowing web access for things like shop and stats. To get the code, use the /link command in the game.<br> OperationId: `UserControllerLinkPlayerProfile`
         * @summary Link player profile
         * @param {LinkPlayerUnauthedInputDTO} [linkPlayerUnauthedInputDTO] LinkPlayerUnauthedInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerLinkPlayerProfile(linkPlayerUnauthedInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerLinkPlayerProfile(linkPlayerUnauthedInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userControllerLinkPlayerProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <br> OperationId: `UserControllerLogin`
         * @summary Login
         * @param {LoginDTO} [loginDTO] LoginDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerLogin(loginDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerLogin(loginDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userControllerLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <br> OperationId: `UserControllerLogout`
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerLogout(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerLogout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userControllerLogout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the current user and the domains that the user has access to. Note that you can only make requests in the scope of a single domain. In order to switch the domain, you need to use the domain selection endpoints<br> OperationId: `UserControllerMe`
         * @summary Get the current logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerMe(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerMe(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userControllerMe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_USERS`<br> OperationId: `UserControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerRemove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerRemove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userControllerRemove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_USERS`, `MANAGE_ROLES`<br> OperationId: `UserControllerRemoveRole`
         * @summary Remove role
         * @param {string} id
         * @param {string} roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerRemoveRole(id, roleId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerRemoveRole(id, roleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userControllerRemoveRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_USERS`<br> OperationId: `UserControllerSearch`
         * @summary Search
         * @param {UserSearchInputDTO} [userSearchInputDTO] UserSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerSearch(userSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerSearch(userSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * One user can have multiple domains, this endpoint is a helper to set the selected domain for the user<br> OperationId: `UserControllerSetSelectedDomain`
         * @summary Set the selected domain for the user
         * @param {string} domainId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerSetSelectedDomain(domainId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerSetSelectedDomain(domainId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userControllerSetSelectedDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_USERS`<br> OperationId: `UserControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {UserUpdateDTO} [userUpdateDTO] UserUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerUpdate(id, userUpdateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerUpdate(id, userUpdateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserApiFp(configuration);
    return {
        /**
         *    Required permissions: `MANAGE_USERS`, `MANAGE_ROLES`<br> OperationId: `UserControllerAssignRole`
         * @summary Assign role
         * @param {string} id
         * @param {string} roleId
         * @param {UserRoleAssignChangeDTO} [userRoleAssignChangeDTO] UserRoleAssignChangeDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerAssignRole(id, roleId, userRoleAssignChangeDTO, options) {
            return localVarFp
                .userControllerAssignRole(id, roleId, userRoleAssignChangeDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_USERS`<br> OperationId: `UserControllerCreate`
         * @summary Create
         * @param {UserCreateInputDTO} [userCreateInputDTO] UserCreateInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerCreate(userCreateInputDTO, options) {
            return localVarFp.userControllerCreate(userCreateInputDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Unset the selected domain for the user, this will clear the domain cookie. On the next request, the backend will set this again.<br> OperationId: `UserControllerDeleteSelectedDomainCookie`
         * @summary Unset the selected domain for the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerDeleteSelectedDomainCookie(options) {
            return localVarFp.userControllerDeleteSelectedDomainCookie(options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_USERS`<br> OperationId: `UserControllerGetOne`
         * @summary Get one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetOne(id, options) {
            return localVarFp.userControllerGetOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_USERS`<br> OperationId: `UserControllerInvite`
         * @summary Invite
         * @param {InviteCreateDTO} [inviteCreateDTO] InviteCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerInvite(inviteCreateDTO, options) {
            return localVarFp.userControllerInvite(inviteCreateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Link your player profile to Takaro, allowing web access for things like shop and stats. To get the code, use the /link command in the game.<br> OperationId: `UserControllerLinkPlayerProfile`
         * @summary Link player profile
         * @param {LinkPlayerUnauthedInputDTO} [linkPlayerUnauthedInputDTO] LinkPlayerUnauthedInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerLinkPlayerProfile(linkPlayerUnauthedInputDTO, options) {
            return localVarFp
                .userControllerLinkPlayerProfile(linkPlayerUnauthedInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * <br> OperationId: `UserControllerLogin`
         * @summary Login
         * @param {LoginDTO} [loginDTO] LoginDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerLogin(loginDTO, options) {
            return localVarFp.userControllerLogin(loginDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * <br> OperationId: `UserControllerLogout`
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerLogout(options) {
            return localVarFp.userControllerLogout(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the current user and the domains that the user has access to. Note that you can only make requests in the scope of a single domain. In order to switch the domain, you need to use the domain selection endpoints<br> OperationId: `UserControllerMe`
         * @summary Get the current logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerMe(options) {
            return localVarFp.userControllerMe(options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_USERS`<br> OperationId: `UserControllerRemove`
         * @summary Remove
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerRemove(id, options) {
            return localVarFp.userControllerRemove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_USERS`, `MANAGE_ROLES`<br> OperationId: `UserControllerRemoveRole`
         * @summary Remove role
         * @param {string} id
         * @param {string} roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerRemoveRole(id, roleId, options) {
            return localVarFp.userControllerRemoveRole(id, roleId, options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_USERS`<br> OperationId: `UserControllerSearch`
         * @summary Search
         * @param {UserSearchInputDTO} [userSearchInputDTO] UserSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerSearch(userSearchInputDTO, options) {
            return localVarFp.userControllerSearch(userSearchInputDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * One user can have multiple domains, this endpoint is a helper to set the selected domain for the user<br> OperationId: `UserControllerSetSelectedDomain`
         * @summary Set the selected domain for the user
         * @param {string} domainId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerSetSelectedDomain(domainId, options) {
            return localVarFp.userControllerSetSelectedDomain(domainId, options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_USERS`<br> OperationId: `UserControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {UserUpdateDTO} [userUpdateDTO] UserUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUpdate(id, userUpdateDTO, options) {
            return localVarFp.userControllerUpdate(id, userUpdateDTO, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     *    Required permissions: `MANAGE_USERS`, `MANAGE_ROLES`<br> OperationId: `UserControllerAssignRole`
     * @summary Assign role
     * @param {string} id
     * @param {string} roleId
     * @param {UserRoleAssignChangeDTO} [userRoleAssignChangeDTO] UserRoleAssignChangeDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userControllerAssignRole(id, roleId, userRoleAssignChangeDTO, options) {
        return UserApiFp(this.configuration)
            .userControllerAssignRole(id, roleId, userRoleAssignChangeDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_USERS`<br> OperationId: `UserControllerCreate`
     * @summary Create
     * @param {UserCreateInputDTO} [userCreateInputDTO] UserCreateInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userControllerCreate(userCreateInputDTO, options) {
        return UserApiFp(this.configuration)
            .userControllerCreate(userCreateInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Unset the selected domain for the user, this will clear the domain cookie. On the next request, the backend will set this again.<br> OperationId: `UserControllerDeleteSelectedDomainCookie`
     * @summary Unset the selected domain for the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userControllerDeleteSelectedDomainCookie(options) {
        return UserApiFp(this.configuration)
            .userControllerDeleteSelectedDomainCookie(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_USERS`<br> OperationId: `UserControllerGetOne`
     * @summary Get one
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userControllerGetOne(id, options) {
        return UserApiFp(this.configuration)
            .userControllerGetOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_USERS`<br> OperationId: `UserControllerInvite`
     * @summary Invite
     * @param {InviteCreateDTO} [inviteCreateDTO] InviteCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userControllerInvite(inviteCreateDTO, options) {
        return UserApiFp(this.configuration)
            .userControllerInvite(inviteCreateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Link your player profile to Takaro, allowing web access for things like shop and stats. To get the code, use the /link command in the game.<br> OperationId: `UserControllerLinkPlayerProfile`
     * @summary Link player profile
     * @param {LinkPlayerUnauthedInputDTO} [linkPlayerUnauthedInputDTO] LinkPlayerUnauthedInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userControllerLinkPlayerProfile(linkPlayerUnauthedInputDTO, options) {
        return UserApiFp(this.configuration)
            .userControllerLinkPlayerProfile(linkPlayerUnauthedInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * <br> OperationId: `UserControllerLogin`
     * @summary Login
     * @param {LoginDTO} [loginDTO] LoginDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userControllerLogin(loginDTO, options) {
        return UserApiFp(this.configuration)
            .userControllerLogin(loginDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * <br> OperationId: `UserControllerLogout`
     * @summary Logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userControllerLogout(options) {
        return UserApiFp(this.configuration)
            .userControllerLogout(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the current user and the domains that the user has access to. Note that you can only make requests in the scope of a single domain. In order to switch the domain, you need to use the domain selection endpoints<br> OperationId: `UserControllerMe`
     * @summary Get the current logged in user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userControllerMe(options) {
        return UserApiFp(this.configuration)
            .userControllerMe(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_USERS`<br> OperationId: `UserControllerRemove`
     * @summary Remove
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userControllerRemove(id, options) {
        return UserApiFp(this.configuration)
            .userControllerRemove(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_USERS`, `MANAGE_ROLES`<br> OperationId: `UserControllerRemoveRole`
     * @summary Remove role
     * @param {string} id
     * @param {string} roleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userControllerRemoveRole(id, roleId, options) {
        return UserApiFp(this.configuration)
            .userControllerRemoveRole(id, roleId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_USERS`<br> OperationId: `UserControllerSearch`
     * @summary Search
     * @param {UserSearchInputDTO} [userSearchInputDTO] UserSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userControllerSearch(userSearchInputDTO, options) {
        return UserApiFp(this.configuration)
            .userControllerSearch(userSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * One user can have multiple domains, this endpoint is a helper to set the selected domain for the user<br> OperationId: `UserControllerSetSelectedDomain`
     * @summary Set the selected domain for the user
     * @param {string} domainId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userControllerSetSelectedDomain(domainId, options) {
        return UserApiFp(this.configuration)
            .userControllerSetSelectedDomain(domainId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_USERS`<br> OperationId: `UserControllerUpdate`
     * @summary Update
     * @param {string} id
     * @param {UserUpdateDTO} [userUpdateDTO] UserUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userControllerUpdate(id, userUpdateDTO, options) {
        return UserApiFp(this.configuration)
            .userControllerUpdate(id, userUpdateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * VariableApi - axios parameter creator
 * @export
 */
export const VariableApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *    Required permissions: `MANAGE_VARIABLES`<br> OperationId: `VariableControllerCreate`
         * @summary Create
         * @param {VariableCreateDTO} [variableCreateDTO] VariableCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variableControllerCreate: async (variableCreateDTO, options = {}) => {
            const localVarPath = `/variables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(variableCreateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_VARIABLES`<br> OperationId: `VariableControllerDelete`
         * @summary Delete
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variableControllerDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('variableControllerDelete', 'id', id);
            const localVarPath = `/variables/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `READ_VARIABLES`<br> OperationId: `VariableControllerFindOne`
         * @summary Find one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variableControllerFindOne: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('variableControllerFindOne', 'id', id);
            const localVarPath = `/variables/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search variables   Required permissions: `READ_VARIABLES`<br> OperationId: `VariableControllerSearch`
         * @summary Search
         * @param {VariableSearchInputDTO} [variableSearchInputDTO] VariableSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variableControllerSearch: async (variableSearchInputDTO, options = {}) => {
            const localVarPath = `/variables/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(variableSearchInputDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *    Required permissions: `MANAGE_VARIABLES`<br> OperationId: `VariableControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {VariableUpdateDTO} [variableUpdateDTO] VariableUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variableControllerUpdate: async (id, variableUpdateDTO, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('variableControllerUpdate', 'id', id);
            const localVarPath = `/variables/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication domainAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(variableUpdateDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * VariableApi - functional programming interface
 * @export
 */
export const VariableApiFp = function (configuration) {
    const localVarAxiosParamCreator = VariableApiAxiosParamCreator(configuration);
    return {
        /**
         *    Required permissions: `MANAGE_VARIABLES`<br> OperationId: `VariableControllerCreate`
         * @summary Create
         * @param {VariableCreateDTO} [variableCreateDTO] VariableCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async variableControllerCreate(variableCreateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.variableControllerCreate(variableCreateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VariableApi.variableControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_VARIABLES`<br> OperationId: `VariableControllerDelete`
         * @summary Delete
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async variableControllerDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.variableControllerDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VariableApi.variableControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `READ_VARIABLES`<br> OperationId: `VariableControllerFindOne`
         * @summary Find one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async variableControllerFindOne(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.variableControllerFindOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VariableApi.variableControllerFindOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search variables   Required permissions: `READ_VARIABLES`<br> OperationId: `VariableControllerSearch`
         * @summary Search
         * @param {VariableSearchInputDTO} [variableSearchInputDTO] VariableSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async variableControllerSearch(variableSearchInputDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.variableControllerSearch(variableSearchInputDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VariableApi.variableControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *    Required permissions: `MANAGE_VARIABLES`<br> OperationId: `VariableControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {VariableUpdateDTO} [variableUpdateDTO] VariableUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async variableControllerUpdate(id, variableUpdateDTO, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.variableControllerUpdate(id, variableUpdateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VariableApi.variableControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * VariableApi - factory interface
 * @export
 */
export const VariableApiFactory = function (configuration, basePath, axios) {
    const localVarFp = VariableApiFp(configuration);
    return {
        /**
         *    Required permissions: `MANAGE_VARIABLES`<br> OperationId: `VariableControllerCreate`
         * @summary Create
         * @param {VariableCreateDTO} [variableCreateDTO] VariableCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variableControllerCreate(variableCreateDTO, options) {
            return localVarFp
                .variableControllerCreate(variableCreateDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_VARIABLES`<br> OperationId: `VariableControllerDelete`
         * @summary Delete
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variableControllerDelete(id, options) {
            return localVarFp.variableControllerDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `READ_VARIABLES`<br> OperationId: `VariableControllerFindOne`
         * @summary Find one
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variableControllerFindOne(id, options) {
            return localVarFp.variableControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Search variables   Required permissions: `READ_VARIABLES`<br> OperationId: `VariableControllerSearch`
         * @summary Search
         * @param {VariableSearchInputDTO} [variableSearchInputDTO] VariableSearchInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variableControllerSearch(variableSearchInputDTO, options) {
            return localVarFp
                .variableControllerSearch(variableSearchInputDTO, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *    Required permissions: `MANAGE_VARIABLES`<br> OperationId: `VariableControllerUpdate`
         * @summary Update
         * @param {string} id
         * @param {VariableUpdateDTO} [variableUpdateDTO] VariableUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variableControllerUpdate(id, variableUpdateDTO, options) {
            return localVarFp
                .variableControllerUpdate(id, variableUpdateDTO, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * VariableApi - object-oriented interface
 * @export
 * @class VariableApi
 * @extends {BaseAPI}
 */
export class VariableApi extends BaseAPI {
    /**
     *    Required permissions: `MANAGE_VARIABLES`<br> OperationId: `VariableControllerCreate`
     * @summary Create
     * @param {VariableCreateDTO} [variableCreateDTO] VariableCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariableApi
     */
    variableControllerCreate(variableCreateDTO, options) {
        return VariableApiFp(this.configuration)
            .variableControllerCreate(variableCreateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_VARIABLES`<br> OperationId: `VariableControllerDelete`
     * @summary Delete
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariableApi
     */
    variableControllerDelete(id, options) {
        return VariableApiFp(this.configuration)
            .variableControllerDelete(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `READ_VARIABLES`<br> OperationId: `VariableControllerFindOne`
     * @summary Find one
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariableApi
     */
    variableControllerFindOne(id, options) {
        return VariableApiFp(this.configuration)
            .variableControllerFindOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search variables   Required permissions: `READ_VARIABLES`<br> OperationId: `VariableControllerSearch`
     * @summary Search
     * @param {VariableSearchInputDTO} [variableSearchInputDTO] VariableSearchInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariableApi
     */
    variableControllerSearch(variableSearchInputDTO, options) {
        return VariableApiFp(this.configuration)
            .variableControllerSearch(variableSearchInputDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *    Required permissions: `MANAGE_VARIABLES`<br> OperationId: `VariableControllerUpdate`
     * @summary Update
     * @param {string} id
     * @param {VariableUpdateDTO} [variableUpdateDTO] VariableUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariableApi
     */
    variableControllerUpdate(id, variableUpdateDTO, options) {
        return VariableApiFp(this.configuration)
            .variableControllerUpdate(id, variableUpdateDTO, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map